import type { Dict } from '../types';

export const th: Dict = {
  'chat.amrCard.switchTitle': 'เรียกใช้โมเดลล้มเหลว — งานนี้ถูกหยุดชั่วคราว',
  'chat.amrCard.switchBody': 'สลับไปยังบริการโมเดล AMR อย่างเป็นทางการของ Gini Studio — ไม่ต้องตั้งค่า API Key หลังจากเข้าสู่ระบบ ให้สิทธิ์ และเติมเงินแล้ว งานนี้จะถูกลองใหม่โดยอัตโนมัติ',
  'chat.amrCard.chipOfficial': 'โฮสติ้งอย่างเป็นทางการ',
  'chat.amrCard.chipNoKey': 'ไม่ต้องใช้ API Key',
  'chat.amrCard.chipAutoRetry': 'ลองใหม่อัตโนมัติหลังเข้าสู่ระบบ',
  'chat.amrCard.switchCta': 'สลับไปยัง AMR และลองใหม่',
  'chat.amrError.authMessage': 'บัญชี AMR ของคุณยังไม่ได้รับอนุญาต ให้สิทธิ์แล้วงานนี้จะถูกลองใหม่โดยอัตโนมัติ',
  'chat.amrError.balanceMessage': 'ยอดเงิน AMR ของคุณหมดแล้ว เติมเงินเพื่อดำเนินงานนี้ต่อ',
  'chat.amrError.authorizeCta': 'ให้สิทธิ์และลองใหม่',
  'chat.amrError.rechargeCta': 'เติมเงิน AMR',
  'chat.antigravityError.launchTerminalCta': 'ลงชื่อเข้าใช้ผ่านเทอร์มินัล',
  'chat.antigravityError.launchSwitchModelCta': 'สลับโมเดลในเทอร์มินัล',
  'common.cancel': 'ยกเลิก',
  'common.save': 'บันทึก',
  'common.close': 'ปิด',
  'common.clear': 'ล้าง',
  'common.delete': 'ลบ',
  'common.rename': 'เปลี่ยนชื่อ',
  'common.edit': 'แก้ไข',
  'common.preview': 'ดูตัวอย่าง',
  'common.share': 'แชร์',
  'common.search': 'ค้นหา',
  'common.searchEllipsis': 'ค้นหา…',
  'common.loading': 'กำลังโหลด…',
  'common.all': 'ทั้งหมด',
  'common.none': 'ไม่มี',
  'common.default': 'ค่าเริ่มต้น',
  'common.installed': 'ติดตั้งแล้ว',
  'common.notInstalled': 'ยังไม่ได้ติดตั้ง',
  'common.active': 'เปิดใช้งาน',
  'common.offline': 'ออฟไลน์',
  'common.selected': 'เลือกแล้ว',
  'common.create': 'สร้าง',
  'common.openPreview': 'เปิดหน้าตัวอย่าง',
  'common.exitFullscreen': 'ออกจากเต็มหน้าจอ',
  'common.fullscreen': 'เต็มหน้าจอ',
  'common.openInNewTab': 'เปิดในแท็บใหม่',
  'common.exportPdf': 'ส่งออกเป็น PDF',
  'common.exportZip': 'ดาวน์โหลดเป็น .zip',
  'common.exportHtml': 'ส่งออกเป็น HTML',
  'common.exportImage': 'ส่งออกเป็นรูปภาพ',
  'common.exportImageFailed': 'การจับภาพล้มเหลว โปรดลองอีกครั้งหรือใช้เครื่องมือจับภาพหน้าจอของเบราว์เซอร์',
  'common.justNow': 'เมื่อครู่นี้',
  'common.minutesAgo': '{n} นาทีที่แล้ว',
  'common.hoursAgo': '{n} ชั่วโมงที่แล้ว',
  'common.daysAgo': '{n} วันที่แล้ว',
  'common.weeksAgo': '{n} สัปดาห์ที่แล้ว',
  'common.now': 'ตอนนี้',
  'common.minutesShort': '{n} นาที',
  'common.hoursShort': '{n} ชม.',
  'common.daysShort': '{n} วัน',
  'common.untitled': 'ไม่มีชื่อ',
  'plugins.availableDetails.provenance': 'ที่มา',
  'plugins.availableDetails.provenanceLine': 'จาก {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'จาก {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'ติดตั้ง',
  'plugins.availableDetails.version': 'เวอร์ชัน',
  'plugins.availableDetails.pluginVersion': 'เวอร์ชันปลั๊กอิน',
  'plugins.availableDetails.copyInstallCommand': 'คัดลอกคำสั่งติดตั้ง',
  'plugins.availableDetails.copied': 'คัดลอกแล้ว',
  'plugins.availableDetails.deprecatedPrefix': 'เลิกใช้งานแล้ว: {message}',
  'plugins.availableDetails.deprecatedFallback': 'เวอร์ชันนี้ถูกทำเครื่องหมายว่าเลิกใช้งานแล้ว',
  'plugins.availableDetails.yanked': 'ถูกถอนแล้ว',
  'plugins.availableDetails.yankedWithReason': 'ถูกถอนแล้ว: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (เลิกใช้งานแล้ว)',
  'plugins.availableDetails.versionYankedSuffix': ' (ถูกถอนแล้ว)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'สิทธิ์การเข้าถึง',
  'plugins.availableDetails.capabilitySummary': 'สรุปความสามารถ',
  'plugins.actions.copyInstallCommand': 'คัดลอกคำสั่งติดตั้ง',
  'plugins.actions.copyPluginId': 'คัดลอก ID ปลั๊กอิน',
  'plugins.actions.copyReadmeBadge': 'คัดลอกแบดจ์ README',
  'plugins.actions.openSourceGithub': 'เปิดซอร์สบน GitHub',
  'plugins.actions.openSource': 'เปิดซอร์ส',
  'plugins.actions.openHomepage': 'เปิดหน้าโฮมเพจ',
  'plugins.actions.openMarketplace': 'เปิดใน marketplace',
  'app.brand': 'GINI Studio',
  'app.brandPill': 'ตัวอย่างเพื่อการวิจัย',
  'app.brandSubtitle': 'โดย Nexu Labs',
  'app.welcomeLoading': 'กำลังโหลดพื้นที่ทำงาน…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'ยินดีต้อนรับ',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'เริ่มจากบรีฟ',
  'settings.onboardingCreateBody': 'อธิบายเว็บไซต์ แอป สไลด์ รูปภาพ หรือวิดีโอที่คุณต้องการ Gini Studio จะสร้างโปรเจกต์ให้และเก็บงานไว้ให้แก้ไขได้ตลอด',
  'settings.onboardingMemoryTitle': 'บันทึกบริบทการทำงาน',
  'settings.onboardingMemoryBody': 'เพิ่มค่ากำหนด ข้อเท็จจริงของโปรเจกต์ และกฎที่ใช้ซ้ำ เพื่อให้แชตในอนาคตเข้าใจบริบทที่ถูกต้อง',
  'settings.onboardingSystemsTitle': 'นำดีไซน์ซิสเต็มของคุณมาใช้',
  'settings.onboardingSystemsBody': 'เลือกหรือสร้างระบบแบรนด์ เพื่อให้งานที่สร้างขึ้นใช้สี ตัวอักษร และภาษาของผลิตภัณฑ์ตามจริง',
  'settings.onboardingExecutionTitle': 'เลือกวิธีการสร้างงาน',
  'settings.onboardingExecutionBody': 'CLI อย่างเป็นทางการ ตั้งค่าได้ในคลิกเดียวพร้อมค่าเริ่มต้นที่ใช้งานได้ทันที ใช้คีย์เดียวเพื่อเลือกจากหลายโมเดลในราคาที่ดีกว่า',
  'settings.onboardingAmrCloudBenefitOfficial': 'แนะนำอย่างเป็นทางการ',
  'settings.onboardingAmrCloudBenefitReady': 'ไม่ต้องดีพลอย',
  'settings.onboardingAmrCloudBenefitModels': 'รองรับ Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'เร็ว ๆ นี้',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'รูปภาพ/วิดีโอ',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills จำนวนมาก',
  'settings.onboardingAmrCloudUpcomingRouting': 'การกำหนดเส้นทางอัจฉริยะ',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'อนุญาต AMR',
  'settings.onboardingAmrCloudAuthorizedAction': 'อนุญาตแล้ว',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'อย่างเป็นทางการ',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as local coding agents, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.onboardingSkip': 'Skip for now',
  'settings.kicker': 'การตั้งค่า',
  'settings.title': 'โหมดการรัน',
  'settings.subtitle': 'เลือกระหว่าง Local CLI และ BYOK',
  'settings.modeAria': 'โหมดการทำงาน',
  'settings.protocolAria': 'โปรโตคอล API',
  'settings.modeDaemon': 'CLI ในเครื่อง',
  'settings.modeDaemonHelp': 'ทำงานผ่าน code-agent CLI บนเครื่องของคุณ',
  'settings.modeDaemonOffline': 'Daemon ไม่ได้ทำงานอยู่',
  'settings.modeDaemonOfflineMeta': 'daemon ออฟไลน์',
  'settings.modeDaemonInstalledMeta': 'ติดตั้งแล้ว {count} ตัว',
  'settings.modeApi': 'ผู้ให้บริการ API',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK ไม่สามารถอ่าน เขียน หรือแก้ไขไฟล์โปรเจกต์ได้ ใช้ Local CLI เมื่อคุณต้องการเปลี่ยนแปลงโค้ด',
  'settings.codeAgent': 'เอเจนต์โค้ด',
  'settings.codeAgentHint': 'ตรวจพบจากการสแกน PATH ของคุณ เลือก CLI ที่คุณต้องการให้ระบบใช้งาน',
  'settings.rescan': '↻ สแกนใหม่',
  'settings.rescanTitle': 'สแกน PATH ใหม่',
  'settings.rescanRunning': 'กำลังสแกน...',
  'settings.rescanSuccess': 'สแกนเสร็จสิ้น พบ {count} ตัวที่ใช้งานได้',
  'settings.designSystemRenameFailed': 'การเปลี่ยนชื่อล้มเหลว ตรวจสอบ daemon แล้วลองอีกครั้ง',
  'settings.rescanFailed': 'การสแกนล้มเหลว ตรวจสอบ daemon แล้วลองอีกครั้ง',
  'settings.test': 'ทดสอบ',
  'settings.testTitle': 'ส่งข้อความทดสอบขนาดเล็กเพื่อยืนยันการเชื่อมต่อ',
  'settings.testRunning': 'กำลังทดสอบการเชื่อมต่อ…',
  'settings.byokReadyToTest': 'พร้อมทดสอบ',
  'settings.testCancel': 'ยกเลิก',
  'settings.testRetry': 'ลองทดสอบอีกครั้ง',
  'settings.required': 'จำเป็น',
  'settings.testMissingFields': 'กรอก {fields} เพื่อทดสอบการเชื่อมต่อ',
  'settings.testSuccessApi': 'เชื่อมต่อแล้ว ตอบกลับใน {ms} มิลลิวินาที — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} ตอบกลับใน {ms} มิลลิวินาที — \'{sample}\'',
  'settings.testAuthFailed': 'การยืนยันตัวตนล้มเหลว ตรวจสอบ API Key ของคุณ',
  'settings.testForbidden': 'ถูกปฏิเสธการเข้าถึง ตรวจสอบบัญชี ภูมิภาค หรือองค์กรของคุณ',
  'settings.testNotFoundModel': 'ไม่พบโมเดล \'{model}\' ใน Endpoint นี้',
  'settings.testInvalidModelId': 'ID โมเดล \'{model}\' ไม่ถูกต้อง ID ต้องขึ้นต้นด้วยตัวอักษรหรือตัวเลข และไม่มีช่องว่าง',
  'settings.testInvalidBaseUrl': 'Base URL ไม่ถูกต้องหรือไม่สามารถเข้าถึงได้',
  'settings.testRateLimited': 'ผู้ให้บริการจำกัดอัตราการส่งข้อมูล',
  'settings.testUpstream': 'ผู้ให้บริการตอบกลับด้วยสถานะ {status} โปรดลองอีกครั้งในภายหลัง',
  'settings.testTimeout': 'การทดสอบหมดเวลาหลังจาก {ms} มิลลิวินาที',
  'settings.testAgentMissing': 'ยังไม่ได้ติดตั้ง {agentName} หรือไม่ได้อยู่ใน PATH',
  'settings.testAgentSpawn': 'ไม่สามารถเริ่ม {agentName} ได้: {detail}',
  'settings.testUnknown': 'การทดสอบล้มเหลว: {detail}',
  'settings.agentInstall.install': 'ติดตั้ง',
  'settings.agentInstall.docs': 'เอกสาร',
  'settings.agentInstall.pathHint': 'หากคุณติดตั้ง CLI ด้วย npm หรือ Homebrew แล้วแต่ยังแสดงว่าไม่ได้ติดตั้ง โปรดตรวจสอบว่าโฟลเดอร์ bin ของเครื่องมือนั้นอยู่ใน PATH ที่ Gini Studio daemon ใช้งาน (บน macOS ค่า PATH ของ Terminal และแอป GUI อาจต่างกัน) ดู QUICKSTART.md (ส่วน "Local agent CLI and PATH")',
  'settings.agentInstall.stepOpenLinks': 'เปิดลิงก์ติดตั้งหรือเอกสารสำหรับเอเจนต์ที่ต้องการ',
  'settings.agentInstall.stepAuth': 'ยืนยันตัวตนกับ CLI ของผู้ให้บริการ (ลงชื่อเข้าใช้หรือเพิ่มข้อมูลรับรอง API) ก่อนกลับไปที่ Gini Studio',
  'settings.agentInstall.stepRescan': 'คลิกสแกนใหม่ในส่วนนี้',
  'settings.agentInstall.stepSelect': 'เลือกการ์ดเอเจนต์เมื่อแสดงว่าได้ติดตั้งแล้ว',
  'settings.noAgentsDetected': 'ยังไม่พบเอเจนต์ โปรดติดตั้งอย่างใดอย่างหนึ่ง: local coding agents, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen หรือ GitHub Copilot CLI แล้วคลิกสแกนใหม่',
  'settings.agentInstalledGroup': 'CLI ของคุณ ({count})',
  'settings.agentInstallGroup': 'พร้อมให้ติดตั้ง ({count})',
  'settings.agentAuthRequired': 'ต้องยืนยันตัวตน',
  'settings.agentAuthUnknown': 'ไม่ทราบสถานะการยืนยันตัวตน',
  'settings.amrCloud': 'Gini Studio AMR',
  'settings.amrAuthorize': 'อนุญาต',
  'settings.amrBenefitOfficial': 'ทางการ',
  'settings.amrBenefitLowerPrice': 'ต้นทุนต่ำกว่า',
  'settings.amrBenefitManyModels': 'โมเดลจำนวนมาก',
  'settings.amrPromoBonus': 'โบนัสจำกัด: +100%',
  'settings.amrSignInToContinue': 'ลงชื่อเข้าใช้เพื่อดำเนินการต่อ',
  'settings.amrSignIn': 'ลงชื่อเข้าใช้',
  'settings.amrSignedIn': 'ลงชื่อเข้าใช้แล้ว',
  'settings.amrNotSignedIn': 'ยังไม่ได้ลงชื่อเข้าใช้',
  'settings.amrSigningIn': 'กำลังลงชื่อเข้าใช้…',
  'settings.amrCancelSignIn': 'ยกเลิกการลงชื่อเข้าใช้',
  'settings.amrAccountStatus': 'สถานะบัญชี AMR',
  'settings.amrConsole': 'AMR Console',
  'settings.amrLoginErrorCompact': 'การลงชื่อเข้าใช้ AMR ล้มเหลว',
  'settings.advanced': 'ขั้นสูง',
  'settings.amrLogin': 'ลงชื่อเข้าใช้',
  'settings.amrLogout': 'ออกจากระบบ',
  'settings.amrLoggingIn': 'กำลังลงชื่อเข้าใช้…',
  'settings.amrLoggingOut': 'กำลังลงชื่อออก…',
  'auth.logout': 'ออกจากระบบ',
  'auth.loggingOut': 'กำลังลงชื่อออก…',
  'settings.amrLoggedInAs': 'ลงชื่อเข้าใช้ในชื่อ {email}',
  'settings.amrLoggedInWithPlan': 'ลงชื่อเข้าใช้ในชื่อ {email} · {plan}',
  'settings.amrLoggedInPill': 'ลงชื่อเข้าใช้แล้ว',
  'settings.amrNotLoggedIn': 'ยังไม่ได้ลงชื่อเข้าใช้',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'เลือกผู้ให้บริการอย่างรวดเร็ว',
  'settings.providerPreset': 'พรีเซ็ตเกตเวย์',
  'settings.protocolGroupProtocols': 'โปรโตคอล',
  'settings.protocolGroupGateways': 'เกตเวย์',
  'settings.customProvider': 'กำหนดผู้ให้บริการเอง',
  'settings.apiKey': 'API Key',
  'settings.apiKeyGetLink': 'รับคีย์ ↗',
  'settings.showKey': 'แสดง Key',
  'settings.hideKey': 'ซ่อน Key',
  'settings.show': 'แสดง',
  'settings.hide': 'ซ่อน',
  'settings.model': 'โมเดล',
  'settings.apiKeyInvalid': 'API key ไม่ถูกต้อง',
  'settings.apiKeyCleaned': 'ลบช่องว่างส่วนเกินออกจาก API key แล้ว',
  'settings.modelsLoadedFromAccount': '✓ โหลด {count} โมเดลจากบัญชีของคุณแล้ว',
  'settings.modelsLoadedCount': '✓ โหลด {count} โมเดลแล้ว',
  'settings.modelSourceAccount': 'จากบัญชีของคุณ',
  'settings.modelSourceSuggested': 'แนะนำ',
  'settings.fetchModels': 'ดึงโมเดล',
  'settings.fetchModelsTitle': 'ดึงโมเดลที่มีอยู่จากผู้ให้บริการนี้',
  'settings.fetchModelsRunning': 'กำลังดึงโมเดล…',
  'settings.fetchModelsMissingFields': 'กรอก {fields} เพื่อดึงโมเดล',
  'settings.fetchModelsInvalidBaseUrl': 'ใส่ Base URL ที่ถูกต้องเพื่อดึงโมเดล',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI ใช้ชื่อ deployment ดังนั้นจึงไม่สามารถค้นหาโมเดลได้ที่นี่',
  'settings.fetchModelsUnsupportedOllama': 'ยังไม่สามารถค้นหาโมเดลของ Ollama Cloud ได้ในขณะนี้ เลือกหรือพิมพ์ชื่อโมเดล',
  'settings.fetchModelsSuccess': 'ดึงโมเดลมาแล้ว {count} รายการ',
  'settings.fetchModelsEmpty': 'ไม่มีโมเดลข้อความที่เข้ากันได้ส่งกลับมา',
  'settings.fetchModelsUnsupported': 'ไม่สามารถค้นหาโมเดลสำหรับโปรโตคอลนี้ได้',
  'settings.fetchModelsFailed': 'ไม่สามารถดึงโมเดลได้: {detail}',
  'settings.suggestedModelsHint': 'นี่คือโมเดลที่แนะนำสำหรับโปรโตคอลนี้ ผู้ให้บริการของคุณอาจรองรับโมเดลอื่นๆ',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'ใช้ URL สาธารณะ http:// หรือ https://',
  'settings.baseUrlCustomize': 'ปรับแต่ง',
  'settings.baseUrlDefaultHint': 'ปลายทางเริ่มต้น โดยปกติไม่จำเป็นต้องเปลี่ยน',
  'settings.azureBaseUrlPlaceholder': 'วาง URL ปลายทางของ Azure',
  'settings.azureBaseUrlHint': 'ดูได้ใน Azure portal → ทรัพยากรของคุณ → Endpoint',
  'settings.azureDeploymentModel': 'ชื่อ Deployment',
  'settings.azureCustomDeploymentName': 'ชื่อ deployment ที่กำหนดเอง',
  'settings.azureDeploymentModelHint': 'สำหรับ Azure OpenAI ฟิลด์นี้ใช้เป็นชื่อ Deployment ใน /openai/deployments/<model> ป้อนชื่อ Deployment ที่คุณสร้างใน Azure',
  'settings.azureModelFetchHint': 'กรอกชื่อ deployment จากทรัพยากร Azure ของคุณ Azure deployment ไม่สามารถดึงข้อมูลอัตโนมัติได้',
  'settings.apiVersion': 'เวอร์ชัน API',
  'settings.byokImageModel': 'โมเดลสร้างภาพ',
  'settings.byokVideoModel': 'โมเดลสร้างวิดีโอ',
  'settings.byokVideoI2vHint': 'โมเดลภาพเป็นวิดีโอ: ต้องมีภาพอ้างอิง (หากไม่ระบุ จะใช้ภาพล่าสุดในโปรเจกต์โดยอัตโนมัติ)',
  'settings.byokSpeechModel': 'โมเดลเสียงพูด',
  'settings.byokSpeechVoice': 'เสียงพูด',
  'settings.byokModelDefaultOption': 'ค่าเริ่มต้น',
  'settings.maxTokens': 'Max tokens (เลือกได้)',
  'settings.maxTokensHint': 'ขีดจำกัดความยาวในการตอบกลับ',
  'settings.apiHint': 'คำสั่งจะถูกส่งผ่าน local daemon proxy ไปยัง base URL ที่คุณตั้งไว้ API Key จะถูกเก็บในเบราว์เซอร์นี้เท่านั้น',
  'settings.skipForNow': 'ข้ามไปก่อน',
  'settings.getStarted': 'เริ่มต้นใช้งาน',
  'settings.envConfigure': 'โหมดการรัน',
  'settings.localCli': 'CLI ในเครื่อง',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'ไม่ได้เลือกเอเจนต์',
  'settings.language': 'ภาษา',
  'settings.languageHint': 'เปลี่ยนภาษาอินเทอร์เฟซ บันทึกไว้ในเบราว์เซอร์นี้',
  'settings.appearance': 'ลักษณะที่ปรากฏ',
  'settings.appearanceHint': 'เลือกธีมสว่าง มืด หรือตามระบบ',
  'settings.themeSystem': 'ระบบ',
  'settings.themeLight': 'สว่าง',
  'settings.themeDark': 'มืด',
  'settings.agentModelHead': 'โมเดลสำหรับ:',
  'settings.modelPicker': 'โมเดล',
  'settings.modelSourceLive': 'สดจาก CLI',
  'settings.modelSourceFallback': 'รายการในตัว',
  'settings.reasoningPicker': 'ความพยายามในการให้เหตุผล',
  'settings.modelPickerHint': 'ดึงข้อมูลจาก CLI เมื่อมีคำสั่ง `models`',
  'settings.modelPickerLiveHint': 'รีเฟรชโมเดลจาก CLI ที่ติดตั้งแล้ว ค่าเริ่มต้นยังใช้การตั้งค่าของ CLI',
  'settings.modelPickerLiveCatalogOnlyHint': 'รีเฟรชโมเดลจาก CLI ที่ติดตั้งแล้ว',
  'settings.modelPickerFallbackHint': 'กำลังแสดงค่าเริ่มต้นในตัว คลิกสแกนอีกครั้งเพื่อดึงโมเดลสดจาก CLI',
  'settings.cliEnvTitle': 'ตำแหน่งการตั้งค่า CLI',
  'settings.cliEnvHint': 'ตั้งค่าไดเรกทอรีการกำหนดค่า (ที่ไม่เป็นความลับ) สำหรับแอปพลิเคชัน',
  'settings.cliEnvClaudeConfigDir': 'ไดเรกทอรีการตั้งค่า local coding agents',
  'settings.cliEnvClaudeBaseUrl': 'Base URL ของ Claude proxy',
  'settings.cliEnvClaudeApiKey': 'API key พร็อกซีของ Claude',
  'settings.cliEnvCodexHome': 'โฮมของ Codex',
  'settings.cliEnvCodexBin': 'เส้นทางไฟล์เรียกทำงาน Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL พร็อกซีของ Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key พร็อกซีของ Codex/OpenAI',
  'settings.modelCustom': 'กำหนดเอง (พิมพ์ด้านล่าง)…',
  'settings.modelCustomLabel': 'ID โมเดลที่กำหนดเอง',
  'settings.modelCustomPlaceholder': 'เช่น anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'ผู้ให้บริการสื่อ',
  'settings.mediaProvidersHint': 'API keys สำหรับการสร้างภาพ วิดีโอ และเสียง บันทึกในเครื่องและซิงค์กับ local daemon',
  'settings.mcpServerTitle': 'เซิร์ฟเวอร์ MCP',
  'settings.mcpServerHint': 'เปิดให้ Gini Studio เป็นเซิร์ฟเวอร์ MCP สำหรับเอเจนต์โค้ด',
  'settings.externalMcpTitle': 'MCP ภายนอก',
  'settings.externalMcpHint': 'เพิ่มเครื่องมือ MCP จากบริการภายนอก (Higgsfield, GitHub, …)',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'ตั้งค่าแล้ว',
  'settings.mediaProviderUnset': 'ยังไม่ได้ตั้งค่า',
  'settings.mediaProviderClear': 'ล้าง',
  'settings.mediaProviderClearConfirm': 'ล้างการตั้งค่า {name} ที่บันทึกไว้ใช่หรือไม่? คุณจะต้องตั้งค่าใหม่อีกครั้งเพื่อใช้งาน {name}',
  'settings.mediaProviderPlaceholder': 'วาง API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'กำหนด Base URL แท่นค่าเริ่มต้น',
  'settings.mediaProviderReload': 'โหลดใหม่จาก daemon',
  'settings.mediaProviderReloadError': 'ไม่สามารถโหลดการตั้งค่าผู้ให้บริการสื่อใหม่จาก daemon ในเครื่องได้',
  'settings.mediaProviderReloadSuccess': 'โหลดการตั้งค่าผู้ให้บริการสื่อใหม่จาก daemon ในเครื่องแล้ว',
  'settings.mediaProviderLoadError': 'ไม่สามารถโหลดการตั้งค่าผู้ให้บริการสื่อจาก daemon ในเครื่องได้ ขณะนี้กำลังใช้การตั้งค่าที่บันทึกไว้ในเบราว์เซอร์ไปก่อน',
  'settings.mediaProviderComingSoonHint': 'เราติดตามสิ่งเหล่านี้สำหรับแผนงาน daemon ยังไม่ได้จัดส่งไคลเอนต์ ดังนั้นจึงไม่มีอะไรให้กำหนดค่า',
  'settings.privacy': 'ความเป็นส่วนตัว',
  'settings.privacyHint': 'ข้อมูลที่แชร์กับทีม Gini Studio',
  'settings.privacyConsentKicker': 'ช่วยเราพัฒนา Gini Studio',
  'settings.privacyConsentLead': 'Gini Studio สามารถแชร์ข้อมูลการใช้งานกับทีมของเราเพื่อช่วยพัฒนา ซึ่งรวมถึง:',
  'settings.privacyConsentFooter': 'คุณสามารถเปลี่ยนการตั้งค่าเหล่านี้ได้ตลอดเวลาใน การตั้งค่า → ความเป็นส่วนตัว เราจะไม่ส่งเนื้อหาในไฟล์ที่คุณสร้างขึ้น',
  'settings.privacyConsentShare': 'แชร์ข้อมูลการใช้งาน',
  'settings.privacyConsentDecline': 'ไม่แชร์',
  'settings.privacyConsentAccept': 'เข้าใจแล้ว',
  'settings.privacyConsentBannerFooter': 'การแชร์ข้อมูลเปิดใช้งานโดยค่าเริ่มต้น คุณสามารถปิดได้ทุกเมื่อที่ Settings → Privacy เราจะไม่อัปโหลดเนื้อหาของไฟล์ artifact ที่คุณสร้างขึ้นโดยเด็ดขาด',
  'settings.privacyConsentPolicyLink': 'อ่านนโยบายความเป็นส่วนตัว',
  'settings.privacyMetrics': 'ข้อมูลผู้ใช้นิรนาม',
  'settings.privacyMetricsHint': 'จำนวนการใช้งาน, การใช้โทเค็น, อัตราข้อผิดพลาด',
  'settings.privacyContent': 'เนื้อหาการสนทนา',
  'settings.privacyContentHint': 'คำสั่งของคุณและการตอบกลับของระบบ (ตัดทอนเหลือ 8/16 KB)',
  'settings.privacyArtifacts': 'ข้อมูลโครงสร้างไฟล์',
  'settings.privacyArtifactsHint': 'ชื่อไฟล์ ประเภท ขนาดไฟล์ที่สร้าง',
  'settings.privacyInstallationId': 'ID ผู้ใช้นิรนาม',
  'settings.privacyOptedOut': 'ปฏิเสธแล้ว',
  'settings.privacyDataDeletion': 'ลบข้อมูลของฉัน',
  'settings.privacyDataDeletionHint': 'รีเซ็ต ID ผู้ใช้นิรนามและหยุดการส่งข้อมูล',
  'settings.about': 'เกี่ยวกับ',
  'settings.aboutHint': 'เวอร์ชันและรายละเอียดระบบ',
  'settings.appVersion': 'เวอร์ชัน',
  'settings.appChannel': 'ช่องทาง',
  'settings.appRuntime': 'รันไทม์',
  'settings.appPlatform': 'แพลตฟอร์ม',
  'settings.appArchitecture': 'สถาปัตยกรรม',
  'settings.runtimePackaged': 'แอปที่แพ็กเกจแล้ว',
  'settings.runtimeDevelopment': 'การพัฒนา',
  'settings.versionUnavailable': 'ข้อมูลเวอร์ชันไม่พร้อมใช้งานขณะที่ daemon ออฟไลน์',
  'settings.giniStudioCapabilitiesTitle': 'ความสามารถของ GINI Studio',
  'settings.installLatest': 'ติดตั้งเวอร์ชันล่าสุด',
  'settings.alreadyLatest': 'คุณใช้เวอร์ชันล่าสุดอยู่แล้ว',
  'settings.mcpTitle': 'เซิร์ฟเวอร์ MCP',
  'settings.mcpHint': 'ให้ coding agent (Cursor, local coding agents, VS Code…) อ่านโปรเจกต์ Gini Studio ของคุณได้โดยตรง',
  'settings.mcpDaemonError': 'ไม่สามารถเชื่อมต่อกับ daemon ในเครื่องเพื่อระบุพาธการติดตั้งได้ ({error}) โปรดตรวจสอบว่า Gini Studio กำลังทำงานอยู่ จากนั้นเปิดแผงนี้ใหม่',
  'settings.mcpBuildDaemon': 'สร้าง daemon ก่อน',
  'settings.mcpNodeMissing': 'ไม่พบไบนารีของ Node',
  'settings.mcpBuildHint': 'ไม่พบ apps/daemon/dist/cli.js รัน `pnpm --filter @open-design/daemon build` แล้วรีเฟรช',
  'settings.mcpMethodCli': 'คำสั่ง CLI',
  'settings.mcpInstructionCli': 'รันคำสั่งนี้ใน terminal ของคุณ',
  'settings.mcpMethodToml': 'การตั้งค่า TOML',
  'settings.mcpInstructionCodex': 'เพิ่มตารางนี้ต่อท้าย {path} การตั้งค่าเดียวกันนี้ใช้ร่วมกันระหว่าง Codex CLI และส่วนขยาย Codex IDE',
  'settings.mcpMethodOneClick': 'ติดตั้งด้วยคลิกเดียว',
  'settings.mcpInstructionCursor': 'คลิก "Install in Cursor" เพื่อติดตั้งพร้อมกล่องโต้ตอบขออนุมัติ หรือผสาน JSON นี้เข้ากับ {path}',
  'settings.mcpDeeplinkInstallCursor': 'ติดตั้งใน Cursor',
  'settings.mcpMethodJson': 'การตั้งค่า JSON',
  'settings.mcpInstructionCopilot': 'เปิด Command Palette ({shortcut}) รัน "MCP: Open User Configuration" แล้วผสาน JSON นี้ Copilot Chat ต้องอยู่ในโหมด Agent เพื่อให้เครื่องมือแสดงขึ้นมา',
  'settings.mcpInstructionAntigravity': 'ใน Antigravity: เมนู "..." ของแผง Agent → MCP Servers → Manage MCP Servers → View raw config แล้วรวม JSON นี้',
  'settings.mcpInstructionZed': 'เปิด Zed Settings ({shortcut}) แล้วผสานสิ่งนี้เข้ากับอ็อบเจกต์ระดับบนสุด Zed ใช้ "context_servers" ไม่ใช่ "mcpServers"',
  'settings.mcpInstructionWindsurf': 'เปิด {path} (หรือใช้ไอคอน MCPs ใน Cascade → Configure) แล้วรวม:',
  'settings.mcpCopyAria': 'คัดลอกสคริปต์การตั้งค่า MCP',
  'settings.mcpResolvingFailed': '# resolving paths failed, see the error above',
  'settings.mcpLoadingPaths': '# loading install paths from the local daemon…',
  'settings.mcpCopied': 'คัดลอกแล้ว',
  'settings.mcpCopy': 'คัดลอก',
  'settings.mcpCursorApproval': 'Cursor จะแสดงกล่องโต้ตอบขออนุมัติก่อนเขียนการตั้งค่า',
  'settings.mcpCodexOneClickInstall': 'ติดตั้งใน Codex',
  'settings.mcpCodexOneClickUninstall': 'ลบออกจาก Codex',
  'settings.mcpCodexOneClickUnavailable': 'ไม่พบ Codex CLI บน PATH — ติดตั้ง Codex หรือวาง snippet ด้วยตนเอง',
  'settings.mcpCodexInstallSuccess': 'ติดตั้งแล้ว รีสตาร์ท Codex เพื่อโหลดเซิร์ฟเวอร์ใหม่',
  'settings.mcpCodexUninstallSuccess': 'ลบออกจาก Codex แล้ว',
  'settings.mcpCodexBusy': 'กำลังทำงาน…',
  'settings.mcpCodexInstallError': 'การดำเนินการล้มเหลว: {error}',
  'settings.mcpRestartNote': 'รีสตาร์ทไคลเอนต์ของคุณเพื่อรับเซิร์ฟเวอร์ใหม่',
  'settings.mcpRestartDetail': 'โปรแกรมแก้ไขส่วนใหญ่จะโหลดเซิร์ฟเวอร์ MCP เฉพาะตอนเริ่มต้นเท่านั้น ใน Cursor / VS Code / Antigravity / Windsurf คุณสามารถรัน `Developer: Reload Window` จาก command palette แทนการรีสตาร์ททั้งหมดได้ ส่วน Zed และ local coding agents ต้องปิดแล้วเปิดใหม่',
  'settings.mcpCapabilitiesTitle': 'สิ่งที่ Agent ของคุณทำได้',
  'settings.mcpCapabilityRead': 'อ่านหรือค้นหาไฟล์ใดก็ได้ในโปรเจกต์ (HTML, JSX, CSS, JSON, SVG, Markdown)',
  'settings.mcpCapabilityPull': 'ดึงชุดดีไซน์ในการเรียกครั้งเดียว: ไฟล์เริ่มต้นพร้อมทุก CSS variable, คอมโพเนนต์ และฟอนต์ที่อ้างอิงถึง',
  'settings.mcpCapabilityDefault': 'ตั้งค่าเริ่มต้นเป็นโปรเจกต์และไฟล์ที่คุณเปิดอยู่ใน Gini Studio เพื่อให้คุณพูดได้ว่า "สร้างสิ่งนี้ในแอปของฉัน" โดยไม่ต้องระบุดีไซน์ซ้ำอีก',
  'settings.mcpRunningNote': 'Gini Studio ต้องกำลังทำงานอยู่เพื่อให้การเรียกเครื่องมือ MCP สำเร็จ หากคุณเริ่มต้นโค้ดดิ้ง Agent ก่อนเปิด Gini Studio ให้รีสตาร์ท Agent เพื่อให้สามารถเชื่อมต่อกับ daemon ที่ทำงานอยู่ได้',
  'entry.tabDesigns': 'ดีไซน์',
  'entry.tabTemplates': 'ตัวอย่าง',
  'entry.tabDesignSystems': 'ระบบการออกแบบ',
  'entry.tabConnectors': 'ตัวเชื่อมต่อ',
  'entry.openSettingsTitle': 'การตั้งค่า',
  'entry.openSettingsAria': 'เปิดการตั้งค่า',
  'entry.discordLabel': 'เข้าร่วม Discord',
  'entry.discordOnlineLabel': 'ออนไลน์ {count} คน',
  'entry.followXLabel': 'ติดตาม @ginistudio บน X',
  'entry.resizeAria': 'ปรับขนาดแถบด้านข้าง',
  'entry.loadingWorkspace': 'กำลังโหลดพื้นที่ทำงาน…',
  'entry.useEverywhereTitle': 'ใช้ได้ทุกที่',
  'entry.useEverywhereAria': 'เปิดคู่มือ Use Everywhere (CLI, MCP, HTTP, Skills)',
  'entry.navExpand': 'ขยายแถบด้านข้าง',
  'entry.navCollapse': 'ย่อแถบด้านข้าง',
  'entry.navNewProject': 'โปรเจกต์ใหม่',
  'entry.navHome': 'หน้าแรก',
  'entry.navProjects': 'โปรเจกต์',
  'entry.navTasks': 'การทำงานอัตโนมัติ',
  'entry.navPlugins': 'ปลั๊กอิน',
  'entry.navDesignSystems': 'ดีไซน์ซิสเต็ม',
  'entry.navIntegrations': 'การเชื่อมต่อ',
  'workspaceTabs.project': 'โปรเจกต์',
  'workspaceTabs.pluginDetails': 'รายละเอียดปลั๊กอิน',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'คุณต้องการออกแบบอะไร?',
  'homeHero.templatesScrollHint': 'เลื่อนขึ้นเพื่อสำรวจเทมเพลตเพิ่มเติม',
  'homeHero.templatesCollapse': 'ยุบเทมเพลต',
  'homeHero.subtitlePrefix': 'Design, build, and ship polished creative work with GINI Studio.',
  'homeHero.placeholder': 'อธิบายสิ่งที่คุณต้องการสร้าง…',
  'homeHero.placeholderActive': 'แก้ไขตัวอย่างคำค้นหรือเขียนของคุณเอง…',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'เพิ่มบริบท',
  'homeHero.addPlugin': 'เพิ่มปลั๊กอิน',
  'homeHero.addConnectors': 'เพิ่มตัวเชื่อมต่อ',
  'homeHero.addMcp': 'เพิ่มเซิร์ฟเวอร์ MCP',
  'homeHero.noPlugins': 'ไม่มีปลั๊กอินที่ติดตั้ง',
  'homeHero.noMcp': 'ไม่มีเซิร์ฟเวอร์ MCP',
  'homeHero.noConnectors': 'ไม่มีตัวเชื่อมต่อที่เชื่อมต่ออยู่',
  'homeHero.applying': 'กำลังปรับใช้…',
  'homeHero.pluginTitle': 'ปลั๊กอิน: {title}',
  'homeHero.pluginPrefix': 'ปลั๊กอิน: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'ลบปลั๊กอิน',
  'homeHero.removePluginAria': 'ลบปลั๊กอิน {title}',
  'homeHero.clearActivePlugin': 'ล้างปลั๊กอินที่ใช้งานอยู่',
  'homeHero.clearActiveSkill': 'ล้าง skill ที่ใช้งานอยู่',
  'homeHero.contextItemsResolved': 'แก้ไขรายการบริบทแล้ว {n} รายการ',
  'homeHero.removeFile': 'ลบไฟล์',
  'homeHero.contextSearchResults': 'ผลการค้นหาบริบท',
  'homeHero.contextSurfaces': 'พื้นผิวบริบท',
  'homeHero.loadingContext': 'กำลังโหลดบริบท…',
  'homeHero.noResults': 'ไม่มีผลลัพธ์สำหรับ "{query}"',
  'homeHero.searchPrompt': 'ค้นหาไฟล์ ปลั๊กอิน skills, MCP server และคอนเนกเตอร์',
  'homeHero.parameters': '{n} พารามิเตอร์',
  'homeHero.details': 'รายละเอียด',
  'homeHero.toRun': 'เพื่อเรียกใช้',
  'homeHero.forNewLine': 'เพื่อขึ้นบรรทัดใหม่',
  'homeHero.run': 'เรียกใช้',
  'homeHero.typeSomethingToRun': 'พิมพ์บางอย่างเพื่อเรียกใช้',
  'homeHero.promptExamples': 'ตัวอย่าง',
  'homeHero.footer.designSystem': 'สไตล์',
  'homeHero.footer.autoDesignSystem': 'อัตโนมัติ',
  'homeHero.footer.autoDesignSystemSummary': 'จับคู่ระบบออกแบบและสไตล์ภาพที่เหมาะกับพรอมป์ปัจจุบันโดยอัตโนมัติ',
  'homeHero.footer.ratio': 'สัดส่วน',
  'homeHero.footer.duration': 'ระยะเวลา',
  'homeHero.footer.resolution': 'ความละเอียด',
  'homeHero.footer.speakerNotes': 'บันทึก',
  'homeHero.footer.noSpeakerNotes': 'ไม่มีโน้ต',
  'homeHero.footer.availableCount': 'พร้อมใช้งาน {n} รายการ',
  'homeHero.footer.noMatches': 'ไม่พบรายการที่ตรงกัน',
  'homeHero.moreShortcuts': 'เพิ่มเติม',
  'homeHero.railAria': 'เลือกหมวดหมู่โปรเจกต์หรือทางลัดเริ่มต้น',
  'homeHero.subTypeAria': 'เลือกประเภทย่อย',
  'homeHero.confirmReplaceTitle': 'แทนที่ prompt ปัจจุบันหรือไม่?',
  'homeHero.confirmReplaceBody': 'การใช้ {title} จะแทนที่ข้อความที่อยู่ในช่องป้อนข้อมูลในขณะนี้',
  'homeHero.confirmReplace': 'แทนที่',
  'homeHero.chip.prototype': 'ต้นแบบ',
  'homeHero.chip.liveArtifact': 'Artifact แบบเรียลไทม์',
  'homeHero.chip.deck': 'ชุดสไลด์',
  'homeHero.chip.image': 'รูปภาพ',
  'homeHero.chip.video': 'วิดีโอ',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'เสียง',
  'homeHero.chip.createPlugin': 'สร้างปลั๊กอิน',
  'homeHero.chip.figma': 'จาก Figma',
  'homeHero.chip.folder': 'จากโฟลเดอร์',
  'homeHero.chip.template': 'จากเทมเพลต',
  'homeHero.chip.liveArtifactHint': 'สร้าง artifact แบบ HTML/CSS/JS ที่โต้ตอบได้ ซึ่งคุณสามารถดูตัวอย่างแบบสดได้',
  'homeHero.chip.hyperframesHint': 'สร้างภาพเคลื่อนไหวแบบ HTML: คำบรรยาย ภาพที่ตอบสนองต่อเสียง และการเปลี่ยนฉาก',
  'homeHero.chip.createPluginHint': 'สร้างปลั๊กอิน Gini Studio ที่นำกลับมาใช้ใหม่ได้ และเพิ่มลงในปลั๊กอินของฉัน',
  'homeHero.chip.figmaHint': 'ย้าย frame ของ Figma เข้าสู่ design system ที่ใช้งานอยู่',
  'homeHero.chip.folderHint': 'นำเข้าโฟลเดอร์ภายในเครื่องที่มีอยู่และแก้ไขต่อ',
  'homeHero.chip.templateHint': 'เริ่มจากเทมเพลตที่มาพร้อมกัน',
  'workingDirPicker.title': 'โฟลเดอร์',
  'workingDirPicker.homeTitle': 'เลือกตำแหน่งที่จะจัดเก็บโปรเจกต์นี้',
  'workingDirPicker.processing': 'กำลังประมวลผล…',
  'workingDirPicker.select': 'เลือกโฟลเดอร์',
  'workingDirPicker.clearAria': 'ล้างไดเรกทอรีทำงาน',
  'workingDirPicker.replaceFailed': 'ไม่สามารถแทนที่ไดเรกทอรีทำงานได้',
  'workingDirPicker.unavailable': 'ตัวเลือกโฟลเดอร์ไม่พร้อมใช้งานในบิลด์นี้ เรียกใช้แอปเดสก์ท็อปเพื่อเลือกโฟลเดอร์',
  'workingDirPicker.openUnavailable': 'เปิดโปรเจกต์นี้ในแอปเดสก์ท็อปเพื่อแสดงโฟลเดอร์',
  'workingDirPicker.openFailed': 'ไม่สามารถแสดงโฟลเดอร์นี้ได้',
  'workingDirPicker.showInFileManager': 'แสดงในตัวจัดการไฟล์',
  'workingDirPicker.replace': 'แทนที่ไดเรกทอรี…',
  'workingDirPicker.recent': 'ไดเรกทอรีล่าสุด',
  'handoff.toTarget': 'ส่งต่อไปยัง {target}',
  'handoff.openInTarget': 'เปิดใน {target}',
  'handoff.openAction': 'เปิด',
  'handoff.menuTitle': 'เปิดในเอดิเตอร์ใด?',
  'handoff.action': 'ส่งต่อ',
  'handoff.fallbackTitle': 'ไม่พบเอดิเตอร์บน $PATH - จะเปิดใน {target}',
  'handoff.chooseTargetAria': 'เลือกเป้าหมายการส่งต่อ',
  'handoff.optionsAria': 'ตัวเลือกการส่งต่อ',
  'handoff.editorSection': 'เปิดด้วยเอดิเตอร์',
  'handoff.cliSection': 'คัดลอกสำหรับ CLI',
  'handoff.clickOpen': 'คลิกเพื่อเปิด',
  'handoff.framework': 'เฟรมเวิร์กโค้ด',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML และ CSS',
  'handoff.amrWebsite': 'เปิดเว็บไซต์ AMR',
  'handoff.copyPrompt': 'คัดลอกพรอมป์ต์',
  'handoff.copyPromptForTarget': 'คัดลอกพรอมป์ต์สำหรับ {target}',
  'handoff.copied': 'คัดลอกแล้ว',
  'handoff.projectPathUnavailable': 'กำลังโหลดพาธของโปรเจกต์ โปรดลองอีกครั้งในอีกสักครู่',
  'handoff.copyFailed': 'การเขียนลงคลิปบอร์ดถูกบล็อก โปรดลองอีกครั้งในอีกสักครู่',
  'handoff.promptIntro': 'ดำเนินการต่อจากโฟลเดอร์โปรเจกต์ Gini Studio ในเครื่องนี้:',
  'handoff.promptTarget': 'เป้าหมาย',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'คุณกำลังเข้ามาดำเนินการต่อใน {cli} กรุณา:',
  'handoff.promptReadFiles': 'เข้าหรืออ่านไดเรกทอรีนี้ก่อน โดยให้ความสำคัญกับ DESIGN.md, README, ไฟล์ HTML/CSS/JS ที่มีอยู่, แอสเซต และ package.json หากมี',
  'handoff.promptKeepDesign': 'รักษาการออกแบบภาพ เลย์เอาต์ การโต้ตอบ และแอสเซตในปัจจุบันไว้ อย่าหยุดอยู่แค่แผน',
  'handoff.promptProduceCode': 'สร้างหรือแก้ไขโค้ด {framework} ที่รันได้จริง หากโปรเจกต์มีสแตกที่ชัดเจนกว่าอยู่แล้ว ให้ชี้ให้เห็นความขัดแย้งและทำให้ผลลัพธ์ยังรันได้',
  'handoff.promptVerify': 'จบด้วยการบอกคำสั่งสำหรับรัน พรีวิว และตรวจสอบให้ฉัน',
  'handoff.promptCommandHint': 'หากต้องการเริ่มจากไดเรกทอรีของโปรเจกต์ ให้ใช้:',
  'handoff.promptProject': 'โปรเจกต์',
  'handoff.promptProjectId': 'Project ID',
  'handoff.notInstalled': 'ยังไม่ได้ติดตั้ง',
  'handoff.notDetectedTitle': '{target} - ไม่พบบน $PATH',
  'designSystemPicker.select': 'เลือกดีไซน์ซิสเต็ม',
  'designSystemPicker.loading': 'กำลังโหลด design systems…',
  'designSystemPicker.searchPlaceholder': 'ค้นหาดีไซน์ซิสเต็ม (ชื่อ / หมวดหมู่ / สรุป)',
  'designSystemPicker.searchCompactPlaceholder': 'ค้นหาดีไซน์ซิสเต็ม',
  'designSystemPicker.noneTitle': 'ไม่ใช้ดีไซน์ซิสเต็ม',
  'designSystemPicker.noneSummary': 'ให้โมเดลเลือกได้อย่างอิสระ',
  'designSystemPicker.empty': 'ไม่พบดีไซน์ซิสเต็มที่ตรงกัน',
  'designSystemPicker.openPreview': 'เปิดพรีวิว',
  'designSystemPicker.loadingPreview': 'กำลังโหลดตัวอย่าง…',
  'designSystemPicker.noPreview': 'ไม่มีหน้าพรีวิว เปิด Design Systems เพื่อดูพรีวิวแบบเต็ม',
  'designSystemPicker.previewHint': 'ชี้เมาส์ที่ดีไซน์ซิสเต็มเพื่อพรีวิว',
  'designSystemPicker.fullscreenAria': 'พรีวิวเต็มจอของ {title}',
  'designSystemPicker.closeFullscreen': 'ปิดพรีวิวเต็มจอ',
  'designSystemPicker.closeEsc': 'ปิด (Esc)',
  'designSystemPicker.previewFrameTitle': 'พรีวิวของ {title}',
  'designSystemPicker.fullscreenFrameTitle': 'พรีวิวเต็มจอของ {title}',
  'recentProjects.title': 'โปรเจกต์ล่าสุด',
  'recentProjects.viewAll': 'ดูทั้งหมด',
  'recentProjects.empty': 'ยังไม่มีโปรเจกต์ — พิมพ์ prompt เพื่อเริ่มต้น',
  'pluginsHome.title': 'Explore',
  'pluginsHome.subtitle': 'เวิร์กโฟลว์ Gini Studio พร้อมใช้งานที่มาพร้อมกับรันไทม์นี้ เลือกหนึ่งรายการเพื่อโหลดพรอมป์ต์เริ่มต้น หรือเรียกดูรีจิสตรีเพื่อดูเพิ่มเติม',
  'pluginsHome.browseRegistry': 'Explore all',
  'pluginsHome.count': '{filtered} จาก {total}',
  'pluginsHome.loadingCatalog': 'กำลังโหลดแคตตาล็อก…',
  'pluginsHome.emptyCatalog': 'แคตตาล็อกว่างเปล่า ปลั๊กอินที่มาพร้อมกับ Gini Studio ควรปรากฏที่นี่โดยอัตโนมัติ — ลองรีสตาร์ท daemon หากยังเกิดปัญหานี้อยู่',
  'pluginsHome.emptyFiltered': 'ไม่มีปลั๊กอินที่ตรงกับตัวกรองปัจจุบัน',
  'pluginsHome.clearFilters': 'ล้างตัวกรอง',
  'pluginsHome.modeAria': 'โหมดปลั๊กอิน',
  'pluginsHome.featured': 'บันทึกแล้ว',
  'pluginsHome.totalInCatalog': '{n} รายการในแคตตาล็อก',
  'pluginsHome.categoryFilterAria': 'ตัวกรองหมวดหมู่',
  'pluginsHome.subcategoryFilterAria': 'ตัวกรองหมวดหมู่ย่อย {label}',
  'pluginsHome.allCategory': '{label} ทั้งหมด',
  'pluginsHome.searchPlaceholder': 'ค้นหาปลั๊กอิน…',
  'pluginsHome.searchAria': 'ค้นหาปลั๊กอิน',
  'pluginsHome.clearSearch': 'ล้างการค้นหา',
  'pluginsHome.facet.import': 'นำเข้า',
  'pluginsHome.facet.create': 'สร้าง',
  'pluginsHome.facet.export': 'ส่งออก',
  'pluginsHome.facet.share': 'แชร์',
  'pluginsHome.facet.deploy': 'ดีพลอย',
  'pluginsHome.facet.refine': 'ปรับแต่ง',
  'pluginsHome.facet.extend': 'ขยายเพิ่ม',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'โค้ด / โฟลเดอร์',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'ภาพหน้าจอ',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'สไลด์',
  'pluginsHome.facet.publicLink': 'ลิงก์สาธารณะ',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsView.lede': 'เรียกดูเวิร์กโฟลว์ที่ติดตั้งไว้ ค้นพบรายการใน registry จัดการแหล่งที่มา และเตรียมปลั๊กอินสำหรับการแจกจ่ายให้ทีม',
  'pluginsView.importPlugin': 'นำเข้าปลั๊กอิน',
  'pluginsView.agentContext': 'บริบทของ Agent',
  'pluginsView.summaryAria': 'สรุปปลั๊กอิน',
  'pluginsView.areasAria': 'พื้นที่ของปลั๊กอิน',
  'pluginsView.loading': 'กำลังโหลดปลั๊กอิน…',
  'pluginsView.tab.installed': 'ติดตั้งแล้ว',
  'pluginsView.tab.available': 'พร้อมใช้งาน',
  'pluginsView.tab.sources': 'แหล่งที่มา',
  'pluginsView.tab.team': 'ทีม',
  'pluginsView.tabHint.installed': 'ปลั๊กอินของคุณ',
  'pluginsView.tabHint.available': 'จากแหล่งที่มา',
  'pluginsView.tabHint.sources': 'แคตตาล็อก',
  'pluginsView.tabHint.team': 'องค์กร',
  'pluginsView.installedTitle': 'ปลั๊กอินที่ติดตั้งแล้ว',
  'pluginsView.installedSubtitle': 'ปลั๊กอินที่คุณนำเข้าหรือติดตั้งจากแหล่งที่มาในมาร์เก็ตเพลส',
  'pluginsView.installedEmpty': 'ยังไม่มีปลั๊กอินของผู้ใช้ที่ติดตั้งไว้ ใช้ สร้าง / นำเข้า หรือติดตั้งรายการที่พร้อมใช้งาน',
  'pluginsView.availableTitle': 'พร้อมใช้งานจากแหล่งที่มา',
  'pluginsView.availableSubtitle': 'รายการในแคตตาล็อกที่ค้นพบจากมาร์เก็ตเพลสที่กำหนดค่าไว้',
  'pluginsView.availableFiltersAria': 'ตัวกรองปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.searchAvailableAria': 'ค้นหาปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.searchAvailablePlaceholder': 'ค้นหาปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.clearAvailableSearch': 'ล้างการค้นหาปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.source': 'แหล่งที่มา',
  'pluginsView.availableEmptyInstalled': 'ยังไม่มีรายการที่พร้อมใช้งาน รายการในแคตตาล็อกที่ติดตั้งแล้วจะถูกนำออกจากรายการพร้อมใช้งาน ถอนการติดตั้งรายการหนึ่งเพื่อให้กลับมาพร้อมใช้งานอีกครั้ง',
  'pluginsView.availableEmptyFiltered': 'ไม่มีรายการที่พร้อมใช้งานตรงกับตัวกรองของคุณ',
  'pluginsView.availableEmptyNoSources': 'ยังไม่มีรายการที่พร้อมใช้งาน เพิ่มแหล่งที่มาในแท็บแหล่งที่มา',
  'pluginsView.installing': 'กำลังติดตั้ง…',
  'pluginsView.install': 'ติดตั้ง',
  'pluginsView.sourcesTitle': 'แหล่งที่มาของ registry',
  'pluginsView.sourcesSubtitle': 'แค็ตตาล็อก Marketplace ที่ป้อนรายการ plugin ที่พร้อมใช้งาน',
  'pluginsView.sourceUrl': 'Source URL',
  'pluginsView.defaultTrust': 'ความเชื่อถือเริ่มต้น',
  'pluginsView.trust.restricted': 'จำกัด',
  'pluginsView.trust.trusted': 'เชื่อถือได้',
  'pluginsView.trust.official': 'ทางการ',
  'pluginsView.adding': 'กำลังเพิ่ม…',
  'pluginsView.addSource': 'เพิ่มแหล่งที่มา',
  'pluginsView.sourcesEmpty': 'ยังไม่ได้กำหนดค่าแหล่งที่มาของ registry',
  'pluginsView.pluginsCount': '{n} ปลั๊กอิน',
  'pluginsView.catalogVersion': 'แค็ตตาล็อก v{version}',
  'pluginsView.trustFor': 'ความเชื่อถือสำหรับ {name}',
  'pluginsView.refreshing': 'กำลังรีเฟรช…',
  'pluginsView.removing': 'กำลังลบ…',
  'pluginsView.teamTitle': 'Marketplace ของทีมส่วนตัว',
  'pluginsView.teamBody': 'พื้นที่นี้สงวนไว้สำหรับแค็ตตาล็อกขององค์กรและทีม นโยบายความเชื่อถือส่วนตัว และการควบคุมวงจรชีวิตของ plugin ที่แชร์ร่วมกัน',
  'pluginCard.details': 'รายละเอียด',
  'pluginCard.use': 'ใช้งาน',
  'pluginCard.useWithQuery': 'ใช้งานพร้อมคำค้นหา',
  'pluginCard.applying': 'กำลังปรับใช้…',
  'pluginCard.publish': 'เผยแพร่',
  'pluginCard.contribute': 'ร่วมสนับสนุน',
  'pluginCard.starting': 'กำลังเริ่ม…',
  'pluginCard.detailsAria': 'ดูรายละเอียดของ {title}',
  'pluginCard.chooseUseAria': 'เลือกวิธีใช้งาน {title}',
  'pluginCard.useOptionsAria': 'ตัวเลือกการใช้งานสำหรับ {title}',
  'pluginCard.shareAria': 'แชร์ {title}',
  'pluginCard.publishAria': 'เผยแพร่ {title} เป็น GitHub repository',
  'pluginCard.publishTitle': 'เผยแพร่ plugin เป็น GitHub repository',
  'pluginCard.contributeAria': 'ร่วมสนับสนุน {title} ให้กับ Gini Studio',
  'pluginCard.contributeTitle': 'ร่วมสนับสนุน plugin ให้กับ Gini Studio ด้วย pull request',
  'skillPluginCandidate.createForMe': 'สร้างให้ฉัน',
  'skillPluginCandidate.contributeToMain': 'ร่วมสนับสนุนไปยัง main',
  'skillPluginCandidate.publishRepo': 'เผยแพร่ repo',
  'skillPluginCandidate.dismiss': 'ปิด',
  'skillPluginCandidate.repoDescription': 'repo นี้ดูเหมือนจะใช้งานเป็น plugin ได้',
  'integrations.kicker': 'การผสานรวม',
  'integrations.lede': 'เชื่อมต่อระบบภายนอก นำเครื่องมือ MCP เข้าสู่ลูปของ Agent และใช้งาน Gini Studio จาก IDE สคริปต์ และระบบอัตโนมัติอื่น ๆ',
  'integrations.agentReady': 'พร้อมสำหรับ Agent',
  'integrations.areasAria': 'พื้นที่การผสานรวม',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'เครื่องมือภายนอก',
  'integrations.tabHint.connectors': 'บัญชีและ API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'การผสานรวม Skills',
  'integrations.skillsBody': 'การจัดการการผสานรวมระดับ Skill กำลังถูกย้ายมาจากอีก branch หนึ่ง แท็บนี้สงวนไว้เพื่อให้การตั้งค่า MCP, Connectors และ Skills ในอนาคตอยู่ในเส้นทาง Integration เดียวกัน',
  'mcpClient.title': 'เซิร์ฟเวอร์ MCP ภายนอก',
  'mcpClient.subtitle': 'เครื่องมือจากภายนอกสำหรับ Agent เขียนโค้ดของคุณ',
  'mcpClient.addServer': 'เพิ่มเซิร์ฟเวอร์',
  'mcpClient.emptyTitle': 'ยังไม่ได้กำหนดค่าเซิร์ฟเวอร์ MCP',
  'mcpClient.emptyBody': 'คลิก "Add server" เพื่อเริ่มต้น — เลือกเทมเพลต (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) หรือตั้งค่าเซิร์ฟเวอร์ stdio / HTTP แบบกำหนดเอง',
  'mcpClient.saveChanges': 'บันทึกการเปลี่ยนแปลง',
  'mcpClient.storedAt': 'จัดเก็บที่',
  'mcpClient.daemonError': 'ไม่สามารถเชื่อมต่อกับ daemon ภายในเครื่องได้ โปรดตรวจสอบว่า Gini Studio กำลังทำงานอยู่ จากนั้นเปิดแผงนี้อีกครั้ง',
  'mcpClient.saveFailed': 'บันทึกไม่สำเร็จ โปรดตรวจสอบว่า daemon กำลังทำงานอยู่ แล้วลองอีกครั้ง',
  'useEverywhere.modalAria': 'ใช้ Gini Studio ได้ทุกที่',
  'useEverywhere.modalTitle': 'ใช้ Gini Studio ได้ทุกที่',
  'useEverywhere.modalSubtitle': 'นำ Gini Studio ไปใช้ใน IDE, Agent หรือสคริปต์ใดก็ได้ — CLI, HTTP, MCP และ Skills ใช้ “Copy guide for an agent” แล้ววางลงใน local coding agents, Codex, Cursor, openclaw หรือ hermes เพื่อตั้งค่าทุกอย่าง',
  'useEverywhere.closeAria': 'ปิดการใช้งานทุกที่',
  'useEverywhere.closeTitle': 'ปิด (Esc)',
  'useEverywhere.tabsAria': 'พื้นผิวการผสานรวม',
  'useEverywhere.footStrong': 'ส่งต่อด้วยคลิกเดียว',
  'useEverywhere.footBody': 'คัดลอกคู่มือ markdown แบบมีโครงสร้างที่ Agent ของคุณนำไปใช้งานได้ทันที — ติดตั้ง ตรวจสอบ และใช้งาน',
  'useEverywhere.configureMcp': 'กำหนดค่าเซิร์ฟเวอร์ MCP',
  'useEverywhere.copyGuide': 'คัดลอกคู่มือสำหรับ Agent',
  'useEverywhere.copy': 'คัดลอก',
  'useEverywhere.copied': 'คัดลอกแล้ว',
  'useEverywhere.copyFailed': 'คัดลอกไม่สำเร็จ',
  'useEverywhere.copySnippetAria': 'คัดลอกสนิปเพ็ต: {label}',
  'useEverywhere.section.overview.tab': 'ภาพรวม',
  'useEverywhere.section.overview.heading': 'Gini Studio ทำงานได้ทุกที่ที่ agent ของคุณทำงาน',
  'useEverywhere.section.overview.intro': 'Gini Studio เป็นมากกว่าหน้าต่าง — มันคือ daemon ที่มีสิทธิ์พิเศษบนเครื่อง (`od`) บวกกับ registry ของ Skills + Design-Systems + Atoms เมื่อมันทำงานอยู่บนเครื่องของคุณ code agent ใดก็ตาม (local coding agents, Codex, Cursor, OpenCode/openclaw, Hermes หรือสคริปต์ของคุณเอง) สามารถสั่งการสร้างงาน ตรวจสอบโปรเจกต์ และผลิต design artifact ผ่านสี่ส่วนติดต่อที่ใช้แทนกันได้',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` สำหรับสคริปต์แบบ headless, CI และการทำงานอัตโนมัติบน shell',
  'useEverywhere.section.overview.bullet2': 'MCP server — เชื่อม Gini Studio ให้เป็นเซิร์ฟเวอร์ Model Context Protocol เพื่อให้ Agent ที่รองรับ MCP สามารถแสดงรายการ skills, รัน scenario และอ่าน artifact ได้',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` endpoint แบบ REST + SSE; เป็นส่วนติดต่อเดียวกับที่ web UI ใช้',
  'useEverywhere.section.overview.bullet4': 'Skills — แพ็ก `SKILL.md` แบบ drop-in (รองรับ Claude) ที่ Agent ใดก็ตามซึ่งอยู่ใน PATH ของคุณสามารถเรียกใช้ได้โดยไม่ต้องมี Gini Studio เลย',
  'useEverywhere.section.overview.bullet5': 'Artifact มาตรฐาน — สร้างโปรเจกต์ HTML จริงจาก Skills, ปลั๊กอินเริ่มต้นที่มาพร้อมกัน และตัวอย่างปลั๊กอินจากชุมชนก่อนที่ daemon จะเริ่มทำงาน',
  'useEverywhere.section.overview.snippet1': 'เริ่ม daemon (และ web UI) ในเครื่อง',
  'useEverywhere.section.overview.snippet2': 'ยืนยันว่าเข้าถึงได้',
  'useEverywhere.section.overview.snippet3': 'นำเข้าอาร์ติแฟกต์มาตรฐานก่อนบูต',
  'useEverywhere.section.overview.footer': 'โดยค่าเริ่มต้น daemon จะเขียนไปที่ `./.od/` (เฉพาะโปรเจกต์) ตั้งค่า `OD_DATA_DIR=~/.open-design` เพื่อแชร์ข้อมูลข้ามโปรเจกต์',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'ควบคุม Gini Studio จาก shell ใดก็ได้',
  'useEverywhere.section.cli.intro': 'ไบนารี `od` มาพร้อมกับ daemon และเป็นไบนารีเดียวกันกับที่ local coding agents / Codex ใช้เมื่อรันการสร้าง ซับคำสั่งส่วนใหญ่เป็นไคลเอนต์ขนาดเล็กที่ POST ไปยัง daemon ในเครื่อง จึงทำงานเหมือนกันไม่ว่าคุณจะเปิดใช้ผ่าน `pnpm tools-dev` หรือในรูปแบบแอปแพ็กเกจ',
  'useEverywhere.section.cli.bullet1': '`od` (ไม่มี args) — บูต daemon และเปิด web UI',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — ผลิตข้อมูลไบต์ของรูปภาพ / วิดีโอ / เสียงผ่าน media protocol แบบรวมศูนย์',
  'useEverywhere.section.cli.bullet3': '`od run ...` — เริ่มการรันโปรเจกต์จาก prompt + skill',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — ติดตั้งและปรับใช้ปลั๊กอินจากชุมชน',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — ตรวจสอบสิ่งที่มีอยู่ในเครื่อง',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — ตรวจสอบสถานะของ daemon และตรวจหา agent CLIs ใน PATH ของคุณ',
  'useEverywhere.section.cli.snippet1': 'สร้างรูปภาพ (มอบหมายให้ media provider ที่ตั้งค่าไว้)',
  'useEverywhere.section.cli.snippet2': 'รัน scenario plugin แบบ headless และสตรีมอีเวนต์เป็นบรรทัด JSON',
  'useEverywhere.section.cli.snippet3': 'แสดงรายการสกิลและ design system ที่มีในเครื่อง',
  'useEverywhere.section.cli.snippet4': 'ตรวจสอบอาร์ติแฟกต์ที่ซีดไว้ผ่าน CLI',
  'useEverywhere.section.cli.snippet5': 'ตรวจสอบสภาพแวดล้อม + Agent ที่ตรวจพบ (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'คำสั่งย่อยทั้งหมดรองรับ `--daemon-url http://127.0.0.1:<port>` เพื่อกำหนดเป้าหมายเป็น daemon ที่กำลังทำงานอยู่ — มีประโยชน์เมื่อรันอินสแตนซ์ที่สองแบบ sandbox สำหรับการทดสอบ',
  'useEverywhere.section.mcp.tab': 'เซิร์ฟเวอร์ MCP',
  'useEverywhere.section.mcp.heading': 'เปิดเผย Gini Studio เป็นเซิร์ฟเวอร์ MCP ให้กับ coding agent ใดก็ได้',
  'useEverywhere.section.mcp.intro': 'Gini Studio มาพร้อมกับเซิร์ฟเวอร์ Model Context Protocol (`od mcp`) ที่ให้ client ใดก็ตามซึ่งรองรับ MCP — Cursor, local coding agents, Antigravity, VS Code Copilot Chat, openclaw, hermes — ค้นพบเครื่องมือของ Gini Studio (แสดงรายการ skills, เรนเดอร์ตัวอย่าง, สร้างมีเดีย, รันปลั๊กอิน) ได้โดยไม่ต้องเรียกผ่าน shell เอง daemon จะเผยแพร่ snippet การติดตั้งที่พร้อมวางผ่าน `GET /api/mcp/install-info` สำหรับ client หลักแต่ละตัว',
  'useEverywhere.section.mcp.bullet1': 'Stdio transport — ไม่ต้องใช้พอร์ตเพิ่ม client จะ spawn `od mcp` โดยตรง',
  'useEverywhere.section.mcp.bullet2': 'ค้นหา URL ของ daemon ที่ทำงานอยู่โดยอัตโนมัติผ่าน IPC status socket ในเครื่องเมื่อเปิดใช้เป็น sidecar',
  'useEverywhere.section.mcp.bullet3': 'ใช้ `--daemon-url http://127.0.0.1:<port>` เป็นตัวสำรองสำหรับการติดตั้งแบบทั่วไป เพื่อให้กระบวนการ MCP พบ daemon ที่ทำงานอยู่เสมอ',
  'useEverywhere.section.mcp.bullet4': 'ตรึง `OD_DATA_DIR` เพื่อให้กระบวนการ MCP ที่ถูกสร้างขึ้นเขียนไปยังตำแหน่งเดียวกันกับที่ daemon ใช้อยู่แล้ว (หลีกเลี่ยง EPERM ในแอปบันเดิลแพ็กเกจของ macOS)',
  'useEverywhere.section.mcp.snippet1': 'การตั้งค่า MCP client แบบทั่วไป (ใช้ได้ใน Cursor, local coding agents, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'หรือ: ขอสนิปเพ็ตที่ปรับให้เหมาะกับการติดตั้งของคุณจาก daemon',
  'useEverywhere.section.mcp.snippet3': 'ตัวแปร MCP แบบ Live-artifacts (อ่านและรีเฟรช dashboard)',
  'useEverywhere.section.mcp.footer': 'ในแอป Gini Studio ให้เปิด Settings → Integrations เพื่อคัดลอกคำสั่งติดตั้งเฉพาะ client (Cursor, local coding agents, Antigravity, VS Code) แทนการแก้ไข JSON ด้วยมือ',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'REST + SSE surface เดียวกันกับที่ web UI ใช้',
  'useEverywhere.section.http.intro': 'daemon ในเครื่องให้บริการ HTTP API ที่ `http://127.0.0.1:7456` (กำหนดพอร์ตได้) ทุก endpoint ที่ web UI เรียกใช้สามารถใช้กับสคริปต์ของคุณได้เช่นกัน endpoint แบบสตรีมมิง (chat turn, project run) จะส่ง Server-Sent Events พร้อมชนิดตามสัญญาใน `@open-design/contracts`',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — สถานะการทำงานของ daemon',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` และ `GET /api/design-systems` — registry ที่มีให้ใช้งาน',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` และ `POST /api/projects` — แสดงรายการและสร้างโปรเจกต์ (POST จะคืนค่าโปรเจกต์ + บทสนทนาแรก)',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — สตรีม SSE ของเหตุการณ์ Agent สำหรับบทสนทนา',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — ผูกปลั๊กอินที่ติดตั้งไว้และรับ query ตัวอย่างที่เรนเดอร์แล้ว + อินพุต',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — code-agent CLIs ที่ตรวจพบใน PATH ของคุณ',
  'useEverywhere.section.http.snippet1': 'แสดงรายการสกิลที่ติดตั้งไว้ (agent จะใช้สิ่งเหล่านี้เป็นเทมเพลต)',
  'useEverywhere.section.http.snippet2': 'สร้างโปรเจกต์จากพรอมต์ (โฟลว์ฝั่งเซิร์ฟเวอร์แบบเต็ม)',
  'useEverywhere.section.http.snippet3': 'สตรีมรอบการสนทนาหนึ่งครั้ง (SSE — แต่ละบรรทัดเข้ากันได้กับ JSON-Lines)',
  'useEverywhere.section.http.footer': 'ไทป์ TypeScript ล้วนสำหรับทุก request/response อยู่ใน `@open-design/contracts` — import เข้าสคริปต์ของคุณเพื่อ autocomplete เต็มรูปแบบโดยไม่ต้องตั้งค่า generator',
  'useEverywhere.section.skills.tab': 'สกิลและ headless',
  'useEverywhere.section.skills.heading': 'Skills แบบ drop-in สำหรับ Agent ใดก็ตาม — แม้ไม่ได้รัน Gini Studio อยู่',
  'useEverywhere.section.skills.intro': 'Skill คือไดเรกทอรีที่มี `SKILL.md` ซึ่งรองรับ Claude (YAML front-matter + เนื้อหา) Gini Studio ขยายรูปแบบด้วย namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) เพื่อให้ artifact เดียวกันใช้งานได้ทั้งภายใน Gini Studio และโดย Agent ทั่วไปอย่าง local coding agents, Codex, openclaw หรือ hermes การค้นพบจะเป็นไปตามลำดับความสำคัญเพื่อให้โปรเจกต์สามารถแทนที่ skills ของตัวเองได้',
  'useEverywhere.section.skills.bullet1': 'การค้นพบ: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (โปรเจกต์ชนะ)',
  'useEverywhere.section.skills.bullet2': 'Symlink สกิลหนึ่งเข้าไปในหลายโปรเจกต์เพื่อแชร์โดยไม่ต้องคัดลอก',
  'useEverywhere.section.skills.bullet3': 'แต่ละสกิลสามารถประกาศ connector, atom, ข้อกำหนด design-system และตัวอย่างผลลัพธ์ `preview` สำหรับแกลเลอรีได้',
  'useEverywhere.section.skills.bullet4': 'Headless: agent ที่มี `od` อยู่ใน PATH สามารถเรียก `od skills list` แล้วรันสกิลใดก็ได้ ส่วน daemon เป็นตัวเลือกสำหรับโฟลว์แบบอ่านอย่างเดียว',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` ทดสอบรูปแบบอาร์ติแฟกต์เดียวกันด้วยตัวอย่าง plugin เริ่มต้นและตัวอย่าง plugin จากชุมชน จากนั้นเก็บโปรเจกต์ `index.html` ที่ได้เป็นข้อมูลทดสอบที่นำกลับมาใช้ใหม่ได้',
  'useEverywhere.section.skills.snippet1': 'SKILL.md แบบขั้นต่ำ (front matter ที่เข้ากันได้กับ Claude + ส่วนเสริมของ Gini Studio)',
  'useEverywhere.section.skills.snippet2': 'Symlink สกิลที่แชร์ไว้เข้าไปในโปรเจกต์ (สไตล์ cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: แสดงรายการสกิลที่ daemon เห็นในตอนนี้',
  'useEverywhere.section.skills.snippet4': 'บันเดิล fixture ของอาร์ติแฟกต์แบบ headless',
  'useEverywhere.section.skills.footer': 'ข้อกำหนด: `docs/skills-protocol.md` และ `docs/agent-adapters.md` ครอบคลุม adapter surface ทั้งหมด (local coding agents, Codex, Cursor, agent ที่รองรับ MCP, การสำรองด้วย BYOK API) และกลยุทธ์การฉีดสกิลแยกตาม adapter',
  'tasks.kicker': 'เวิร์กสเปซระบบอัตโนมัติ',
  'tasks.comingSoon': 'เร็วๆ นี้',
  'tasks.lede': 'ระบบอัตโนมัติเปลี่ยนพรอมต์ให้เป็นงานที่คงทน: Orbit รันงานเหล่านั้น routine คอยเก็บรักษาไว้ schedule ตัดสินใจว่าจะทำงานเมื่อใด และ live artifact แสดงสิ่งที่เปลี่ยนไป',
  'tasks.newAutomation': 'ระบบอัตโนมัติใหม่',
  'tasks.previewNote': 'เป็นเพียงพื้นผิวพรีวิวเท่านั้น การตั้งค่า Orbit ใช้ได้แล้ววันนี้ ส่วน routine, schedule และการเชื่อมต่อ live artifact จะมาเมื่อ branch ฝั่งแบ็กเอนด์ถูกผสานเข้ามา',
  'tasks.primitivesAria': 'องค์ประกอบพื้นฐานของระบบอัตโนมัติ',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'รันไทม์ที่คงอยู่ถาวรสำหรับงาน agent ที่ทำงานยาวนานหรือทำซ้ำ',
  'tasks.primitive.orbit.enabled': 'เปิดใช้สรุปประจำวันแล้ว',
  'tasks.primitive.orbit.manualOnly': 'แบบแมนนวลเท่านั้น',
  'tasks.primitive.routines.title': 'รูทีน',
  'tasks.primitive.routines.body': 'คำนิยามงานที่คงทนซึ่งยังคงอยู่หลังจากแชตเดียวจบลง',
  'tasks.primitive.routines.meta': 'Product shell พร้อมแล้ว',
  'tasks.primitive.schedules.title': 'กำหนดการ',
  'tasks.primitive.schedules.body': 'ทริกเกอร์ตามเวลาหรืออีเวนต์ที่ตัดสินใจว่า routine ควรทำงานเมื่อใด',
  'tasks.primitive.schedules.meta': 'รอ branch',
  'tasks.primitive.liveArtifacts.title': 'อาร์ติแฟกต์แบบเรียลไทม์',
  'tasks.primitive.liveArtifacts.body': 'รายงานและบันทึกที่อัปเดตต่อเนื่องในขณะที่ agent ทำงาน',
  'tasks.primitive.liveArtifacts.meta': 'โมเดลพรีวิว',
  'tasks.listAria': 'รายการระบบอัตโนมัติ',
  'tasks.routinesAndRuns': '{n} routine และการรัน',
  'tasks.filtersAria': 'ตัวกรองระบบอัตโนมัติ',
  'tasks.filter.scheduled': 'ตั้งเวลาแล้ว',
  'tasks.filter.running': 'กำลังทำงาน',
  'tasks.filter.done': 'เสร็จสิ้น',
  'tasks.configurationAria': 'การตั้งค่าระบบอัตโนมัติ',
  'tasks.slot.trigger': 'ทริกเกอร์',
  'tasks.slot.pattern': 'รูปแบบ',
  'tasks.slot.runtime': 'รันไทม์',
  'tasks.slot.output': 'เอาต์พุต',
  'tasks.liveArtifact': 'อาร์ติแฟกต์แบบเรียลไทม์',
  'tasks.viewProgress': 'ดูความคืบหน้า',
  'tasks.pause': 'หยุดชั่วคราว',
  'tasks.runNow': 'เรียกใช้ทันที',
  'tasks.openArtifact': 'เปิดอาร์ติแฟกต์',
  'tasks.status.dailyAt': 'รายวัน · {time}',
  'tasks.status.pausedManual': 'หยุดชั่วคราว · เฉพาะแบบกำหนดเอง',
  'tasks.sample.orbit.title': 'สรุป Connector ประจำวันของ Orbit',
  'tasks.sample.orbit.metaEnabled': 'กำหนดเวลาสรุป Connector แล้ว',
  'tasks.sample.orbit.metaDisabled': 'เปิดการตั้งค่า Orbit เพื่อเปิดใช้งาน',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artifact แบบเรียลไทม์',
  'tasks.sample.orbit.previewDisabled': 'ไม่มีการกำหนดเวลาเรียกใช้',
  'tasks.sample.orbit.triggerEnabled': 'กำหนดเวลา · รายวันเวลา {time}',
  'tasks.sample.orbit.triggerDisabled': 'กำหนดเอง · รันตามต้องการ',
  'tasks.sample.orbit.pattern': 'กิจวัตร · สรุปจาก connector',
  'tasks.sample.orbit.runtime': 'Orbit · ตั้งเวลา daemon แล้ว',
  'tasks.sample.orbit.output': 'Artifact สด · รายงานที่รีเฟรชได้',
  'tasks.sample.orbit.artifactMetaEnabled': 'รีเฟรชหลังการเรียกใช้แต่ละครั้ง',
  'tasks.sample.orbit.artifactMetaDisabled': 'กำลังรอกำหนดเวลา',
  'tasks.sample.orbit.body1': '# สรุปกิจกรรมประจำวันของ Orbit',
  'tasks.sample.orbit.body2': 'ตรวจสอบ connector แล้ว · สำเร็จ, ข้าม และล้มเหลว',
  'tasks.sample.orbit.body3': 'ไฮไลต์จะกลายเป็นอาร์ติแฟกต์แบบเรียลไทม์ที่รีเฟรชได้',
  'tasks.sample.mcp.title': 'การวิจัยทางเลือกของ MCP',
  'tasks.sample.mcp.status': 'กำลังทำงานใน orbit · 2 ชม. 14 น.',
  'tasks.sample.mcp.meta': 'ประมวลผลแหล่งข้อมูลแล้ว 14 / 30 แหล่ง',
  'tasks.sample.mcp.preview': 'research_notes.md · สด',
  'tasks.sample.mcp.trigger': 'ด้วยตนเอง · ครั้งเดียว',
  'tasks.sample.mcp.pattern': 'พรอมต์การวิจัยเชิงลึก',
  'tasks.sample.mcp.runtime': 'ระยะไกล · ถาวร',
  'tasks.sample.mcp.output': 'รายงานสด · อัปเดตอัตโนมัติ',
  'tasks.sample.mcp.artifactMeta': 'อัปเดตเมื่อ 12 วินาทีที่แล้ว',
  'tasks.sample.mcp.body1': '# ทางเลือกของ MCP - ผลการวิเคราะห์เบื้องต้น',
  'tasks.sample.mcp.body2': 'ตรวจสอบแล้ว 14 แหล่ง · คัดเลือก 3 ตัวเต็ง',
  'tasks.sample.mcp.body3': '## รายชื่อที่คัดเลือก',
  'tasks.sample.mcp.body4': '- สคีมาการเรียกใช้เครื่องมือผ่าน JSON-RPC...',
  'tasks.sample.mcp.body5': '- โปรโตคอล Agent ที่ใช้ gRPC...',
  'tasks.sample.weekly.title': 'สรุปทีมประจำสัปดาห์',
  'tasks.sample.weekly.status': 'ครั้งถัดไป: จันทร์ 9:00 น.',
  'tasks.sample.weekly.meta': 'อัปเดตเอกสารประจำสัปดาห์ของทีม',
  'tasks.sample.weekly.preview': 'team_weekly.md · artifact ถัดไป',
  'tasks.sample.weekly.trigger': 'กำหนดเวลา · รายสัปดาห์',
  'tasks.sample.weekly.pattern': 'กิจวัตร · สรุปของทีม',
  'tasks.sample.weekly.runtime': 'ระยะไกล · ทำซ้ำ',
  'tasks.sample.weekly.output': 'Artifact สด · markdown',
  'tasks.sample.weekly.artifactMeta': 'อัปเดตล่าสุดเมื่อ 4 วันที่แล้ว',
  'tasks.sample.weekly.body1': '# ทีมประจำสัปดาห์',
  'tasks.sample.weekly.body2': '## กำลังดำเนินการ',
  'tasks.sample.weekly.body3': '- รอบการผสานรวมระบบดีไซน์',
  'tasks.sample.weekly.body4': '- การตรวจสอบคุณภาพ Connector',
  'tasks.sample.weekly.body5': '## ความเสี่ยง',
  'tasks.sample.pr.title': 'การแจ้งเตือนรีวิว PR',
  'tasks.sample.pr.status': 'เมื่อมี PR ใหม่ · ทำงานไปเมื่อ 23 น. ที่แล้ว',
  'tasks.sample.pr.meta': 'ส่งข้อความตรงทาง Slack',
  'tasks.sample.pr.preview': 'การส่งครั้งล่าสุดสำเร็จ',
  'tasks.sample.pr.trigger': 'เหตุการณ์ · PR ใหม่',
  'tasks.sample.pr.pattern': 'กิจวัตร · การแจ้งเตือน',
  'tasks.sample.pr.runtime': 'ในเครื่อง · รันด่วน',
  'tasks.sample.pr.output': 'ข้อความ · Slack DM',
  'tasks.sample.pr.artifactMeta': 'เรียกใช้ครั้งล่าสุดเมื่อ 23 นาทีที่แล้ว',
  'tasks.sample.pr.body1': 'เปิด PR #184 เพื่อรีวิว',
  'tasks.sample.pr.body2': 'ผู้รีวิวที่ตรงกัน: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'การส่ง: ส่งข้อความตรงทาง Slack แล้ว',
  'tasks.sample.meeting.title': 'การเตรียมตัวก่อนการประชุม',
  'tasks.sample.meeting.status': 'พรุ่งนี้ · 10:00 น.',
  'tasks.sample.meeting.meta': 'ครั้งเดียว · ส่งสรุป',
  'tasks.sample.meeting.preview': 'meeting_brief.md · อยู่ในคิว',
  'tasks.sample.meeting.trigger': 'กำหนดเวลา · ครั้งเดียว',
  'tasks.sample.meeting.pattern': 'พรอมต์สรุปบรีฟ',
  'tasks.sample.meeting.runtime': 'ระยะไกล · จำกัด',
  'tasks.sample.meeting.output': 'อาร์ติแฟกต์ + ข้อความ',
  'tasks.sample.meeting.artifactMeta': 'อยู่ในคิวสำหรับการสร้าง',
  'tasks.sample.meeting.body1': '# บรีฟการประชุม',
  'tasks.sample.meeting.body2': 'แหล่งวาระการประชุม: กิจกรรมในปฏิทิน + เอกสารที่เชื่อมโยง',
  'tasks.sample.meeting.body3': 'เอาต์พุตจะประกอบด้วยการตัดสินใจ ปัญหาที่ติดขัด และคำถาม',
  'tasks.sample.candidate.title': 'การติดตามผู้สมัคร',
  'tasks.sample.candidate.status': 'ล้มเหลว · ต้องการความสนใจ',
  'tasks.sample.candidate.meta': 'การยืนยันตัวตนหมดอายุ',
  'tasks.sample.candidate.preview': 'เชื่อมต่อ Greenhouse อีกครั้งเพื่อดำเนินการต่อ',
  'tasks.sample.candidate.trigger': 'กำหนดเวลา · รายวัน',
  'tasks.sample.candidate.pattern': 'กิจวัตร · ซิงก์ผู้สมัคร',
  'tasks.sample.candidate.runtime': 'ระยะไกล · ทำซ้ำ',
  'tasks.sample.candidate.output': 'Artifact สด · ตาราง',
  'tasks.sample.candidate.artifactMeta': 'หยุดชั่วคราวจนกว่าการยืนยันตัวตนจะกลับมาใช้งานได้',
  'tasks.sample.candidate.body1': '# ไปป์ไลน์ผู้สมัคร',
  'tasks.sample.candidate.body2': 'การซิงค์สำเร็จครั้งล่าสุด: 2 วันที่แล้ว',
  'tasks.sample.candidate.body3': 'ต้องดำเนินการ: เชื่อมต่อบัญชีแหล่งข้อมูลอีกครั้ง',
  'routines.title': 'ระบบอัตโนมัติ',
  'routines.subtitle': 'ระบบอัตโนมัติที่กำหนดเวลาไว้ซึ่งทำงานโดยไม่ต้องดูแล',
  'routines.newAutomation': 'ระบบอัตโนมัติใหม่',
  'routines.loading': 'กำลังโหลด…',
  'routines.empty': 'ยังไม่มีการทำงานอัตโนมัติ',
  'routines.emptyHint': 'คลิก สร้างการทำงานอัตโนมัติ เพื่อตั้งเวลาให้ Agent ทำงานแบบไม่ต้องดูแล',
  'routines.runHistoryLoading': 'กำลังโหลดการทำงาน…',
  'routines.runHistoryEmpty': 'ยังไม่มีการรัน',
  'routines.fieldName': 'ชื่อ',
  'routines.fieldNamePlaceholder': 'สรุปข่าวประจำเช้า',
  'routines.fieldPrompt': 'พรอมต์',
  'routines.fieldPromptPlaceholder': 'ดึงกิจกรรม GitHub + Linear ของเมื่อวานและสรุปสิ่งที่เปลี่ยนแปลง',
  'routines.fieldSchedule': 'กำหนดเวลา',
  'routines.fieldMinute': 'นาทีของทุกชั่วโมง',
  'routines.fieldTime': 'เวลา',
  'routines.fieldTimezone': 'เขตเวลา',
  'routines.fieldsetProject': 'โปรเจกต์',
  'routines.kind.hourly': 'ทุกชั่วโมง',
  'routines.kind.daily': 'ทุกวัน',
  'routines.kind.weekdays': 'วันธรรมดา',
  'routines.kind.weekly': 'ทุกสัปดาห์',
  'routines.weekday.short.0': 'อา.',
  'routines.weekday.short.1': 'จ.',
  'routines.weekday.short.2': 'อ.',
  'routines.weekday.short.3': 'พ.',
  'routines.weekday.short.4': 'พฤ.',
  'routines.weekday.short.5': 'ศ.',
  'routines.weekday.short.6': 'ส.',
  'routines.weekday.long.0': 'วันอาทิตย์',
  'routines.weekday.long.1': 'วันจันทร์',
  'routines.weekday.long.2': 'วันอังคาร',
  'routines.weekday.long.3': 'วันพุธ',
  'routines.weekday.long.4': 'วันพฤหัสบดี',
  'routines.weekday.long.5': 'วันศุกร์',
  'routines.weekday.long.6': 'วันเสาร์',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'รันทุกชั่วโมงเมื่อถึงนาทีที่ :{minute}',
  'routines.describe.daily': 'รันทุกวันเวลา {time} {tz}',
  'routines.describe.weekdays': 'ทำงานทุกวันจันทร์–ศุกร์ เวลา {time} {tz}',
  'routines.describe.weekly': 'รันทุก{day}เวลา {time} {tz}',
  'routines.modeCreate': 'สร้างโปรเจกต์ใหม่ทุกครั้งที่รัน',
  'routines.modeCreateHint': 'พื้นที่ทำงานใหม่ที่แยกอิสระในแต่ละครั้งที่ทำงาน',
  'routines.modeReuse': 'ใช้โปรเจกต์ที่มีอยู่เดิม',
  'routines.modeReuseHint': 'การรันแต่ละครั้งจะเป็นการสนทนาใหม่ภายในโปรเจกต์',
  'routines.pickProject': '— เลือกโปรเจกต์ —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ โปรเจกต์ใหม่ทุกครั้งที่ทำงาน',
  'routines.tagPaused': 'หยุดชั่วคราว',
  'routines.metaNext': 'ครั้งถัดไป: {when}',
  'routines.metaLast': 'ครั้งล่าสุด:',
  'routines.triggerManual': 'ด้วยตนเอง',
  'routines.triggerScheduled': 'ตามกำหนดเวลา',
  'routines.openProject': 'เปิดโปรเจกต์',
  'routines.openProjectTitle': 'เปิดโปรเจกต์ที่การรันนี้บันทึกข้อมูลลงไป',
  'routines.runNow': 'รันตอนนี้',
  'routines.edit': 'แก้ไข',
  'routines.pause': 'หยุดชั่วคราว',
  'routines.resume': 'ดำเนินการต่อ',
  'routines.history': 'ประวัติ',
  'routines.hideHistory': 'ซ่อนประวัติ',
  'routines.delete': 'ลบ',
  'routines.deleteTitle': 'ลบการทำงานอัตโนมัตินี้',
  'routines.cancel': 'ยกเลิก',
  'routines.save': 'บันทึก',
  'routines.saving': 'กำลังบันทึก…',
  'routines.create': 'สร้าง',
  'routines.creating': 'กำลังสร้าง…',
  'routines.status.queued': 'อยู่ในคิว',
  'routines.status.running': 'กำลังรัน',
  'routines.status.succeeded': 'สำเร็จ',
  'routines.status.failed': 'ล้มเหลว',
  'routines.status.canceled': 'ยกเลิกแล้ว',
  'routines.confirmDelete': 'ลบการทำงานอัตโนมัตินี้หรือไม่? การรันที่ผ่านมาและโปรเจกต์ของการรันเหล่านั้นจะยังคงอยู่',
  'routines.errorPickProject': 'เลือกโปรเจกต์เพื่อใช้ซ้ำ หรือสลับไปที่ “สร้างใหม่ทุกครั้งที่ทำงาน”',
  'routines.errorAgentEmptyOutput': 'Agent ทำงานเสร็จโดยไม่ได้สร้างผลลัพธ์ใดๆ โมเดลหรือผู้ให้บริการอาจส่งคืนการตอบสนองที่ว่างเปล่า — ตรวจสอบบันทึกของ agent เพื่อหาข้อผิดพลาดจากต้นทาง',
  'entry.helpAria': 'ช่วยเหลือ',
  'entry.helpMenuAria': 'เมนูช่วยเหลือ',
  'entry.helpGetHelp': 'ขอความช่วยเหลือบน GitHub',
  'entry.helpSubmitFeature': 'ส่งคำขอฟีเจอร์',
  'entry.helpWhatsNew': 'มีอะไรใหม่',
  'entry.helpDownloadDesktop': 'ดาวน์โหลดแอปเดสก์ท็อป',
  'entry.tabImageTemplates': 'เทมเพลตภาพ',
  'entry.tabVideoTemplates': 'เทมเพลตวิดีโอ',
  'promptTemplates.searchPlaceholder': 'ค้นหาเทมเพลต…',
  'promptTemplates.countLabel': '{n} ผลลัพธ์',
  'promptTemplates.emptyImage': 'ยังไม่ได้ติดตั้งเทมเพลตคำสั่งภาพ',
  'promptTemplates.emptyVideo': 'ยังไม่ได้ติดตั้งเทมเพลตคำสั่งวิดีโอ',
  'promptTemplates.emptyNoMatch': 'ไม่พบเทมเพลตที่ตรงกับการค้นหา',
  'promptTemplates.attributionFooter': 'ดัดแปลงมาจากห้องสมุดคำสั่งสาธารณะ',
  'promptTemplates.openPreviewTitle': 'เปิดคำสั่งและดูตัวอย่าง',
  'promptTemplates.sourcePrefix': 'แหล่งที่มา:',
  'promptTemplates.fetchError': 'ไม่สามารถโหลดเนื้อหาเทมเพลตนี้',
  'promptTemplates.promptLabel': 'เนื้อหาคำสั่ง',
  'promptTemplates.copyPrompt': 'คัดลอกคำสั่ง',
  'promptTemplates.copyDone': 'คัดลอกแล้ว!',
  'promptTemplates.modelHint': 'โมเดลที่แนะนำ: {model}',
  'promptTemplates.openSource': 'ดูต้นฉบับ',
  'promptTemplates.openFullscreen': 'เปิดแสดงผลเต็มหน้าจอ',
  'promptTemplates.closeFullscreen': 'ปิดแสดงผลเต็มหน้าจอ',
  'promptTemplates.allSources': 'ทุกแหล่งที่มา',
  'promptTemplates.sourceFilterAria': 'กรองตามแหล่งที่มา',
  'promptTemplates.retry': 'ลองใหม่',
  'connectors.title': 'ตัวเชื่อมต่อ',
  'connectors.subtitle': 'แหล่งข้อมูลที่สามารถใช้ใน live artifacts',
  'connectors.account': 'บัญชี',
  'connectors.noAccount': 'ไม่ได้เชื่อมต่อ',
  'connectors.tools': 'เครื่องมือ',
  'connectors.connect': 'เชื่อมต่อ',
  'connectors.disconnect': 'ตัดการเชื่อมต่อ',
  'connectors.authorizationPending': 'รอการอนุญาต...',
  'connectors.authorizationPendingHint': 'ดำเนินการอนุญาตให้เสร็จสมบูรณ์ในหน้าต่างที่เปิดขึ้น',
  'connectors.cancelAuthorization': 'ยกเลิก',
  'connectors.configure': 'กำหนดค่า',
  'connectors.unavailable': 'ไม่พร้อมใช้งาน',
  'connectors.phaseStubTitle': 'Connector APIs เป็นการแสดงตัวอย่างสำหรับ Phase 3',
  'connectors.statusAvailable': 'พร้อมใช้งาน',
  'connectors.statusConnected': 'เชื่อมต่อแล้ว',
  'connectors.statusError': 'ข้อผิดพลาด',
  'connectors.statusDisabled': 'ปิดการใช้งาน',
  'connectors.gateTitle': 'เพิ่ม Composio API key ของคุณเพื่อดำเนินการต่อ',
  'connectors.gateBody': 'วาง API key ด้านบนและคลิกบันทึกเพื่อดูการผสานรวมที่พร้อมใช้งาน',
  'connectors.aboutLabel': 'เกี่ยวกับ',
  'connectors.detailsLabel': 'รายละเอียด',
  'connectors.statusLabel': 'สถานะ',
  'connectors.category.aiAgents': 'เอเจนต์ AI',
  'connectors.category.aiInfrastructure': 'โครงสร้างพื้นฐาน AI',
  'connectors.category.accounting': 'การบัญชี',
  'connectors.category.admin': 'ผู้ดูแลระบบ',
  'connectors.category.advertising': 'การโฆษณา',
  'connectors.category.analytics': 'การวิเคราะห์',
  'connectors.category.automation': 'ระบบอัตโนมัติ',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'ปฏิทิน',
  'connectors.category.commerce': 'พาณิชย์',
  'connectors.category.communication': 'การสื่อสาร',
  'connectors.category.contacts': 'รายชื่อติดต่อ',
  'connectors.category.dataPlatform': 'แพลตฟอร์มข้อมูล',
  'connectors.category.database': 'ฐานข้อมูล',
  'connectors.category.design': 'การออกแบบ',
  'connectors.category.developer': 'ผู้พัฒนา',
  'connectors.category.documentation': 'เอกสารประกอบ',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'การศึกษา',
  'connectors.category.email': 'อีเมล',
  'connectors.category.events': 'กิจกรรม',
  'connectors.category.fieldService': 'บริการภาคสนาม',
  'connectors.category.finance': 'การเงิน',
  'connectors.category.fitness': 'ฟิตเนส',
  'connectors.category.forms': 'แบบฟอร์ม',
  'connectors.category.gaming': 'เกม',
  'connectors.category.hr': 'ฝ่ายบุคคล',
  'connectors.category.hospitality': 'การบริการลูกค้า',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'การผสานรวม',
  'connectors.category.localization': 'การปรับให้เข้ากับท้องถิ่น',
  'connectors.category.logistics': 'โลจิสติกส์',
  'connectors.category.maps': 'แผนที่',
  'connectors.category.marketing': 'การตลาด',
  'connectors.category.media': 'สื่อ',
  'connectors.category.meetings': 'การประชุม',
  'connectors.category.nonprofit': 'ไม่แสวงหาผลกำไร',
  'connectors.category.observability': 'ระบบการสังเกตการณ์',
  'connectors.category.payments': 'การชำระเงิน',
  'connectors.category.personal': 'ส่วนบุคคล',
  'connectors.category.presentations': 'งานนำเสนอ',
  'connectors.category.procurement': 'การจัดซื้อ',
  'connectors.category.product': 'ผลิตภัณฑ์',
  'connectors.category.productivity': 'ผลิตภาพ',
  'connectors.category.projectManagement': 'การจัดการโครงการ',
  'connectors.category.recruiting': 'การสรรหา',
  'connectors.category.research': 'การวิจัย',
  'connectors.category.salesIntelligence': 'ระบบข้อมูลการขาย',
  'connectors.category.scheduling': 'การจัดตารางเวลา',
  'connectors.category.search': 'ค้นหา',
  'connectors.category.security': 'ความปลอดภัย',
  'connectors.category.signing': 'เซ็นเอกสาร',
  'connectors.category.social': 'โซเชียลมีเดีย',
  'connectors.category.spreadsheets': 'สเปรดชีต',
  'connectors.category.storage': 'พื้นที่เก็บข้อมูล',
  'connectors.category.support': 'สนับสนุน',
  'connectors.category.surveys': 'แบบสำรวจ',
  'connectors.category.tasks': 'งาน',
  'connectors.category.timeTracking': 'ติดตามเวลา',
  'connectors.category.video': 'วิดีโอ',
  'connectors.category.whiteboard': 'กระดานไวท์บอร์ด',
  'connectors.categoryLabel': 'หมวดหมู่',
  'connectors.providerLabel': 'ผู้ให้บริการ',
  'connectors.toolsSection': 'เครื่องมือ',
  'connectors.toolsLoading': 'กำลังโหลดเครื่องมือ…',
  'connectors.noToolsAvailable': 'ยังไม่มีเครื่องมือที่พร้อมใช้งาน',
  'connectors.toolDetailsUnavailable': 'รายละเอียดเครื่องมือไม่พร้อมใช้งาน แต่ตัวเชื่อมต่อนี้มีเครื่องมือ {n} ตัว',
  'connectors.loadMoreTools': 'โหลดเครื่องมือเพิ่มเติม',
  'connectors.openDetailsAria': 'เปิดรายละเอียด {name}',
  'connectors.toolsBadgeNone': 'ไม่มีเครื่องมือ',
  'connectors.toolsBadgeOne': '{n} เครื่องมือ',
  'connectors.toolsBadgeMany': '{n} เครื่องมือ',
  'connectors.searchPlaceholder': 'ค้นหาตัวเชื่อมต่อ…',
  'connectors.searchAriaLabel': 'ค้นหาตัวเชื่อมต่อตามชื่อ',
  'connectors.searchClear': 'ล้างการค้นหา',
  'connectors.emptyNoMatchTitle': 'ไม่มีตัวเชื่อมต่อที่ตรงกับ “{query}”',
  'connectors.emptyNoMatchBody': 'ลองใช้คำหลักอื่น',
  'connectors.emptyNoMatchAction': 'ล้างการค้นหา',
  'newproj.tabPrototype': 'ต้นแบบ (Prototype)',
  'newproj.tabLiveArtifact': 'อาร์ติแฟกต์แบบสด',
  'newproj.tabDeck': 'สไลด์นำเสนอ',
  'newproj.tabTemplate': 'จากเทมเพลต',
  'newproj.tabMedia': 'สื่อ',
  'newproj.tabOther': 'อื่นๆ',
  'newproj.titlePrototype': 'ต้นแบบใหม่',
  'newproj.titleLiveArtifact': 'Live artifact ใหม่',
  'newproj.titleDeck': 'สไลด์นำเสนอใหม่',
  'newproj.titleTemplate': 'เริ่มจากเทมเพลต',
  'newproj.titleImage': 'ภาพใหม่',
  'newproj.titleVideo': 'วิดีโอใหม่',
  'newproj.titleAudio': 'เสียงใหม่',
  'newproj.titleMedia': 'สื่อใหม่',
  'newproj.titleOther': 'โปรเจกต์ใหม่',
  'newproj.namePlaceholder': 'ชื่อโปรเจกต์',
  'newproj.fidelityLabel': 'ความละเอียด',
  'newproj.fidelityWireframe': 'ไวร์เฟรม',
  'newproj.fidelityHigh': 'ความละเอียดสูง',
  'newproj.toggleSpeakerNotes': 'ใช้บันทึกผู้บรรยาย',
  'newproj.toggleSpeakerNotesHint': 'ลดข้อความในสไลด์ — ให้ข้อมูลอยู่ในบันทึกแทน',
  'newproj.toggleAnimations': 'รวมแอนิเมชัน',
  'newproj.toggleAnimationsHint': 'เพิ่มแอนิเมชันตอนเข้าหน้า',
  'newproj.targetPlatformsLabel': 'แพลตฟอร์มเป้าหมาย',
  'newproj.targetPlatformsHint': 'เลือกได้หนึ่งรายการหรือมากกว่า เว็บแบบ Responsive ครอบคลุมเฉพาะเบรกพอยต์ของเบราว์เซอร์เท่านั้น เพิ่ม iOS, Android, แอปแท็บเล็ต หรือแอปเดสก์ท็อปสำหรับเวอร์ชันเนทีฟข้ามแพลตฟอร์ม',
  'newproj.platform.responsive.label': 'เว็บแบบ Responsive',
  'newproj.platform.responsive.hint': 'ประสบการณ์เว็บเดียวที่ปรับให้เหมาะกับเบราว์เซอร์บนเดสก์ท็อป แท็บเล็ต และมือถือ',
  'newproj.platform.webDesktop.label': 'เว็บเดสก์ท็อป',
  'newproj.platform.webDesktop.hint': 'ผลิตภัณฑ์หรือหน้าแลนดิ้งที่เน้นเบราว์เซอร์เป็นหลัก',
  'newproj.platform.mobileIos.label': 'แอป iOS',
  'newproj.platform.mobileIos.hint': 'เฟรม iPhone และกฎการโต้ตอบของ iOS',
  'newproj.platform.mobileAndroid.label': 'แอป Android',
  'newproj.platform.mobileAndroid.hint': 'เฟรม Pixel และกฎการโต้ตอบแบบ Material',
  'newproj.platform.tablet.label': 'แอปแท็บเล็ต',
  'newproj.platform.tablet.hint': 'ประสบการณ์แท็บเล็ตสไตล์เนทีฟพร้อมมุมมองแบบแยกส่วน',
  'newproj.platform.desktopApp.label': 'แอปเดสก์ท็อป',
  'newproj.platform.desktopApp.hint': 'กรอบหน้าต่างแอป macOS/Windows',
  'newproj.surfaceOptionsLabel': 'พื้นผิวเสริม',
  'newproj.includeLandingPage': 'รวมหน้าแลนดิ้ง',
  'newproj.includeLandingPageHint': 'เพิ่มหน้าการตลาดแบบ Responsive สำหรับโฆษณา รายการรอ แคมเปญเปิดตัว การดาวน์โหลดแอป หรือคำอธิบายผลิตภัณฑ์',
  'newproj.includeOsWidgets': 'รวมวิดเจ็ตของ OS',
  'newproj.includeOsWidgetsHint': 'เพิ่มวิดเจ็ตหน้าจอหลัก หน้าจอล็อก หรือวิดเจ็ตเข้าถึงด่วนแบบเนทีฟของแพลตฟอร์มสำหรับแอปมือถือ/แท็บเล็ต',
  'newproj.includeOsWidgetsDisabledHint': 'ใช้ได้เมื่อเลือกแอป iOS, Android หรือแท็บเล็ตเป็นแพลตฟอร์มเป้าหมาย',
  'newproj.templateLabel': 'เทมเพลต',
  'newproj.noTemplatesTitle': 'ยังไม่มีเทมเพลต',
  'newproj.noTemplatesBody': 'เปิดโปรเจกต์แล้วเลือกบันทึกเป็นเทมเพลตเพื่อใช้งานที่นี่',
  'newproj.savedTemplate': 'เทมเพลตที่บันทึกแล้ว',
  'newproj.fileSingular': 'ไฟล์',
  'newproj.filePlural': 'ไฟล์',
  'newproj.create': 'สร้าง',
  'newproj.locationLabel': 'บันทึกไปยัง',
  'newproj.locationDefault': 'โปรเจกต์ Gini Studio',
  'newproj.locationExternalBase': 'ฐานภายนอก',
  'newproj.createLiveArtifact': 'สร้าง live artifact',
  'newproj.createFromTemplate': 'สร้างจากเทมเพลต',
  'newproj.createDisabledTitle': 'คุณต้องบันทึกโปรเจกต์เป็นเทมเพลตก่อน',
  'newproj.importClaudeZip': 'นำเข้า GINI Studio ZIP',
  'newproj.importClaudeZipTitle': 'นำเข้า .zip จาก GINI Studio',
  'newproj.importingClaudeZip': 'กำลังนำเข้า…',
  'newproj.privacyFooter': 'โดยค่าเริ่มต้น คุณเท่านั้นที่สามารถดูโปรเจกต์ของคุณได้',
  'newproj.designSystem': 'ระบบการออกแบบ',
  'newproj.dsNoneFreeform': 'ไม่มี — ฟรีฟอร์ม',
  'newproj.dsNoneSubtitleEmpty': 'เลือกพาเลตต์สีของคุณเอง',
  'newproj.dsNoneSubtitleSelected': 'ให้ระบบเลือกพาเลตต์สีให้',
  'newproj.dsCategoryFallback': 'ระบบการออกแบบ',
  'newproj.dsSearch': 'ค้นหา Design systems…',
  'newproj.dsModeAria': 'โหมดการเลือก',
  'newproj.dsModeSingle': 'เดี่ยว',
  'newproj.dsModeMulti': 'หลาย',
  'newproj.dsNoneTitle': 'ไม่มี — ฟรีฟอร์ม',
  'newproj.dsNoneSub': 'ให้ระบบเลือกพาเลตต์สีให้',
  'newproj.dsEmpty': 'ไม่พบ Design systems ที่ตรงกับ “{query}”',
  'newproj.dsFootSingular': 'เพื่อเป็นแรงบันดาลใจเท่านั้น',
  'newproj.dsFootPlural': 'เพื่อเป็นแรงบันดาลใจเท่านั้น',
  'newproj.dsFootClear': 'ล้าง',
  'newproj.dsBadgeDefault': 'ค่าเริ่มต้น',
  'newproj.dsPrimaryFallback': 'หลัก',
  'newproj.surfaceImage': 'รูปภาพ',
  'newproj.surfaceVideo': 'วิดีโอ',
  'newproj.surfaceAudio': 'เสียง',
  'newproj.modelLabel': 'โมเดล',
  'newproj.modelSearch': 'ค้นหาโมเดล…',
  'newproj.modelEmpty': 'ไม่พบโมเดลที่ตรงกัน',
  'newproj.modelRecommended': 'แนะนำ',
  'newproj.modelMissingTitle': 'เลือกโมเดล',
  'newproj.modelMissingSub': 'เลือกโมเดลสำหรับพื้นที่นี้',
  'newproj.aspectLabel': 'อัตราส่วน',
  'newproj.videoLengthLabel': 'ความยาว',
  'newproj.videoLengthSeconds': '{n}วิ',
  'newproj.audioKindLabel': 'ประเภทเสียง',
  'newproj.audioKindMusic': 'เพลง',
  'newproj.audioKindSpeech': 'คำพูด',
  'newproj.audioKindSfx': 'เอฟเฟกต์',
  'newproj.audioDurationLabel': 'ระยะเวลา',
  'newproj.audioDurationSeconds': '{n}วิ',
  'newproj.voiceLabel': 'เสียงพูด',
  'newproj.voicePlaceholder': 'Voice id ของผู้ให้บริการ (ไม่บังคับ)',
  'newproj.connectorsLabel': 'ตัวเชื่อมต่อ',
  'newproj.connectorsHint': 'แหล่งข้อมูลที่ artifact นี้ดึงข้อมูลมาได้',
  'newproj.connectorsEmptyTitle': 'ยังไม่ได้ตั้งค่าตัวเชื่อมต่อ',
  'newproj.connectorsEmptyBody': 'เชื่อมต่อแหล่งข้อมูลเพื่อให้ได้ตัวเลขจริง',
  'newproj.connectorsEmptyCta': 'ตั้งค่าตัวเชื่อมต่อ →',
  'newproj.connectorsLoading': 'กำลังโหลดตัวเชื่อมต่อ…',
  'newproj.connectorsCountOne': 'เชื่อมต่อแล้ว {n} ตัว',
  'newproj.connectorsCountMany': 'เชื่อมต่อแล้ว {n} ตัว',
  'newproj.connectorsManage': 'จัดการ',
  'newproj.promptTemplateLabel': 'เทมเพลตอ้างอิง',
  'newproj.promptTemplateNoneTitle': 'เขียนคำสั่งเอง',
  'newproj.promptTemplateNoneSub': 'ไม่ต้องใช้ตัวอ้างอิง อธิบายในแบบของคุณ',
  'newproj.promptTemplateRefSub': 'เทมเพลตอ้างอิง',
  'newproj.promptTemplateSearch': 'ค้นหาเทมเพลต…',
  'newproj.promptTemplateEmpty': 'ยังไม่ได้ติดตั้งเทมเพลตสำหรับส่วนนี้',
  'newproj.promptTemplateBodyLabel': 'คำสั่ง (แก้ไขได้)',
  'newproj.promptTemplateOptimizeHint': 'การปรับแก้ของคุณจะส่งผลต่อเอเจนต์ด้วย',
  'newproj.promptTemplateBodyEmpty': 'เนื้อหาว่างเปล่า เอเจนต์จะไม่ได้ข้อมูลอ้างอิง',
  'newproj.deleteTemplateTitle': 'ลบเทมเพลต',
  'newproj.deleteTemplateConfirm': 'ลบ "{name}" ใช่ไหม การลบนี้ไม่สามารถย้อนกลับได้',
  'newproj.deleteTemplateConfirmCta': 'ลบเทมเพลต',
  'newproj.deleteTemplateError': 'ไม่สามารถลบเทมเพลตนี้ได้ โปรดลองอีกครั้ง',
  'designs.subRecent': 'ล่าสุด',
  'designs.subYours': 'ดีไซน์ของคุณ',
  'designs.filterAria': 'ตัวกรอง',
  'designs.searchPlaceholder': 'ค้นหา…',
  'designs.emptyNoProjects': 'ยังไม่มีโปรเจกต์',
  'designs.emptyNoMatch': 'ไม่พบโปรเจกต์',
  'designs.deleteTitle': 'ลบโปรเจกต์',
  'designs.deleteConfirm': 'ลบ "{name}"?',
  'designs.cardFreeform': 'ฟรีฟอร์ม',
  'designs.badgeLive': 'สด',
  'designs.liveArtifactBadgesAria': 'ป้ายกำกับ',
  'designs.liveCount': '{n} สด',
  'designs.statusLive': 'อาร์ติแฟกต์แบบสด',
  'designs.statusArchived': 'เก็บถาวรแล้ว',
  'designs.statusError': 'ข้อผิดพลาด',
  'designs.statusRefreshing': 'กำลังรีเฟรช…',
  'designs.statusRefreshFailed': 'รีเฟรชไม่สำเร็จ',
  'designs.statusRefreshed': 'รีเฟรชแล้ว',
  'designs.status.notStarted': 'ยังไม่เริ่ม',
  'designs.status.queued': 'อยู่ในคิว',
  'designs.status.running': 'กำลังทำงาน',
  'designs.status.awaitingInput': 'ต้องการข้อมูลเพิ่ม',
  'designs.status.succeeded': 'สำเร็จ',
  'designs.status.published': 'เผยแพร่แล้ว',
  'designs.status.failed': 'ล้มเหลว',
  'designs.status.canceled': 'ยกเลิกแล้ว',
  'designs.viewToggleAria': 'โหมดมุมมอง',
  'designs.viewGrid': 'ตาราง',
  'designs.viewKanban': 'บอร์ด',
  'designs.kanbanEmptyColumn': 'ไม่มีรายการ',
  'designs.deleteAria': 'ลบ {name}',
  'designs.menuMore': 'การดำเนินการเพิ่มเติม',
  'designs.menuRename': 'เปลี่ยนชื่อ',
  'designs.menuDelete': 'ลบ',
  'designs.renamePrompt': 'ชื่อใหม่สำหรับ "{name}"',
  'designs.selectMode': 'เลือก',
  'designs.cancelSelect': 'ยกเลิก',
  'designs.deleteSelected': 'ลบรายการที่เลือก',
  'designs.selectedCount': 'เลือกแล้ว {n} รายการ',
  'designs.deleteSelectedConfirm': 'ลบ {n} โปรเจกต์หรือไม่',
  'designs.deleteSelectedSuccess': 'ลบ {n} โปรเจกต์สำเร็จแล้ว',
  'designs.deleteSelectedPartial': 'ลบ {deleted} โปรเจกต์แล้ว ล้มเหลว {failed} รายการ',
  'designs.tagPrototype': 'ต้นแบบ',
  'designs.tagLiveArtifact': 'อาร์ติแฟกต์แบบสด',
  'designs.tagSlide': 'สไลด์',
  'designs.tagMedia': 'สื่อ',
  'designs.renameTitle': 'เปลี่ยนชื่อโปรเจกต์',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'ยกเลิก',
  'examples.typeLabel': 'ประเภท',
  'examples.surfaceLabel': 'พื้นที่',
  'examples.surfaceWeb': 'เว็บไซต์',
  'examples.surfaceImage': 'รูปภาพ',
  'examples.surfaceVideo': 'วิดีโอ',
  'examples.surfaceAudio': 'เสียง',
  'examples.scenarioLabel': 'สถานการณ์',
  'examples.modeAll': 'ทั้งหมด',
  'examples.modePrototypeDesktop': 'ต้นแบบ · เดสก์ท็อป',
  'examples.modePrototypeMobile': 'ต้นแบบ · มือถือ',
  'examples.modeDeck': 'สไลด์นำเสนอ',
  'examples.modeDocument': 'เอกสารและเทมเพลต',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'สด',
  'examples.scenarioGeneral': 'ทั่วไป',
  'examples.scenarioEngineering': 'วิศวกรรม',
  'examples.scenarioProduct': 'ผลิตภัณฑ์',
  'examples.scenarioDesign': 'การออกแบบ',
  'examples.scenarioMarketing': 'การตลาด',
  'examples.scenarioSales': 'ฝ่ายขาย',
  'examples.scenarioFinance': 'การเงิน',
  'examples.scenarioHr': 'ทรัพยากรบุคคล',
  'examples.scenarioOperations': 'ฝ่ายปฏิบัติการ',
  'examples.scenarioSupport': 'ฝ่ายสนับสนุน',
  'examples.scenarioLegal': 'กฎหมาย',
  'examples.scenarioEducation': 'การศึกษา',
  'examples.scenarioPersonal': 'ส่วนบุคคล',
  'examples.searchPlaceholder': 'ค้นหาตัวอย่าง…',
  'examples.searchAria': 'ค้นหา',
  'examples.emptyNoSkills': 'ไม่มีทักษะที่พร้อมใช้งาน',
  'examples.emptyNoMatch': 'ไม่มีตัวอย่างที่ตรงกัน',
  'examples.openPreview': '⤢ เปิดหน้าตัวอย่าง',
  'examples.loadingPreview': 'กำลังโหลด…',
  'examples.hoverPreview': 'เลื่อนเมาส์ไปที่นี่เพื่อดูตัวอย่าง',
  'examples.usePrompt': 'ใช้คำสั่งนี้',
  'examples.previewModalTitle': 'ดูตัวอย่าง',
  'examples.shareTitle': 'แชร์ตัวอย่างนี้',
  'examples.shareLoadFirst': 'โหลดหน้าตัวอย่างก่อน',
  'examples.unavailablePlaceholder': 'ไม่มีตัวอย่าง {kind} ที่เผยแพร่แล้ว — เปิดเพื่อดูข้อมูลเพิ่มเติม',
  'examples.shareUnavailable': 'ไม่มีตัวอย่าง {kind} ที่ส่งมอบแล้วให้แชร์',
  'examples.shareMenu': 'แชร์ ▾',
  'examples.exportPdfAllSlides': 'ดาวน์โหลด PDF',
  'examples.exportPptxLocked': 'ดาวน์โหลด PPTX',
  'examples.tagSlideDeck': 'สไลด์นำเสนอ',
  'examples.tagTemplate': 'เทมเพลต',
  'examples.tagDesignSystem': 'ระบบการออกแบบ',
  'examples.tagMobilePrototype': 'ต้นแบบมือถือ',
  'examples.tagDesktopPrototype': 'ต้นแบบเดสก์ท็อป',
  'examples.tagImage': 'ภาพ',
  'examples.tagVideo': 'วิดีโอ',
  'examples.tagAudio': 'เสียง',
  'examples.previewLabel': 'ดูตัวอย่าง',
  'ds.surfaceLabel': 'พื้นที่',
  'ds.surfaceWeb': 'เว็บไซต์',
  'ds.surfaceImage': 'รูปภาพ',
  'ds.surfaceVideo': 'วิดีโอ',
  'ds.surfaceAudio': 'เสียง',
  'ds.searchPlaceholder': 'ค้นหา design systems…',
  'ds.emptyNoMatch': 'ไม่พบ design systems',
  'ds.badgeDefault': 'ค่าเริ่มต้น',
  'ds.preview': 'ดูตัวอย่าง',
  'ds.previewTitle': 'ตัวอย่าง',
  'ds.categoryAll': 'ทั้งหมด',
  'ds.categoryUncategorized': 'ไม่มีหมวดหมู่',
  'ds.showcase': 'โชว์เคส',
  'ds.tokens': 'โทเค็น',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'กำลังโหลด…',
  'avatar.title': 'บัญชีและการตั้งค่า',
  'avatar.localCli': 'CLI ในเครื่อง',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'ใช้ Local CLI',
  'avatar.useApi': 'ใช้ API · BYOK',
  'avatar.codeAgent': 'เอเจนต์โค้ด',
  'avatar.rescan': 'สแกนหาใหม่',
  'avatar.amrConsole': 'บัญชี AMR',
  'avatar.amrConsoleMeta': 'ยอดคงเหลือและการเติมเงิน',
  'avatar.settings': 'การตั้งค่า',
  'avatar.backToProjects': 'กลับไปยังโปรเจกต์',
  'avatar.metaActive': 'เปิดใช้งาน',
  'avatar.metaOffline': 'ออฟไลน์',
  'avatar.metaSelected': 'เลือกแล้ว',
  'avatar.noAgentSelected': 'ไม่ได้เลือกเอเจนต์',
  'avatar.modelSection': 'โมเดล',
  'avatar.modelLabel': 'โมเดล',
  'avatar.reasoningLabel': 'การใช้เหตุผล',
  'avatar.customSuffix': '(กำหนดเอง)',
  'socialShare.openDesignSection': 'แชร์ Gini Studio',
  'socialShare.openDesignTitle': 'Gini Studio บน GitHub',
  'socialShare.openDesignText': 'Gini Studio คือพื้นที่ทำงานแบบโอเพนซอร์สสำหรับการสร้าง แก้ไข เผยแพร่ และส่งต่อชิ้นงานออกแบบ',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'แชร์ลงโซเชียล',
  'socialShare.projectTitle': '{title} · Gini Studio',
  'socialShare.projectText': 'สร้างด้วย Gini Studio: {title} ดูชิ้นงานที่เผยแพร่และกดดาวให้ repo: {repo}',
  'socialShare.projectCopyText': 'สร้างด้วย Gini Studio: {title}\n{url}\nrepo ของ Gini Studio: {repo}',
  'socialShare.deployFirst': 'ดีพลอยแล้วแชร์…',
  'socialShare.copied': 'คัดลอกแล้ว',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'สลับ CLI / โมเดล',
  'inlineSwitcher.chipCli': 'CLI ในเครื่อง',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'ค่าเริ่มต้น',
  'inlineSwitcher.noAgent': 'ไม่มี Agent',
  'inlineSwitcher.modeLabel': 'โหมด',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'ผู้ให้บริการ',
  'inlineSwitcher.modelLabel': 'โมเดล',
  'inlineSwitcher.useCli': 'ใช้ CLI ในเครื่อง',
  'inlineSwitcher.useByok': 'ใช้ API key แบบ BYOK',
  'inlineSwitcher.daemonOffline': 'Daemon ออฟไลน์ — เปิดการตั้งค่า',
  'inlineSwitcher.noAgentsDetected': 'ไม่พบ CLI ใน PATH',
  'inlineSwitcher.openSettingsForModel': 'ตั้งค่าผู้ให้บริการในการตั้งค่า',
  'inlineSwitcher.missingApiKey': 'ยังไม่ได้ตั้งค่า API key — เปิดการตั้งค่าเพื่อเพิ่ม',
  'inlineSwitcher.openFullSettings': 'เปิดการตั้งค่าการดำเนินการ',
  'inlineSwitcher.customSuffix': '(กำหนดเอง)',
  'project.backToProjects': 'กลับไปยังโปรเจกต์',
  'project.metaFreeform': 'ฟรีฟอร์ม',
  'project.customInstructions': 'คำแนะนำของโปรเจกต์',
  'project.customInstructionsPlaceholder': 'คำสั่งสำหรับโปรเจกต์นี้ (แทรกในทุกข้อความ)…',
  'project.resizeChatPanel': 'ปรับขนาดแผงแชท',
  'project.instructionsActive': 'ใช้งานอยู่ — รวมอยู่ในทุกข้อความ',
  'chat.tabChat': 'แชท',
  'chat.tabComments': 'ความคิดเห็น',
  'chat.commentsSoon': 'ความคิดเห็น — เร็วๆ นี้',
  'chat.comments.attached': 'แนบในแชทแล้ว',
  'chat.comments.emptyAttached': 'ไม่มีความคิดเห็น',
  'chat.comments.saved': 'บันทึกความคิดเห็นแล้ว',
  'chat.comments.emptySaved': 'ไม่มีการบันทึกความคิดเห็น',
  'chat.comments.add': 'เพิ่ม',
  'chat.comments.addAll': 'เพิ่มทั้งหมด',
  'chat.comments.remove': 'ลบ',
  'chat.comments.placeholder': 'แสดงความคิดเห็นเกี่ยวกับส่วนนี้…',
  'chat.comments.addSend': 'เพิ่ม & ส่ง',
  'chat.comments.updateSend': 'อัปเดต & ส่ง',
  'chat.comments.removeAttachment': 'ลบไฟล์แนบ',
  'chat.comments.removeAttachmentAria': 'ลบไฟล์แนบความคิดเห็นสำหรับ {name}',
  'chat.comments.comment': 'ความคิดเห็น',
  'chat.comments.sendToChat': 'ส่งไปยังแชต',
  'chat.comments.sending': 'กำลังส่ง…',
  'chat.comments.edit': 'แก้ไข',
  'chat.comments.select': 'เลือก',
  'chat.comments.selectAll': 'เลือกทั้งหมด',
  'chat.comments.deselect': 'ยกเลิกการเลือก',
  'chat.comments.nSelected': 'เลือกแล้ว {n} รายการ',
  'chat.comments.pin': 'ปักหมุด',
  'chat.comments.addNote': 'เพิ่มโน้ต',
  'chat.comments.savedToast': 'บันทึกความคิดเห็นแล้ว',
  'chat.comments.pinSavedToast': 'บันทึกหมุดแล้ว',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': 'รายการที่บันทึกไว้ {n} รายการ',
  'chat.comments.clear': 'ล้าง',
  'chat.comments.targetImage': 'รูปภาพ',
  'chat.comments.targetControl': 'ตัวควบคุม',
  'chat.comments.targetLink': 'ลิงก์',
  'chat.comments.targetText': 'ข้อความ',
  'chat.comments.targetSection': 'ส่วน',
  'chat.comments.targetPage': 'หน้า',
  'chat.comments.targetArea': 'พื้นที่',
  'chat.annotationNotePlaceholder': 'เพิ่มโน้ตสำหรับเครื่องหมายนี้',
  'chat.annotationAttachImage': 'แนบรูปภาพ',
  'chat.annotationAttachedImages': 'รูปภาพที่แนบ',
  'chat.annotationAttachedRemove': 'ลบรูปภาพล่าสุด',
  'chat.annotationAddToInput': 'เพิ่มลงในช่องป้อนข้อมูล',
  'chat.annotationAddingToInput': 'กำลังเพิ่ม...',
  'chat.annotationQueue': 'คิว',
  'chat.annotationQueueing': 'กำลังเข้าคิว...',
  'chat.annotationSending': 'กำลังส่ง...',
  'chat.annotationSendDisabledReason': 'มีงานกำลังทำงานอยู่',
  'chat.annotationPreviewMissing': 'ไม่สามารถจับภาพตัวอย่างได้ โปรดลองอีกครั้ง',
  'chat.annotationPreviewMissingInk': 'ไม่สามารถจับภาพตัวอย่างได้ ลองอีกครั้งเพื่อหลีกเลี่ยงการส่งเฉพาะลายเส้น',
  'chat.annotationTimeout': 'การส่งคำอธิบายประกอบหมดเวลา โปรดลองอีกครั้ง',
  'chat.annotationFailed': 'การส่งคำอธิบายประกอบล้มเหลว โปรดลองอีกครั้ง',
  'chat.annotationProjectCreateFailed': 'ไม่สามารถสร้างโปรเจกต์ได้ จึงไม่ได้ส่งคำอธิบายประกอบ',
  'chat.annotationUploadFailed': 'การอัปโหลดไฟล์แนบล้มเหลว โปรดลองอีกครั้ง',
  'chat.conversationsTitle': 'การสนทนา',
  'chat.conversationsAria': 'ประวัติ',
  'chat.newConversation': 'สนทนาใหม่',
  'chat.newConversationsTitle': 'เริ่มใหม่',
  'chat.conversationsHeading': 'บทสนทนาทั้งหมด',
  'chat.new': 'ใหม่',
  'chat.emptyConversations': 'ยังไม่มีบทสนทนา',
  'chat.deleteConversation': 'ลบบทสนทนา',
  'chat.renameConversationLabel': 'เปลี่ยนชื่อ "{title}"',
  'chat.deleteConversationConfirm': 'ลบ "{title}" หรือไม่?',
  'chat.untitledConversation': 'บทสนทนาที่ไม่มีชื่อ',
  'chat.forkedConversationTitle': 'ฟอร์กของ {title}',
  'chat.forkConversationFailed': 'ไม่สามารถ fork บทสนทนานี้ได้',
  'chat.startTitle': 'เริ่มแชทได้เลย',
  'chat.startHint': 'อธิบายสิ่งที่ต้องการสร้าง หรือเริ่มจากตัวอย่างเหล่านี้:',
  'chat.fillInputTitle': 'คลิกเพื่อใส่ข้อความ',
  'chat.jumpToLatest': 'เลื่อนไปล่าสุด',
  'chat.scrollToLatest': 'เลื่อนลงล่าง',
  'chat.you': 'คุณ',
  'chat.openFile': 'เปิด {name}',
  'chat.copyPrompt': 'คัดลอกพรอมต์',
  'chat.copyErrorDiagnostic': 'คัดลอกข้อมูลวิเคราะห์ข้อผิดพลาด',
  'chat.copyDone': 'คัดลอกแล้ว!',
  'chat.inspect.noEditableTargets': 'ไม่พบข้อความหรือเป้าหมายสไตล์ที่แก้ไขได้',
  'chat.inspect.noCommentTargets': 'ไม่พบข้อความหรือเป้าหมายภาพที่แสดงความคิดเห็นได้',
  'chat.inspect.editHint': 'เลือกข้อความหรือเป้าหมายสไตล์ในตัวอย่างเพื่อแก้ไข',
  'chat.inspect.commentHint': 'เลือกข้อความหรือพื้นที่ในตัวอย่างเพื่อแสดงความคิดเห็น',
  'chat.composerPlaceholder': 'อธิบายสิ่งที่ต้องการสร้าง…',
  'chat.activeFileEditingLabel': 'กำลังแก้ไข',
  'chat.activeFilePlaceholder': 'ขอให้ Gini Studio แก้ไข {file}...',
  'chat.designArtifactsShowMore': 'แสดงไฟล์ดีไซน์เพิ่มอีก {count} ไฟล์',
  'chat.mode.chat.label': 'ถาม',
  'chat.mode.chat.title': 'โหมดถาม',
  'chat.mode.chat.summary': 'สำหรับคำตอบเร็ว การแก้ไข การวางแผน และการสนทนา โดยไม่ถือว่าต้องสร้างชิ้นงานออกแบบเสมอไป',
  'chat.mode.chat.solves': 'ใช้เพื่อทำความคิดให้ชัด ปรับ prompt เปรียบเทียบตัวเลือก หรือถามเกี่ยวกับงานที่มีอยู่',
  'chat.mode.chat.query1': 'สรุปร่างนี้และชี้จุดที่ยังขาด',
  'chat.mode.chat.query2': 'ช่วยเลือกโครงสร้างที่ดีที่สุดสำหรับ landing page นี้',
  'chat.mode.chat.query3': 'รีวิวดีไซน์นี้และเสนอการปรับปรุงที่ชัดเจน',
  'chat.mode.plan.label': 'แผน',
  'chat.mode.plan.title': 'โหมดแผน',
  'chat.mode.plan.summary': 'สำรวจและวางแนวทางก่อนแก้ไฟล์ เครื่องมือแก้ไขจะถูกบล็อกจนกว่าคุณจะอนุมัติและสลับไป Design',
  'chat.mode.plan.solves': 'ใช้สำรวจ workspace เปรียบเทียบตัวเลือก และสร้างแผน TodoWrite ที่ตรวจทานได้ก่อนลงมือทำ',
  'chat.mode.plan.query1': 'สำรวจโปรเจกต์นี้และเสนอแผนทีละขั้นตอนสำหรับรีดีไซน์แลนดิ้งเพจ',
  'chat.mode.plan.query2': 'ระบุไฟล์และส่วนที่จะเปลี่ยนก่อนสร้างอะไร',
  'chat.mode.plan.query3': 'เปรียบเทียบสองแนวทางและแนะนำแผนที่ควรดำเนินการ',
  'chat.mode.plan.badge': 'แผน',
  'chat.mode.plan.approve': 'อนุมัติและสร้าง',
  'chat.mode.plan.approveHint': 'สลับไปโหมด Design Agent เพื่อดำเนินการตามแผนนี้',
  'chat.mode.design.label': 'Design Agent',
  'chat.mode.design.title': 'โหมด Design Agent',
  'chat.mode.design.summary': 'สำหรับสร้างหรือแก้ไขผลงานจริง เช่น หน้าเว็บ prototype live artifact สไลด์ รูปภาพ วิดีโอ HyperFrames เสียง dashboard และไฟล์โปรเจกต์',
  'chat.mode.design.solves': 'ใช้เมื่ออยากให้ Gini Studio สร้างไฟล์ อัปเดต workspace หรือเปลี่ยน brief เป็นงานส่งมอบหลายรูปแบบ',
  'chat.mode.design.query1': 'สร้าง landing page เปิดตัวผลิตภัณฑ์และ HyperFrames prototype จาก brief นี้',
  'chat.mode.design.query2': 'ทำ deck นักลงทุน 10 สไลด์พร้อม speaker notes',
  'chat.mode.design.query3': 'สร้างคอนเซ็ปต์รูปภาพ วิดีโอ และเสียงสำหรับแคมเปญนี้',
  'chat.mode.cardBestFor': 'เหมาะสำหรับ',
  'chat.mode.cardTry': 'ลองถามว่า',
  'chat.composerHint': '⌘/Ctrl + Enter เพื่อส่ง · ระบุเป้าหมาย เนื้อหา สไตล์ และรูปแบบ',
  'chat.cliSettingsTitle': 'ตั้งค่าโมเดลและ CLI',
  'chat.cliSettingsAria': 'ตั้งค่า',
  'chat.attachTitle': 'แนบไฟล์ (วาง / ลาก)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'แนบไฟล์',
  'chat.importFigma': 'นำเข้าจาก Figma',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'chat.importTitle': 'นำเข้าจากที่อื่น (เร็วๆ นี้)',
  'chat.importLabel': 'นำเข้า',
  'chat.importComingSoon': 'เร็วๆ นี้',
  'chat.importSoon': 'เร็วๆ นี้',
  'chat.importFig': 'อัปโหลดไฟล์ Figma',
  'chat.importGitHub': 'ต่อ GitHub',
  'chat.importWeb': 'ดึงหน้าเว็บ',
  'chat.importFolder': 'ลิ้งก์โค้ดโฟลเดอร์',
  'chat.importSkills': 'ทักษะและระบบการออกแบบ',
  'chat.importProject': 'อ้างอิงโปรเจกต์อื่น',
  'chat.importDesignSystemHeader': 'เลือกระบบดีไซน์',
  'chat.importDesignSystemBack': 'กลับ',
  'chat.importDesignSystemSearch': 'ค้นหาระบบดีไซน์…',
  'chat.importDesignSystemEmpty': 'ไม่มีระบบดีไซน์ที่ตรงกับ "{query}"',
  'chat.importDesignSystemNone': 'ไม่มี — อิสระ',
  'chat.importDesignSystemNoneSub': 'รอบนี้ไม่ยึดติดกับระบบใด',
  'chat.importDesignSystemActive': 'ใช้งานอยู่',
  'chat.importDesignSystemSwitched': 'สลับระบบดีไซน์ไปเป็น {title}',
  'chat.importDesignSystemFailed': 'ไม่สามารถสลับระบบดีไซน์ได้ โปรดลองอีกครั้ง',
  'chat.importDesignSystemLoadFailed': 'ไม่สามารถโหลดระบบการออกแบบได้',
  'browserUse.title': 'แรงบันดาลใจ',
  'browserUse.summary': 'การกระทำบนเว็บ {count} รายการ โดยให้ความสำคัญกับการดึงทรัพยากร ภาษาการออกแบบ การเคลื่อนไหว การตรวจสอบภาพ และโครงสร้างคอมโพเนนต์',
  'browserUse.searchAria': 'ค้นหาแรงบันดาลใจ',
  'browserUse.searchPlaceholder': 'ค้นหาภาพหน้าจอ ฟอนต์ สี a11y...',
  'browserUse.empty': 'ไม่มีแรงบันดาลใจที่ตรงกัน',
  'browserUse.unavailable': 'ไม่มีแรงบันดาลใจให้ใช้งานที่นี่',
  'browserUse.added': 'เพิ่มลงในตัวเรียบเรียงแล้ว',
  'browserUse.category.assets': 'การดึงทรัพยากร',
  'browserUse.category.tokens': 'ภาษาการออกแบบ',
  'browserUse.category.motion': 'การเคลื่อนไหว',
  'browserUse.category.visual': 'การตรวจสอบภาพ',
  'browserUse.category.structure': 'คอมโพเนนต์',
  'browserUse.category.project': 'การรันโปรเจกต์',
  'browserUse.category.general': 'ทั่วไป',
  'browserUse.input.none': 'ไม่มีอินพุต',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'ตัวเลือก (ไม่บังคับ)',
  'browserUse.input.requirementSelector': 'ข้อกำหนด, ตัวเลือก (ไม่บังคับ)',
  'browserUse.input.selectorOptional': 'ตัวเลือก (ไม่บังคับ)',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'ตัวเลือก, scale=2',
  'browserUse.input.gridOverlay': '12 คอลัมน์, สูงสุด 1200, ระยะห่าง 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, โดเมน, หรือคำค้นหา',
  'browserUse.input.selector': 'ตัวเลือก',
  'browserUse.input.selectorText': 'ตัวเลือกและข้อความ',
  'browserUse.input.scroll': 'พิกเซล, บน, ล่าง, หรือทั้งหน้า',
  'browserUse.input.terminalRun': 'คำสั่ง, หมดเวลา 120 วินาที',
  'browserUse.input.command': 'คำสั่ง',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'ผู้สมัครโลโก้ที่ดีที่สุดจากส่วนหัว, นำทาง, ชื่อคลาส, ตำแหน่ง, ภาพ OG, และการสำรองด้วย favicon',
  'browserUse.action.list_images.output': 'img, srcset, source ทั้งหมด และภาพพื้นหลัง CSS พร้อมขนาดและข้อความ alt',
  'browserUse.action.download_assets.output': 'โฟลเดอร์ทรัพยากรที่ดาวน์โหลดพร้อม _manifest.json ที่รองรับ referer และ cookie',
  'browserUse.action.extract_svgs.output': 'SVG แบบอินไลน์และไฟล์ .svg ที่ลิงก์ไว้ บันทึกเป็นไฟล์ SVG แต่ละไฟล์',
  'browserUse.action.optimize_svgs.output': 'ไฟล์ SVG ที่ปรับให้เหมาะสมพร้อมอัตราการบีบอัด',
  'browserUse.action.extract_colors.output': 'จานสีแบบถ่วงน้ำหนักพร้อมตัวแปรสี CSS :root เป็น palette.json และ palette.html',
  'browserUse.action.extract_fonts.output': 'ตระกูลฟอนต์ ขนาด น้ำหนัก และกฎ @font-face ยอดนิยม เป็น typography.json',
  'browserUse.action.extract_design_tokens.output': 'รัศมี, เงา, ระยะห่าง, และตัวแปร CSS เป็น tokens.json',
  'browserUse.action.extract_type_scale.output': 'สเกลของหัวเรื่อง, เนื้อหา, และปุ่ม พร้อมขนาด น้ำหนัก ความสูงบรรทัด และอัตราส่วน',
  'browserUse.action.extract_buttons.output': 'คลังสไตล์ปุ่มที่ตัดข้อมูลซ้ำแล้ว เป็น buttons.html และ buttons.json',
  'browserUse.action.extract_grid_system.output': 'คอนเทนเนอร์ grid และ flex, ทิศทาง, ระยะห่าง, คอลัมน์, และความกว้างสูงสุด เป็น layout.json',
  'browserUse.action.extract_breakpoints.output': 'เบรกพอยต์ของ media-query แบบ responsive เป็น breakpoints.json',
  'browserUse.action.extract_gradients.output': 'เกรเดียนต์ CSS เป็น gradients.css, gradients.json, และ HTML แสดงตัวอย่าง',
  'browserUse.action.extract_shadows.output': 'เงากล่อง, เงาข้อความ, และเงาทอด เป็น shadows.json พร้อมตัวอย่าง',
  'browserUse.action.extract_easings.output': 'ฟังก์ชัน easing ของทรานซิชันและแอนิเมชัน เป็น easings.json',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js, และ style-dictionary.tokens.json',
  'browserUse.action.extract_animations.output': '@keyframes, กฎทรานซิชันและทรานส์ฟอร์ม, ไลบรารีการเคลื่อนไหวที่ตรวจพบ, motion.css, และ motion.json',
  'browserUse.action.validate_view.output': 'เส้นทางภาพหน้าจอพร้อมปัญหาภาพและเลย์เอาต์ที่จัดโครงสร้างแล้ว',
  'browserUse.action.audit_layout.output': 'ข้อบกพร่องของเลย์เอาต์ รวมถึงการล้น, ขอบเขต, การซ้อนทับ, และข้อความที่ถูกตัด เป็น audit.json',
  'browserUse.action.audit_accessibility.output': 'ปัญหาการเข้าถึง (A11y) เกี่ยวกับ selector, label, role, focus, ความต่างของสี และภาพหน้าจอในจุดที่เป็นประโยชน์',
  'browserUse.action.responsive_screenshots.output': 'ภาพหน้าจอแบบ Mobile 390, tablet 834 และ desktop 1440',
  'browserUse.action.screenshot_full.output': 'ภาพหน้าจอเต็มหน้าที่เกินขอบเขตของ viewport',
  'browserUse.action.screenshot_element.output': 'ภาพหน้าจอขององค์ประกอบเดียวที่ 2x โดยค่าเริ่มต้น',
  'browserUse.action.screenshot_with_grid.output': 'ภาพหน้าจอพร้อมเลเยอร์ grid แสดงเลย์เอาต์',
  'browserUse.action.screenshot_dark_mode.output': 'ภาพหน้าจอแบบ prefers-color-scheme: dark',
  'browserUse.action.generate_styleguide.output': 'สไตล์ไกด์หน้าเดียวพร้อมสี, type scale, radius และเงา',
  'browserUse.action.extract_html.output': 'HTML ที่สะอาดและครบในตัว ไม่มี script, noscript หรือ attribute ของ event แบบ inline',
  'browserUse.action.extract_component_inventory.output': 'รูปแบบคอมโพเนนต์ที่ใช้ซ้ำ, selector, จำนวน และภาพหน้าจอ',
  'browserUse.action.extract_copy.output': 'หัวข้อ, CTA, เนื้อหา และคำอธิบายในรูปแบบ copy.md และ copy.json',
  'browserUse.action.extract_nav.output': 'เมนูนำทางหลักและลิงก์ส่วนท้ายในรูปแบบ sitemap.md และ nav.json',
  'browserUse.action.extract_forms.output': 'ฟิลด์ฟอร์ม, label, คำแนะนำการตรวจสอบ และการดำเนินการส่งในรูปแบบ forms.json',
  'browserUse.action.run_project.output': 'URL ของ dev server ที่ตรวจพบ เปิดในแท็บ Browser',
  'browserUse.action.detect_project.output': 'เฟรมเวิร์ก, package manager, คำสั่งติดตั้ง, คำสั่ง dev และพอร์ต',
  'browserUse.action.page_info.output': 'URL, ชื่อเรื่อง, คำอธิบาย, OG image, สีธีม, favicon และ viewport',
  'browserUse.action.snapshot.output': 'องค์ประกอบแบบโต้ตอบและข้อความที่มองเห็นได้สูงสุด 120 รายการ พร้อม tag, label, href และพิกัด',
  'browserUse.action.navigate.output': 'เปิดหน้าและส่งคืน page_info',
  'browserUse.action.click.output': 'คลิกองค์ประกอบแรกที่ตรงกันหลังจากเลื่อนให้อยู่ในมุมมอง',
  'browserUse.action.type_text.output': 'กรอกข้อมูลในช่อง input และส่ง event input และ change',
  'browserUse.action.scroll.output': 'ตำแหน่งการเลื่อนปัจจุบันและสูงสุด',
  'browserUse.action.extract_og_metadata.output': 'Meta title, คำอธิบาย, canonical URL, OG/Twitter card, ภาพสำหรับโซเชียล และสีธีม',
  'browserUse.action.terminal_run.output': 'stdout, stderr และ exit code',
  'browserUse.action.terminal_run_background.output': 'id ของงานที่ทำงานเบื้องหลัง และผลลัพธ์ล่าสุด',
  'browserUse.action.terminal_read.output': 'ผลลัพธ์ terminal ที่แชร์ล่าสุด',
  'chat.designToolbox.title': 'กล่องเครื่องมือออกแบบ',
  'chat.designToolbox.tooltip': 'กล่องเครื่องมือออกแบบ / เสี่ยงดวง',
  'chat.designToolbox.aria': 'เปิดกล่องเครื่องมือออกแบบ',
  'chat.designToolbox.lucky': 'เสี่ยงดวง',
  'chat.designToolbox.searchPlaceholder': 'ค้นหา skill / MCP / plugin / connector / ไฟล์ออกแบบ...',
  'chat.designToolbox.searchAria': 'ค้นหาทรัพยากรในกล่องเครื่องมือออกแบบ',
  'chat.designToolbox.followupSection': 'ติดตามผล',
  'chat.designToolbox.resourcesSection': 'ทรัพยากรทั่วไป',
  'chat.designToolbox.selected': 'ที่เลือก',
  'chat.designToolbox.noResources': 'ไม่พบทรัพยากรสำหรับ "{query}"',
  'chat.designToolbox.badge.video': 'วิดีโอ',
  'chat.designToolbox.badge.image': 'รูปภาพ',
  'chat.designToolbox.badge.motion': 'การเคลื่อนไหว',
  'chat.designToolbox.badge.polish': 'ขัดเกลา',
  'chat.designToolbox.action.auto-match.title': 'จับคู่ขั้นตอนถัดไป',
  'chat.designToolbox.action.auto-match.badge': 'จับคู่',
  'chat.designToolbox.action.auto-match.description': 'กำหนดมาตรฐานรสนิยมก่อน จากนั้นจึงจับคู่ skill, MCP, plugin, connector และไฟล์',
  'chat.designToolbox.action.motion.title': 'เพิ่มอนิเมชัน / การเคลื่อนไหว',
  'chat.designToolbox.action.motion.badge': 'การเคลื่อนไหว',
  'chat.designToolbox.action.motion.description': 'เพิ่มการเคลื่อนไหวแบบ entrance, scroll, state-transition และ micro-interaction ให้กับ HTML หรือองค์ประกอบหน้าปัจจุบัน',
  'chat.designToolbox.action.motion-polish.title': 'ขัดเกลาการเคลื่อนไหว',
  'chat.designToolbox.action.motion-polish.badge': 'จังหวะเวลา',
  'chat.designToolbox.action.motion-polish.description': 'ตรวจสอบจังหวะเวลา, easing, ประสิทธิภาพ และ fallback แบบ reduced-motion สำหรับการเคลื่อนไหวที่มีอยู่',
  'chat.designToolbox.action.anti-ai-polish.title': 'ลบความรู้สึกแบบ AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'รสนิยม',
  'chat.designToolbox.action.anti-ai-polish.description': 'ลบความรู้สึกแบบเทมเพลต, AI gradient, การวางการ์ดซ้อนแบบราคาถูก และเนื้อหาที่คลุมเครือ',
  'chat.designToolbox.action.visual-polish.title': 'ขัดเกลาการออกแบบ / พร้อมส่งมอบ',
  'chat.designToolbox.action.visual-polish.badge': 'ขัดเกลา',
  'chat.designToolbox.action.visual-polish.description': 'ตรวจสอบลำดับชั้นทางสายตา, ตัวอักษร, ระยะห่าง, พฤติกรรมแบบ responsive, การเข้าถึง และคุณภาพการส่งมอบ',
  'chat.designToolbox.action.image-gen.title': 'สร้างรูปภาพ / ภาพอ้างอิง',
  'chat.designToolbox.action.image-gen.badge': 'รูปภาพ',
  'chat.designToolbox.action.image-gen.description': 'สร้างภาพอ้างอิงของส่วนต่างๆ, asset, ไอคอน, ภาพสำหรับโซเชียล หรือ moodboard สำหรับหน้าปัจจุบัน',
  'chat.designToolbox.action.video-gen.title': 'สร้างวิดีโอ / สคริปต์การเคลื่อนไหว',
  'chat.designToolbox.action.video-gen.badge': 'วิดีโอ',
  'chat.designToolbox.action.video-gen.description': 'แปลงงานออกแบบเป็นวิดีโอสั้น, สตอรีบอร์ด Remotion / Hyperframes หรือพรอมต์ที่พร้อมสำหรับการสร้าง',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'ปลั๊กอิน',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'เทมเพลต MCP',
  'chat.designToolbox.kind.connector': 'Connector',
  'chat.designToolbox.kind.designFile': 'ไฟล์ดีไซน์',
  'chat.designToolbox.context.browser': 'เบราว์เซอร์',
  'chat.designToolbox.context.designFiles': 'ไฟล์ดีไซน์',
  'chat.designToolbox.context.designSystem': 'ระบบดีไซน์',
  'chat.designToolbox.context.folder': 'โฟลเดอร์',
  'chat.designToolbox.context.terminal': 'เทอร์มินัล',
  'chat.designToolbox.context.sideChat': 'แชทด้านข้าง',
  'chat.designToolbox.context.liveArtifact': 'Artifact สด',
  'chat.designToolbox.context.file': 'ไฟล์',
  'chat.designToolbox.prompt.contextGeneric': 'เป้าหมายปัจจุบัน: ไฟล์ HTML / ไฟล์ดีไซน์ / เว็บเอลิเมนต์ที่เปิดอยู่ในขณะนี้',
  'chat.designToolbox.prompt.contextSpecific': 'เป้าหมายปัจจุบัน: {kind} · {label}',
  'chat.designToolbox.prompt.preserveDraft': 'คงเจตนาที่มีอยู่แล้วในกล่องเขียนข้อความไว้: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'สกิลที่เลือก: {skill} ใช้เป็นเวิร์กโฟลว์หลักสำหรับรอบนี้',
  'chat.designToolbox.prompt.noSkill': 'หากไม่มีสกิลที่ตรงกันโดยเฉพาะ ให้เลือกชุดผสมผสานที่ดีที่สุดจากสกิล, MCP, ปลั๊กอิน, connector และไฟล์ดีไซน์ที่มีอยู่ก่อน',
  'chat.designToolbox.prompt.autoMatchIntro': 'ทำหน้าที่เป็นตัวประสานงานในบทบาท Creative Director และทำเวิร์กโฟลว์ดีไซน์ให้เสร็จสมบูรณ์:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. กำหนดความหมายของ “ดีไซน์ที่ดูดี” ก่อน: กลุ่มเป้าหมาย เป้าหมายทางธุรกิจ ความรู้สึกของแบรนด์ ตัวอย่างอ้างอิงสไตล์ ความหนาแน่นของข้อมูล มาตรฐานสี/ตัวอักษร/การเคลื่อนไหว/แอสเซ็ต และรูปแบบ AI/เทมเพลตที่ควรหลีกเลี่ยง',
  'chat.designToolbox.prompt.autoMatchStep2': '2. ค้นหาและจับคู่กับดัชนีทรัพยากรทั้งหมดด้านบน อย่าใช้เฉพาะคำแนะนำจากกล่องเครื่องมือดีไซน์เท่านั้น แต่ให้ผสมผสานสกิล, MCP, ปลั๊กอิน, connector และไฟล์ดีไซน์เมื่อเป็นประโยชน์',
  'chat.designToolbox.prompt.autoMatchStep3': '3. หากเป้าหมายหรือเกณฑ์ด้านความสวยงามยังไม่ชัดเจน ให้นำทางฉันด้วยตัวเลือกที่จำกัดหรือ UI แบบฟอร์ม พร้อมระบุค่าเริ่มต้นที่แนะนำ หากชัดเจนเพียงพอแล้ว ให้ดำเนินขั้นตอนถัดไปได้ทันที',
  'chat.designToolbox.prompt.autoMatchStep4': '4. ทำขั้นตอนให้ครบตามลำดับนี้: วินิจฉัย -> ทิศทางสไตล์ -> การเลือกทรัพยากร -> การแก้ไข/สร้างงานที่เป็นรูปธรรม -> การตรวจสอบ ในแต่ละขั้นตอน ให้อธิบายว่าทำไมจึงเลือกทรัพยากรเหล่านี้ และมีอะไรที่ต้องยืนยันในขั้นตอนถัดไป',
  'chat.designToolbox.prompt.motion': 'เพิ่มโมชันคุณภาพสูงให้กับ HTML / เอลิเมนต์ของหน้าปัจจุบัน: เลือกช่วงเวลาที่เป็นประโยชน์ที่สุด 1-2 จุด ไม่ว่าจะเป็นการเข้า, การเลื่อน, การเปลี่ยนสถานะ หรือไมโครอินเทอแร็กชัน ทำให้ดูเรียบง่ายไม่หวือหวา เน้นใช้ transform / opacity และใส่ทางเลือกสำรองสำหรับ prefers-reduced-motion',
  'chat.designToolbox.prompt.motionPolish': 'ตรวจสอบและขัดเกลาจังหวะเวลา, easing, ประสิทธิภาพ และการเข้าถึงของโมชันที่มีอยู่ ลบแอนิเมชันที่กระตุก ดูราคาถูก หรือบั่นทอนความอ่านง่ายออก และใช้ไทม์ไลน์ที่ประณีตขึ้นเมื่อจำเป็น',
  'chat.designToolbox.prompt.antiAiPolish': 'ทำการขัดเกลาหนึ่งรอบเพื่อลดความรู้สึกแบบ AI: ลบเลย์เอาต์แบบเทมเพลต, ไล่สี/แสงเรืองที่ดูราคาถูก, การ์ดซ้อนกันที่ไร้ความหมาย และข้อความที่คลุมเครือออก คงข้อมูลไว้และทำให้รู้สึกเหมือนนักออกแบบจริงเป็นผู้ส่งมอบงาน',
  'chat.designToolbox.prompt.visualPolish': 'ขัดเกลาดีไซน์นี้จนพร้อมส่งมอบ: ตรวจสอบลำดับชั้น, ตัวอักษร, ระยะห่าง, พฤติกรรมแบบ responsive, สถานะของปุ่ม, สถานะว่าง/กำลังโหลด/ข้อผิดพลาด และการเข้าถึง แล้วแก้ไขปัญหาสำคัญที่สุดโดยตรง',
  'chat.designToolbox.prompt.imageGen': 'สร้างแผนสำหรับ visual asset ถัดไปของดีไซน์นี้: ภาพอ้างอิงของแต่ละส่วน, hero asset, ภาพประกอบ, ไอคอน, ภาพสำหรับโซเชียล หรือ moodboard ให้ตัดสินใจก่อนว่าขาดภาพประเภทใด แล้วจึงให้พรอมต์สำหรับสร้างที่นำไปใช้ได้จริง / แผนของไฟล์',
  'chat.designToolbox.prompt.videoGen': 'ปรับดีไซน์นี้ไปสู่วิดีโอ: สร้างสตอรีบอร์ดวิดีโอสั้น, โครงสร้างเฟรมแบบ Hyperframes / Remotion หรือพรอมต์ที่พร้อมใช้กับ Sora/fal เน้นทำให้เนื้อหา HTML / หน้าเว็บที่มีอยู่กลายเป็นช็อตได้อย่างเป็นธรรมชาติ',
  'chat.designToolbox.prompt.useSkill': 'ใช้ {skill} กับดีไซน์ปัจจุบัน',
  'chat.designToolbox.prompt.skillInstruction': 'ตัดสินใจเป้าหมายต่อยอดที่ดีที่สุดก่อน แล้วทำให้เสร็จหนึ่งรอบอย่างเป็นรูปธรรม หากต้องพึ่งพา asset หรือ API ภายนอก ให้จัดเตรียมทางเลือกสำรองที่รันได้ หรือระบุว่าฉันต้องจัดหาอะไรให้',
  'chat.designToolbox.prompt.selectedResource': 'ทรัพยากรที่เลือก: {kind} · {title} ({id})',
  'chat.designToolbox.prompt.resourceDescription': 'คำอธิบายทรัพยากร: {description}',
  'chat.designToolbox.prompt.pluginResource': 'ใช้ปลั๊กอินนี้เป็นบริบทหลักสำหรับขั้นตอนดีไซน์ปัจจุบัน หากมันเปิดให้ป้อนข้อมูลหรือมี GenUI ให้นำทางฉันเลือกเมื่อจำเป็น หากไม่เหมาะกับเป้าหมาย ให้เลือกทรัพยากรส่วนกลางที่ดีกว่าและอธิบายเหตุผล',
  'chat.designToolbox.prompt.mcpResource': 'ให้เลือกใช้ความสามารถของ MCP นี้สำหรับขั้นตอนดีไซน์ถัดไป เมื่อต้องการ asset ภายนอก, การจับภาพเว็บ, การสร้างภาพ/วิดีโอ หรือข้อมูล ให้ตัดสินใจก่อนว่ามันทำงานนั้นได้หรือไม่ แล้วจึงให้แผนที่นำไปใช้ได้จริง',
  'chat.designToolbox.prompt.mcpTemplateResource': 'MCP นี้เป็นเทมเพลตที่ตั้งค่าได้ หากเป็นเครื่องมือที่มีประโยชน์ที่สุดสำหรับขั้นตอนดีไซน์นี้ ให้นำทางการตั้งค่าก่อน หากมีทางเลือกที่ตั้งค่าไว้แล้ว ให้ดำเนินการต่อด้วยทางเลือกนั้น',
  'chat.designToolbox.prompt.connectorResource': 'ใช้ connector นี้เมื่อต้องการข้อมูลจริง, asset, เนื้อหาในบัญชี หรือการเข้าถึงเวิร์กโฟลว์ภายนอก ก่อนใช้งาน ให้อธิบายว่าจะมีการอ่านหรือเขียนอะไรบ้าง และขอการยืนยันเมื่อเหมาะสม',
  'chat.designToolbox.prompt.fileResource': 'ใช้ไฟล์ดีไซน์นี้เป็นเป้าหมายดีไซน์ปัจจุบันหรือ asset อ้างอิง แล้วทำขั้นตอนถัดไปจากมัน หากต้องเปรียบเทียบกับไฟล์อื่น ให้ค้นหาต่อในไฟล์ดีไซน์ทั้งหมด',
  'chat.designToolbox.prompt.resourceIndex': 'ดัชนีทรัพยากรส่วนกลาง: สกิล({skills}), ปลั๊กอิน({plugins}), MCP({mcpEnabled} เปิดใช้งาน / {mcpTemplates} เทมเพลต), connector({connectors} เชื่อมต่อแล้ว), ไฟล์ดีไซน์({files})',
  'chat.designToolbox.prompt.searchableSkills': 'สกิลที่ค้นหาได้',
  'chat.designToolbox.prompt.searchablePlugins': 'ปลั๊กอินที่ค้นหาได้',
  'chat.designToolbox.prompt.availableMcp': 'MCP ที่มีให้ใช้',
  'chat.designToolbox.prompt.connectedConnectors': 'connector ที่เชื่อมต่อแล้ว',
  'chat.designToolbox.prompt.referenceDesignFiles': 'ไฟล์ดีไซน์อ้างอิง',
  'chat.designToolbox.prompt.mcpTemplateName': 'เทมเพลต {name}',
  'chat.designToolbox.prompt.processRule': 'กฎเวิร์กโฟลว์: กำหนดเป้าหมายด้านความสวยงามและข้อจำกัดก่อน แล้วจึงค้นหาและจับคู่ทรัพยากร เมื่อต้องให้ผู้ใช้เลือก ให้สร้าง UI แบบตัวเลือกจำกัด แล้วดำเนินการต่อหลังจากได้รับการยืนยัน',
  'chat.designToolbox.prompt.moreSuffix': ', +อีก {count} รายการ',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'พื้นที่สำหรับการ mention',
  'chat.mentionTabAll': 'ทั้งหมด',
  'chat.mentionTabTabs': 'แท็บ',
  'chat.mentionTabPlugins': 'ปลั๊กอิน',
  'chat.mentionTabSkills': 'สกิล',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'ตัวเชื่อมต่อ',
  'chat.mentionTabFiles': 'ไฟล์ดีไซน์',
  'chat.mentionNoResults': 'ไม่พบผลลัพธ์สำหรับ “{query}”',
  'chat.mentionSearchPrompt': 'ค้นหาไฟล์ดีไซน์, แท็บ, ปลั๊กอิน, สกิล, เซิร์ฟเวอร์ MCP และ connector',
  'chat.mentionSectionTabs': 'แท็บ',
  'chat.mentionSectionPlugins': 'ปลั๊กอิน',
  'chat.mentionSectionSkills': 'สกิล',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'ตัวเชื่อมต่อ',
  'chat.mentionSectionFiles': 'ไฟล์ดีไซน์',
  'chat.mentionActiveSkill': 'ใช้งานอยู่',
  'chat.mentionUseMcpTitle': 'ใช้ {name}',
  'chat.mentionUseConnectorTitle': 'ใช้ {name}',
  'chat.mentionPluginOfficial': 'ทางการ',
  'chat.mentionPluginMine': 'ปลั๊กอินของฉัน',
  'chat.linkedFolderRemoveAria': 'ลบโฟลเดอร์ที่ลิงก์ {path}',
  'chat.linkedFolderNotFound': 'หาโฟลเดอร์ไม่เจอ',
  'chat.linkedFolderAlready': 'ลิงก์ไว้แล้ว',
  'chat.linkedFolderPickError': 'เปิดโฟลเดอร์ไม่ได้',
  'chat.queuedHeader': 'อยู่ในคิว',
  'chat.queuedToSend': 'เพื่อส่ง',
  'chat.queuedEditQueuedTaskAria': 'แก้ไขงานในคิว',
  'chat.queuedSave': 'บันทึก',
  'chat.queuedCancel': 'ยกเลิก',
  'chat.queuedReorder': 'ลากเพื่อจัดลำดับใหม่',
  'chat.queuedEdit': 'แก้ไข',
  'chat.queuedMore': 'อยู่ในคิวเพิ่มเติม',
  'chat.queuedFollowUpFallback': 'งานต่อเนื่องในคิว',
  'chat.send': 'ส่ง',
  'chat.stop': 'หยุด',
  'chat.removeAria': 'ลบ {name}',
  'chat.example1Title': 'ตัวอย่างคำสั่งบรรณาธิการ',
  'chat.example1Tag': 'นิตยสาร',
  'chat.example1Prompt': 'สไลด์บทความบรรณาธิการ 10 หน้า จัดวางแบบคลาสสิค สไตล์นิตยสารและเพิ่มตัวหนังสือใหญ่ๆ',
  'chat.example2Title': 'ตัวอย่างแดชบอร์ด Analytics',
  'chat.example2Tag': 'ข้อมูล',
  'chat.example2Prompt': 'แดชบอร์ดการวิเคราะห์เครื่องมือ SaaS — แถบแสดง KPI และตารางวิเคราะห์สถิติ',
  'chat.example3Title': 'ตัวอย่างรายงานหน้ายาว',
  'chat.example3Tag': 'บรรณาธิการ',
  'chat.example3Prompt': 'หน้าจอรายงานผลกิจกรรมประจำปีแบบแสดงข้อความและกราฟ เลื่อนดูได้ยาวๆ',
  'preview.shareMenu': 'แชร์',
  'preview.exportMenu': 'ส่งออก',
  'preview.shareTemplateBadge': 'เทมเพลต',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'คัดลอกลิงก์เทมเพลต',
  'preview.copyShareText': 'คัดลอกข้อความสำหรับแชร์',
  'preview.shareSocialGroup': 'แชร์ไปยังโซเชียล',
  'preview.shareCopyGroup': 'คัดลอก',
  'preview.shareExportGroup': 'ส่งออกไฟล์',
  'preview.shareCopied': 'คัดลอกแล้ว',
  'preview.shareCopyFailed': 'คัดลอกไม่สำเร็จ',
  'preview.shareTextDefault': 'เทมเพลต Gini Studio: {title}',
  'preview.openInNewTab': 'เปิดในแท็บใหม่',
  'preview.exit': '⤓ ออก',
  'preview.fullscreen': '⤢ เต็มหน้าจอ',
  'preview.closeTitle': 'ปิด (Esc)',
  'preview.loading': 'กำลังโหลด {label}…',
  'preview.errorTitle': 'โหลดผิดพลาด',
  'preview.errorBody': 'โหลด HTML ไม่สำเร็จ โปรดลองอีกครั้ง',
  'preview.retry': 'ลองอีกครั้ง',
  'preview.unavailableTitle': 'ไม่มีตัวอย่างที่เผยแพร่สำหรับ {noun}',
  'preview.unavailableBody': 'เรียกใช้พรอมต์ในแชทเพื่อสร้างผลลัพธ์ {kind}',
  'preview.nounSkill': 'สกิลนี้',
  'preview.nounPlugin': 'ปลั๊กอินนี้',
  'preview.nounTemplate': 'เทมเพลตนี้',
  'preview.showSidebar': 'แสดง {label}',
  'preview.hideSidebar': 'ซ่อน {label}',
  'misc.savedTemplate': 'เทมเพลตที่เก็บไว้',
  'misc.primary': 'หลัก',
  'misc.designSystem': 'ระบบการออกแบบ',
  'workspace.designFiles': 'ไฟล์งานดีไซน์',
  'workspace.focusMode': 'โหมดโฟกัส',
  'workspace.showChat': 'เปิดแชท',
  'workspace.closeTab': 'ปิดแท็บ',
  'workspace.deleteFileConfirm': 'ลบ "{name}" ทิ้งไปเลยหรือไม่?',
  'workspace.deleteSelectedFilesConfirm': 'ลบไฟล์ {n} รายการที่เลือกออกจากโปรเจกต์?',
  'workspace.deleteSelectedFilesPartial': 'ลบ {n} รายการไม่ผ่าน',
  'workspace.openFromDesignFiles': 'เปิดไฟล์จาก',
  'workspace.designFilesLink': 'หน้าไฟล์งาน',
  'workspace.loadingSketch': 'กำลังโหลดกระดานวาด…',
  'workspace.newTab': 'แท็บใหม่',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'แท็บที่เปิดอยู่',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.terminalStarting': 'กำลังเริ่มเทอร์มินัล…',
  'workspace.terminalStartingDescription': 'กำลังเตรียมเชลล์ของโปรเจกต์ โดยปกติใช้เวลาไม่กี่วินาที',
  'workspace.terminalSessionEnded': 'เซสชันสิ้นสุดแล้ว',
  'workspace.terminalReconnecting': 'กำลังเชื่อมต่อใหม่…',
  'workspace.terminalStartFailed': 'ไม่สามารถเริ่มเซสชันเทอร์มินัลได้',
  'workspace.terminalRestart': 'เริ่มใหม่',
  'generationPreview.title': 'กำลังสร้าง…',
  'generationPreview.failedTitle': 'การสร้างล้มเหลว',
  'generationPreview.failedFallback': 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',
  'generationPreview.footnote': 'โดยปกติใช้เวลา 2–5 นาที',
  'generationPreview.stepUnderstand': 'กำลังทำความเข้าใจความต้องการ',
  'generationPreview.stepGenerate': 'กำลังสร้างหน้า',
  'generationPreview.stepPrepare': 'กำลังเตรียมตัวอย่าง',
  'generationPreview.retry': 'ลองใหม่',
  'generationPreview.awaitingTitle': 'กำลังรอข้อมูลจากคุณ',
  'generationPreview.awaitingLead': 'ตอบคำถามสองสามข้อในแชทเพื่อดำเนินการต่อ',
  'generationPreview.stoppedTitle': 'หยุดการสร้างชั่วคราว',
  'generationPreview.stoppedLead': 'ดำเนินการขั้นตอนที่เหลือต่อจากแชทด้านซ้าย',
  'generationPreview.reasonAuth': 'การเข้าสู่ระบบหรือการอนุญาตหมดอายุ',
  'generationPreview.reasonRateLimited': 'มีคำขอมากเกินไป',
  'generationPreview.reasonService': 'บริการสร้างไม่พร้อมใช้งานชั่วคราว',
  'generationPreview.reasonBalance': 'ยอดคงเหลือในบัญชีหมด',
  'designFiles.title': 'ไฟล์ดีไซน์',
  'designFiles.upload': 'อัปโหลดไฟล์',
  'designFiles.pasteText': 'วางข้อความมาเป็นไฟล์',
  'designFiles.newSketch': 'กระดานวาดใหม่',
  'designFiles.empty': 'ลากไฟล์มาใส่เลย หรือสร้างภาพสเก็ตช์',
  'designFiles.refresh': 'รีเฟรช',
  'designFiles.delete': 'ลบ',
  'designFiles.searchPlaceholder': 'ค้นหาไฟล์…',
  'designFiles.up': 'กลับขึ้นบน',
  'designFiles.back': 'ย้อนกลับ',
  'designFiles.crumbs': 'โปรเจกต์',
  'designFiles.rowMenu': 'เมนูจัดการ',
  'designFiles.openInTab': 'เปิดในแท็บ',
  'designFiles.download': 'ดาวน์โหลด',
  'designFiles.downloadSelected': 'โหลด {n} ลงเป็น ZIP',
  'designFiles.deleteSelected': 'ลบ {n}',
  'designFiles.clearSelection': 'ล้างการเลือก',
  'designFiles.selectPage': 'เลือกทั้งหมดหน้านี้',
  'designFiles.selectAll': 'เลือกทุกอย่าง',
  'designFiles.dropTitle': '⤓ วางไฟล์ที่นี่',
  'designFiles.dropDesc': 'รูป เอกสาร อ้างอิง — เอเจนต์จะเก็บมาใช้วิเคราะห์',
  'designFiles.upload.title': 'อัปโหลดไฟล์',
  'designFiles.paste.title': 'วางข้อความแทนไฟล์',
  'designFiles.upload.label': 'อัปโหลด',
  'designFiles.paste.label': 'วาง',
  'designFiles.previewOpen': 'เปิดดู',
  'designFiles.previewClose': 'ปิดหน้าต่าง',
  'designFiles.modified': 'แก้ไปตอน {time} · {size}',
  'designFiles.weeksAgo': '{n} สัปดาห์มาแล้ว',
  'designFiles.groupBy': 'จัดกลุ่มตาม',
  'designFiles.groupByKind': 'ประเภท',
  'designFiles.groupByModified': 'แก้ไขล่าสุด',
  'designFiles.filterBy': 'กรองตามประเภท',
  'designFiles.filterClear': 'ล้าง',
  'designFiles.filterCount': '{n} ประเภท',
  'designFiles.expandGroup': 'ขยาย',
  'designFiles.collapseGroup': 'ย่อ',
  'designFiles.sectionPages': 'หน้าเว็บ',
  'designFiles.sectionScripts': 'สคริปต์',
  'designFiles.sectionImages': 'รูปภาพ',
  'designFiles.sectionSketches': 'แบบร่าง',
  'designFiles.sectionLiveArtifacts': 'อาร์ติแฟกต์แบบไลฟ์',
  'designFiles.sectionOther': 'อื่นๆ',
  'designFiles.modifiedToday': 'วันนี้',
  'designFiles.modifiedYesterday': 'เมื่อวาน',
  'designFiles.modifiedPrevious7Days': '7 วันก่อนหน้า',
  'designFiles.modifiedPrevious30Days': '30 วันก่อนหน้า',
  'designFiles.modifiedOlder': 'เก่ากว่า',
  'designFiles.showMore': 'เปิดดูอีก +{n}',
  'designFiles.kindHtml': 'ไฟล์ HTML',
  'designFiles.kindImage': 'รูปภาพ',
  'designFiles.kindSketch': 'ภาพวาดร่าง',
  'designFiles.kindText': 'ข้อความ',
  'designFiles.kindCode': 'สคริปต์โค้ด',
  'designFiles.kindPdf': 'เอกสาร PDF',
  'designFiles.kindDocument': 'ไฟล์เอกสาร',
  'designFiles.kindPresentation': 'สไลด์',
  'designFiles.kindSpreadsheet': 'ตารางตัวเลข',
  'designFiles.kindLiveArtifact': 'ตัวแอป Live artifact',
  'designFiles.kindBinary': 'ไฟล์ไบนารี',
  'designFiles.kindFolder': 'โฟลเดอร์',
  'designFiles.folderCount': '{n} ไฟล์',
  'designFiles.newFolderTitle': 'โฟลเดอร์ใหม่',
  'designFiles.newFolderLabel': 'ชื่อโฟลเดอร์',
  'designFiles.moveTitle': 'ย้ายไปยังโฟลเดอร์',
  'designFiles.moveLabel': 'โฟลเดอร์ปลายทาง',
  'designFiles.moveRoot': 'รากของโปรเจกต์',
  'designFiles.moveNewFolder': 'โฟลเดอร์ใหม่…',
  'designFiles.move': 'ย้าย',
  'designFiles.copyPath': 'คัดลอกเส้นทาง',
  'designFiles.copiedPath': 'คัดลอกเส้นทางแล้ว',
  'designFiles.deleteFolderConfirm': 'ลบโฟลเดอร์ "{name}" และเนื้อหาทั้งหมดหรือไม่?',
  'designFiles.folderCreated': 'สร้างโฟลเดอร์ "{name}" แล้ว',
  'designFiles.folderDeleted': 'ลบโฟลเดอร์ "{name}" แล้ว',
  'designFiles.filesMoved': 'ย้าย {n} รายการไปยัง {dest} แล้ว',
  'designFiles.colName': 'ชื่อ',
  'designFiles.colKind': 'ชนิด',
  'designFiles.colModified': 'ใช้งานล่าสุด',
  'designFiles.perPage': 'จำนวนแสดง',
  'designFiles.all': 'ทั้งหมด',
  'designFiles.prev': 'ก่อนหน้า',
  'designFiles.next': 'ถัดไป',
  'designFiles.jumpToPage': 'ไปหน้าที่',
  'designFiles.pageInfo': '{start}–{end} รวม {total}',
  'designFiles.sectionFolders': 'โฟลเดอร์',
  'designFiles.sectionStylesheets': 'สไตล์ชีต',
  'designFiles.sectionDocuments': 'เอกสาร',
  'designFiles.kindStylesheet': 'สไตล์ชีต',
  'designFiles.modifiedExt': 'แก้ไขเมื่อ {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'ข้อมูลที่เป็นประโยชน์',
  'designFiles.usefulInfoTip': 'ดับเบิลคลิกที่ไฟล์ใดก็ได้เพื่อเปิดในแท็บเต็ม',
  'quickSwitcher.placeholder': 'ค้นหาและเปิด…',
  'quickSwitcher.empty': 'ไร้ไฟล์ที่หาได้',
  'quickSwitcher.noMatches': 'ไม่เจอรายการที่ตรง',
  'quickSwitcher.navigate': 'ใช้ลูกศรหา',
  'quickSwitcher.open': 'เปิดได้เลย',
  'quickSwitcher.close': 'ปิดออก',
  'pasteDialog.title': 'วางข้อความตรงนี้',
  'pasteDialog.hint': 'จะถูกบันทึกที่กล่องโปรเจกต์',
  'pasteDialog.fileNameLabel': 'ชื่อ',
  'pasteDialog.namePlaceholder': 'เช่น notes.txt',
  'pasteDialog.contentLabel': 'ใจความหลัก',
  'pasteDialog.contentPlaceholder': 'วางอะไรก็ได้ทั้งนั้น…',
  'pasteDialog.save': 'จัดเก็บ',
  'pasteDialog.cancel': 'ยกเลิก',
  'sketch.save': 'บันทึกรูป',
  'sketch.cancel': 'ยกเลิก',
  'sketch.saving': 'กำลังบันทึกรูปภาพ…',
  'sketch.saved': 'บันทึกแล้ว',
  'sketch.tooltipDirty': 'มีการเปลี่ยนผ่าน',
  'sketch.tooltipClean': 'บันทึกสมบูรณ์',
  'fileViewer.empty': 'คลิกที่ไฟล์เพื่อแสดงดู',
  'fileViewer.loading': 'กำลังเรียกโหลด…',
  'fileViewer.exportPptx': 'ส่งข้อมูลเป็น PPTX',
  'fileViewer.openInNewTab': 'เข้าจากหน้าต่างใหม่',
  'fileViewer.copyPath': 'ก็อปปี้ลิ้งก์',
  'fileViewer.copied': 'ทำการคัดลอก!',
  'fileViewer.share': 'แชร์ต่อ',
  'fileViewer.binaryMeta': 'ข้อมูล Binary · {size}',
  'fileViewer.binaryNote': 'เก็บไว้ในรูปแบบคอมพิวเตอร์ ({size} bytes). ให้คุณกดดาวน์โหลดโหลดดู',
  'fileViewer.pdfMeta': 'PDF ตัวย่อ · {size}',
  'fileViewer.documentMeta': 'ไฟล์เอกสาร',
  'fileViewer.presentationMeta': 'พรีเซนเทชั่น',
  'fileViewer.spreadsheetMeta': 'สเปรดชีตแสดงตาราง',
  'fileViewer.previewUnavailable': 'พรีวิวใช้ไม่ได้ ขอให้เปิดไฟล์จากภายนอกดู',
  'fileViewer.download': 'กดโหลด',
  'fileViewer.open': 'เรียกใช้',
  'fileViewer.imageMeta': 'รูปภาพขนาด · {size}',
  'fileViewer.reactMeta': 'โค้ด React · {size}',
  'fileViewer.sketchMeta': 'สเก็ตช์ · {size}',
  'fileViewer.markdownStreamingMeta': 'เตรียมหน้าพรีวิว…',
  'fileViewer.markdownErrorMeta': 'เกิดการเออเร่อในการจำลอง (อาจมีข้อมูลตกหล่น)',
  'fileViewer.markdownStreamingStatus': 'รอจำลอง… แสดง Markdown มาบ้างแล้ว',
  'fileViewer.markdownErrorStatus': 'พังในขั้นจำลอง แสดงชิ้นส่วนเดิมล่าสุด',
  'fileViewer.videoMeta': 'วิดีโอมาแล้ว · {size}',
  'fileViewer.audioMeta': 'คลิปเสียง · {size}',
  'fileViewer.reload': 'โหลดทับ',
  'fileViewer.reloadDisk': 'ดึงโหลดจากแหล่งล่าสุด',
  'fileViewer.copy': 'ก็อปปี้',
  'fileViewer.copyTitle': 'คัดลอกแบบจัดเต็ม',
  'fileViewer.saveDisabled': 'ปุ่มเซฟ (ตอนนี้อ่านได้เท่านั้น)',
  'fileViewer.save': 'เซฟด่วน',
  'fileViewer.preview': 'หน้าพรีวิว',
  'fileViewer.source': 'ซอร์สไฟล์',
  'fileViewer.tweaks': 'ตั้งปรับแต่ง',
  'fileViewer.tweaksUnavailable': 'ไม่มีพาเนลตั้งปรับแต่งในชิ้นงานนี้',
  'fileViewer.jsxModuleTitle': 'ไม่มีการแสดงตัวอย่างแบบสแตนด์อโลน',
  'fileViewer.jsxModuleBody': 'ไฟล์นี้เป็นโมดูลคอมโพเนนต์ที่ถูกโหลดโดยหน้าอื่น',
  'fileViewer.jsxModuleCta': 'เปิดหน้าที่แสดงผลไฟล์นี้:',
  'fileViewer.comment': 'ช่วยคอมเมนต์',
  'fileViewer.edit': 'จัดการแก้ไข',
  'fileViewer.draw': 'วาดรูป',
  'fileViewer.mark': 'มาร์ก',
  'fileViewer.markTool': 'เครื่องมือมาร์ก',
  'fileViewer.boxSelect': 'เลือกแบบกล่อง',
  'fileViewer.screenshot': 'ภาพหน้าจอ',
  'manualEdit.layers': 'เลเยอร์',
  'manualEdit.editableCount': 'ใช้แก้ได้ {count} รูปแบบ',
  'manualEdit.hiddenBadge': 'ซ่อน',
  'manualEdit.title': 'กล่องควบคุม',
  'manualEdit.fallbackTitle': 'แก้ไข',
  'manualEdit.movePanel': 'ย้ายแผงแก้ไข',
  'manualEdit.editParams': 'แก้ไขพารามิเตอร์',
  'manualEdit.closePanel': 'ปิดแผงแก้ไข',
  'manualEdit.selectLayer': 'เลือกเลเยอร์ขึ้นมา',
  'manualEdit.empty': 'เลือกกล่องด้านบนเพื่อเปิดดู',
  'manualEdit.noEditableLayers': 'ไม่พบเลเยอร์ที่แก้ไขได้',
  'manualEdit.noClass': 'ไร้คลาสสไตล์',
  'manualEdit.tabsAria': 'แท็บปรับโครง',
  'manualEdit.tabContent': 'ตัวหนังสือ',
  'manualEdit.tabStyle': 'สไตล์การตกแต่ง',
  'manualEdit.tabAttributes': 'พิกัดส่วนเสริม',
  'manualEdit.tabHtml': 'โค้ด HTML',
  'manualEdit.tabSource': 'ต้นกำเนิดโค้ด',
  'manualEdit.attributesJson': 'พิกัด JSON',
  'manualEdit.selectedHtml': 'โค้ดในตัวที่เลือก',
  'manualEdit.fullSource': 'เนื้อแท้ข้อมูลระบบ',
  'manualEdit.applyContent': 'รับเนื้อหาเข้า',
  'manualEdit.applyStyle': 'ใช้โครงตกแต่ง',
  'manualEdit.applyAttributes': 'รับพิกัดเข้า',
  'manualEdit.applyHtml': 'ตั้งต้น HTML',
  'manualEdit.applySource': 'รับโค้ดรันระบบ',
  'manualEdit.invalidAttributes': 'JSON แอททริบิวต์ใช้งานจริงไม่ได้',
  'manualEdit.changes': 'จุดถูกแก้แล้ว',
  'manualEdit.undo': 'กลับไปเก่า',
  'manualEdit.redo': 'เลื่อนมาใหม่',
  'manualEdit.noChanges': 'การใช้มือแก้ยังไม่มี',
  'manualEdit.imageUrl': 'จุดฝังภาพ (URL)',
  'manualEdit.altText': 'ตัวหนังสือข้อความลับ',
  'manualEdit.label': 'ตัวหนังสือข้างหน้า',
  'manualEdit.text': 'ข้อความ',
  'manualEdit.href': 'ตัวลิ้งก์ข้ามทาง (Href)',
  'manualEdit.textColor': 'ชุดสีตัวหนังสือ',
  'manualEdit.background': 'สีแผ่นพื้นหลัง',
  'manualEdit.fontSize': 'ความใหญ่ตัวหนังสือ',
  'manualEdit.weight': 'น้ำหนักความเข้ม',
  'manualEdit.align': 'ชิดกะตำแหน่ง',
  'manualEdit.padding': 'ขยายเขตภายใน',
  'manualEdit.margin': 'ขยายเขตภายนอก',
  'manualEdit.radius': 'ขอบมน',
  'manualEdit.border': 'ความหนาเส้น',
  'manualEdit.width': 'ขนาดความกว้าง',
  'manualEdit.minHeight': 'ส่วนเตี้ยที่สุด',
  'manualEdit.deleteElement': 'ลบองค์ประกอบ',
  'manualEdit.deleteElementConfirm': 'ลบองค์ประกอบที่เลือกหรือไม่ สามารถยกเลิกได้ด้วยเลิกทำ',
  'manualEdit.uploadImage': 'อัปโหลดรูปภาพ',
  'manualEdit.uploadingImage': 'กำลังอัปโหลดรูปภาพ…',
  'manualEdit.uploadImageFailed': 'ไม่สามารถอัปโหลดรูปภาพได้',
  'manualEdit.focusSlides': 'โฟกัสสไลด์',
  'manualEdit.showPanels': 'แสดงแผง',
  'fileViewer.zoomOut': 'หุบมุมมอง',
  'fileViewer.zoomIn': 'ซูมมองชัด',
  'fileViewer.resetZoom': 'ซูมรีเซ็ตหน้าจอ',
  'fileViewer.viewportAria': 'วิวพอร์ตตัวอย่าง',
  'fileViewer.viewportDesktop': 'เดสก์ท็อป',
  'fileViewer.viewportDesktopTitle': 'ตัวอย่างเดสก์ท็อปแบบเต็มความกว้าง',
  'fileViewer.viewportTablet': 'แท็บเล็ต',
  'fileViewer.viewportTabletTitle': 'ตัวอย่างแท็บเล็ตที่ 820 × 1180 (เกณฑ์แนวตั้งสมัยใหม่)',
  'fileViewer.viewportMobile': 'มือถือ',
  'fileViewer.viewportMobileTitle': 'ตัวอย่างมือถือที่ 390 × 844',
  'fileViewer.reloadAria': 'กดรีโหลดให้สด',
  'fileViewer.previousSlide': 'เลื่อนสไลด์ก่อนหน้า',
  'fileViewer.nextSlide': 'สไลด์แผ่นหน้า',
  'fileViewer.slideNavAria': 'ตัวเลื่อนเปลี่ยนหน้า',
  'fileViewer.present': 'เปิดจอโชว์',
  'fileViewer.presentInTab': 'ค้างในหน้าจอแท็บ',
  'fileViewer.presentFullscreen': 'ยืดให้เต็มที่หน้าจอ',
  'fileViewer.presentNewTab': 'เข้าสู่ลิ้งก์หน้าใหม่',
  'fileViewer.speakerNotes': 'โน้ตผู้บรรยาย',
  'fileViewer.speakerNotesSlide': 'สไลด์ {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'ไม่มีโน้ตผู้บรรยายสำหรับสไลด์นี้',
  'fileViewer.speakerNotesEdit': 'แก้ไข',
  'fileViewer.speakerNotesSave': 'บันทึกโน้ต',
  'fileViewer.speakerNotesPlaceholder': 'เพิ่มโน้ตผู้บรรยายสำหรับสไลด์นี้…',
  'fileViewer.presenterEmptyDeck': 'ไม่มีสไลด์ในเด็คนี้',
  'fileViewer.presenterReset': 'รีเซ็ต',
  'fileViewer.presenterMode': 'โหมดผู้นำเสนอ',
  'fileViewer.deckThumbnailRailAria': 'สไลด์',
  'fileViewer.presenterPause': 'หยุดชั่วคราว',
  'fileViewer.presenterResume': 'ทำต่อ',
  'fileViewer.presenterPrevious': 'ก่อนหน้า',
  'fileViewer.presenterNext': 'ถัดไป',
  'fileViewer.exitPresentation': 'หนีออกโหมดคนโชว์',
  'fileViewer.shareLabel': 'แชร์',
  'fileViewer.shareMenuShareLink': 'แชร์',
  'fileViewer.shareMenuPublishOnline': 'เผยแพร่ออนไลน์',
  'fileViewer.shareMenuDownload': 'ดาวน์โหลด',
  'fileViewer.shareMenuPresentation': 'งานนำเสนอ',
  'fileViewer.shareMenuSourceFiles': 'ไฟล์ต้นฉบับ',
  'fileViewer.shareMenuSave': 'บันทึก',
  'fileViewer.copyShareLink': 'คัดลอกลิงก์แชร์',
  'fileViewer.openSharePage': 'เปิดหน้าแชร์',
  'fileViewer.shareLinkRequiresDeploy': 'เผยแพร่ออนไลน์ก่อนเพื่อรับลิงก์',
  'fileViewer.shareLinkPublishGuide': 'เผยแพร่ออนไลน์ด้านบนเพื่อเปิดใช้การแชร์ ↑',
  'fileViewer.shareAfterGenerationComplete': 'แชร์ได้หลังจากสร้างเสร็จ',
  'fileViewer.copyProviderLink': 'คัดลอกลิงก์ {provider}',
  'fileViewer.copyCloudflareLink': 'คัดลอกลิงก์ Cloudflare',
  'fileViewer.screenshotCopying': 'กำลังคัดลอกภาพหน้าจอ...',
  'fileViewer.screenshotCopied': 'คัดลอกภาพหน้าจอไปยังคลิปบอร์ดแล้ว',
  'fileViewer.screenshotClipboardDenied': 'เบราว์เซอร์บล็อกการเข้าถึงคลิปบอร์ด',
  'fileViewer.screenshotPreviewLoading': 'ตัวอย่างยังคงโหลดอยู่ ลองอีกครั้งในอีกสักครู่',
  'fileViewer.screenshotCaptureFailed': 'ไม่สามารถจับภาพตัวอย่างได้ โปรดลองอีกครั้ง',
  'fileViewer.exportPdf': 'เปลี่ยนฟอร์แมตเอาไปเป็น PDF',
  'fileViewer.exportPdfAllSlides': 'ดาวน์โหลดทั้งหน้าเป็น PDF',
  'fileViewer.exportPptxBusy': 'ต้องให้ทำระบบของปัจจุบันจนสำเร็จก่อน',
  'fileViewer.exportPptxHint': 'ส่งข้อมูลเพื่อให้ทำการแปลเอกสารเป็น PPTX',
  'fileViewer.exportPptxNa': 'งาน PPTX ไม่สามารถดึงออกในจุดนี้ได้',
  'fileViewer.exportZip': 'สูบทั้งหมดมาในรูป .zip',
  'fileViewer.exportHtml': 'เอาไปแค่รูปไฟล์ HTML',
  'fileViewer.exportMd': 'แปลงข้อความแบบฉบับเป็น Markdown',
  'fileViewer.exportImage': 'ส่งออกเป็นรูปภาพ',
  'fileViewer.exportImageFailed': 'การจับภาพล้มเหลว กรุณาลองอีกครั้งหรือใช้เครื่องมือจับภาพหน้าจอของเบราว์เซอร์',
  'fileViewer.exportImageModalSubtitle': 'เลือกรูปแบบ แล้วดาวน์โหลดตัวอย่างปัจจุบันเป็นรูปภาพ',
  'fileViewer.exportImageFormatLabel': 'รูปแบบ',
  'fileViewer.exportImageSaving': 'กำลังบันทึกรูปภาพ…',
  'fileViewer.exportImageSaved': 'บันทึกรูปภาพแล้ว',
  'fileViewer.exportImageDownloadStarted': 'เริ่มดาวน์โหลดแล้ว',
  'fileViewer.exportImageDownloadDetails': 'หากไม่มีหน้าต่างบันทึกเป็นปรากฏขึ้น ให้ตรวจสอบ {filename} ในโฟลเดอร์ดาวน์โหลดของเบราว์เซอร์',
  'fileViewer.exportJsx': 'นำโค้ดในรูปแบบ React JSX ออก',
  'fileViewer.exportReactHtml': 'แยกโหลดมาแค่โครง HTML เท่านั้น',
  'fileViewer.exportStarted': 'เริ่มการส่งออกแล้ว',
  'fileViewer.saveAsTemplate': 'จัดเก็บในหมวดเทมเพลต…',
  'fileViewer.savingTemplate': 'ระบบคอยเซฟแม่แบบให้…',
  'fileViewer.savedTemplate': 'ได้สร้างเทมเพลตใหม่ชื่อ "{name}"',
  'fileViewer.savedTemplateFail': 'ติดปัญหาที่การจำข้อมูลเทมเพลต — ทบทวนให้ดีแล้วกดอีกหน',
  'fileViewer.templateNamePrompt': 'ระบุชื่อตัวเทมเพลต',
  'fileViewer.templateNameDefault': 'แม่แบบว่างไม่มีการระบุชื่อ',
  'fileViewer.templateDescPrompt': 'อธิบายลักษณะเพิ่มเติม (ไม่จำเป็นต้องใส่เลยก็ได้ — แต่มีก็ดีต่อความเข้าใจในครั้งหน้า)',
  'liveArtifact.refresh.button': 'ดึงค่าเริ่มระบบอีกหน',
  'liveArtifact.refresh.buttonTitle': 'รีค่าการทำตัว Live artifact ใหม่',
  'liveArtifact.refresh.loadingTitle': 'ขอเวลาเพื่อดึงของ Live artifact…',
  'liveArtifact.refresh.noSourceTitle': 'ของดั้งเดิมยังไม่เคยมีให้ทำการอัปเดตต่อ',
  'liveArtifact.refresh.running': 'ระบบรันหาค่าอีกคราว…',
  'liveArtifact.refresh.runningMessage': 'เรียกโครงและหน้าตัวโชว์อยู่ โปรดเผื่อเวลา',
  'liveArtifact.refresh.runningAction': 'สิ่งพรีวิวที่มีจากของเก่าอยู่จะได้เห็นเรื่อยไป จนของครั้งหน้าสำเร็จถึงโชว์',
  'liveArtifact.refresh.successOne': 'ผ่านตลอด ได้ผลของล่าสุดแทนแล้ว',
  'liveArtifact.refresh.successMany': 'ผ่านตลอด ได้ผลของล่าสุดแทนแล้ว',
  'liveArtifact.refresh.successAction': 'เปลี่ยนระบบของเดิมเสร็จ ภาพโชว์ใหม่เอาไปใช้งานต่อแล้ว',
  'liveArtifact.refresh.previousFailure': 'ของคราวก่อนหลุดความสำเร็จไป: {message}',
  'liveArtifact.refresh.failureAction': 'ตรวจสอบปัญหาและช่องทางข้อมูลของตัวเดิมก่อน เพื่อกดเปิดใช้งานอีกที',
  'liveArtifact.refresh.networkFailure': 'รีเฟรชเครือข่ายส่งไม่ติด อาจจะมีเรื่องสัญญานตก',
  'liveArtifact.refresh.genericFailure': 'ระบบรีไม่สมบูรณ์',
  'liveArtifact.refresh.statusNever': 'ไร้สิ่งที่สามารถดึงค่าได้',
  'liveArtifact.refresh.statusReady': 'เตรียมเริ่มลุยรอบดึงใหม่',
  'liveArtifact.refresh.statusSucceeded': 'ได้ที่ของสดใหม่',
  'liveArtifact.refresh.statusFailed': 'เสียสูญกับการรอรีข้อมูล',
  'liveArtifact.refresh.statusRunning': 'กำลังรีเฟรช',
  'liveArtifact.refresh.statusRunningDescription': 'การรีเฟรชกำลังดำเนินการอยู่ในขณะนี้',
  'liveArtifact.refresh.statusSucceededDescription': 'การรีเฟรชครั้งล่าสุดเสร็จสมบูรณ์',
  'liveArtifact.refresh.statusFailedDescription': 'ความพยายามรีเฟรชครั้งล่าสุดไม่เสร็จสมบูรณ์',
  'liveArtifact.refresh.statusReadyDescription': 'มีการตั้งค่าแหล่งข้อมูลที่รีเฟรชได้ แต่ไม่มีการรันใดกำลังดำเนินอยู่',
  'liveArtifact.refresh.statusNeverDescription': 'อาร์ติแฟกต์แบบไลฟ์นี้ยังไม่มีแหล่งข้อมูลสำหรับรีเฟรช',
  'liveArtifact.refresh.eventStarted': 'เริ่มแล้ว',
  'liveArtifact.refresh.eventSucceeded': 'สำเร็จ',
  'liveArtifact.refresh.eventFailed': 'ล้มเหลว',
  'liveArtifact.refresh.eventStartedDetail': 'เริ่มรีเฟรชแล้ว…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'อัปเดตแล้ว {n} แหล่งข้อมูล',
  'liveArtifact.refresh.sourcesUpdatedMany': 'อัปเดตแล้ว {n} แหล่งข้อมูล',
  'liveArtifact.refresh.timelineEmpty': 'ยังไม่มีกิจกรรมการรีเฟรชในเซสชันนี้ เรียกใช้รีเฟรชเพื่อบันทึกไทม์ไลน์ หรือรอการรันอัตโนมัติ',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'รีเฟรชล่าสุด',
  'liveArtifact.refresh.heroLastRefreshedNever': 'ไม่เคย',
  'liveArtifact.refresh.justNow': 'เมื่อสักครู่',
  'liveArtifact.refresh.factCreated': 'สร้างแล้ว',
  'liveArtifact.refresh.factLastUpdated': 'อัปเดตล่าสุด',
  'liveArtifact.refresh.factUnknown': 'ไม่ทราบ',
  'liveArtifact.refresh.persistedTitle': 'ประวัติการรีเฟรชที่บันทึกไว้',
  'liveArtifact.refresh.persistedHint': 'รายการที่โหลดจาก refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'ยังไม่มีประวัติการรีเฟรชที่บันทึกไว้',
  'liveArtifact.refresh.persistedStatusSucceeded': 'สำเร็จ',
  'liveArtifact.refresh.persistedStatusRunning': 'กำลังทำงาน',
  'liveArtifact.refresh.persistedStatusFailed': 'ล้มเหลว',
  'liveArtifact.refresh.persistedStatusCancelled': 'ยกเลิกแล้ว',
  'liveArtifact.refresh.persistedStatusSkipped': 'ข้ามแล้ว',
  'liveArtifact.refresh.sessionTitle': 'กิจกรรมของเซสชัน',
  'liveArtifact.refresh.sessionHint': 'เหตุการณ์ที่สังเกตได้ขณะเปิดแท็บนี้',
  'liveArtifact.refresh.docSourceTitle': 'แหล่งที่มาของเอกสาร',
  'liveArtifact.refresh.docSourceHint': 'กำหนดค่าแหล่งที่มาแล้ว',
  'liveArtifact.refresh.docSourceType': 'ประเภท',
  'liveArtifact.refresh.docSourceTool': 'เครื่องมือ',
  'liveArtifact.refresh.docSourceConnector': 'ตัวเชื่อมต่อ',
  'liveArtifact.refresh.debugSummary': 'ข้อมูลเมตาสำหรับการดีบักขั้นสูง',
  'liveArtifact.refresh.debugNote': 'อาจรวมถึง ID ของ connector ชื่อไฟล์ ข้อมูลเมตาของแหล่งที่มา และเส้นทางอาร์ติแฟกต์ภายใน',
  'liveArtifact.viewer.tabPreview': 'พรีวิวภาพ',
  'liveArtifact.viewer.tabCode': 'คำสั่งโค้ด',
  'liveArtifact.viewer.tabData': 'ผลข้อมูล',
  'liveArtifact.viewer.tabRefreshHistory': 'ข้อมูลตอนสั่งเรียกครั้งเก่า',
  'liveArtifact.viewer.dataEmpty': 'Data.json ในตัวของยังไม่โผล่',
  'liveArtifact.viewer.code.templateHeading': 'โครงอักษร HTML เทมเพลต',
  'liveArtifact.viewer.code.renderedHeading': 'สิ่งที่สร้างเรนเดอร์มาที่แท้จริงแบบ HTML',
  'liveArtifact.viewer.code.templateHelp': 'แม่พิมพ์ถูกเตรียมการรวมด้วยค่าตัวของ data.json ไว้พร้อมโชว์พรีวิวแล้ว',
  'liveArtifact.viewer.code.renderedHelp': 'หน้าตาดั้งเดิมของที่สร้างได้ไว้เข้าใช้จริงแบบฉบับ index.html',
  'liveArtifact.viewer.code.variantAria': 'หมวดรวมส่วนแบบร่าง',
  'liveArtifact.viewer.code.variantTemplate': 'กลุ่มเทมเพลต',
  'liveArtifact.viewer.code.variantRendered': 'เรนเดอร์แล้ว',
  'liveArtifact.viewer.code.loading': 'ตามโค้ดเข้ามา…',
  'liveArtifact.viewer.code.unavailable': 'โค้ดที่หาอาจจะไร้ซึ่งข้อมูล',
  'liveArtifact.viewer.code.empty': 'ไม่มีสิ่งใดเขียนตกค้างไว้เลยในนี้',
  'fileViewer.deployToVercel': 'ขึ้นสู่ระดับ Deploy เพื่อ Vercel',
  'fileViewer.redeployToVercel': 'Deploy ทับอันเดิม',
  'fileViewer.deployingToVercel': 'ขอ Deploy เข้าสู่ผู้ดูแล Vercel…',
  'fileViewer.deployProviderLabel': 'ส่วนพื้นที่ผู้จัดการ',
  'fileViewer.vercelProvider': 'ทีม Vercel',
  'fileViewer.cloudflarePagesProvider': 'โฮส Cloudflare Pages',
  'fileViewer.deployToProvider': 'จัดนำโฮสติ้งไปเพื่อ {provider}',
  'fileViewer.redeployToProvider': 'ใช้ทับการ Deploy กับทาง {provider}',
  'fileViewer.deployingToProvider': 'กำลังย้ายข้อมูลเข้าไปสู่ {provider}…',
  'fileViewer.preparingPublicLink': 'จัดทำลิ้งก์ให้พบเห็นทางด้านนอก…',
  'fileViewer.copyDeployLink': 'ลอกลิ้งก์เซฟใช้',
  'fileViewer.deployModalTitle': 'สั่งขึ้นโฮสต์เพื่อ Deploy',
  'fileViewer.deployModalSubtitle': 'เลือกจัดการผสานเชื่อมการทำงานในรูป HTML นี้ให้ออกไปได้เลย',
  'fileViewer.vercelToken': 'ระบบเหรียญของ Vercel Token',
  'fileViewer.vercelTokenGetLink': 'ขอเอา Vercel Token นำมาใช้',
  'fileViewer.vercelTokenPlaceholder': 'วางลงรหัส Vercel Token',
  'fileViewer.vercelTokenReuseHint': 'จะนำข้อมูลเดิมที่ถูกจัดเก็บมาใช้ต่อเลย หากต้องการตัวอื่นก็เอามาพิมพ์ตรงนี้',
  'fileViewer.vercelTokenRequired': 'วางรหัสตัว Vercel ก่อน ถึงจะเริ่มได้',
  'fileViewer.cloudflareApiToken': 'ใช้โทเคนจากฝั่ง Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'รับ API token',
  'fileViewer.cloudflareApiTokenPlaceholder': 'นำ Cloudflare ตัวใหม่แปะตรงช่อง',
  'fileViewer.cloudflareApiTokenReuseHint': 'โทเค็นตัวที่ผูกไว้จะได้การใช้งานก่อนเป็นอย่างดี ต้องการตัวใหม่ก็นำทับได้เลย',
  'fileViewer.cloudflareApiTokenRequired': 'เซฟ Cloudflare เพื่อเข้าใช้งานให้ถูกต้อง',
  'fileViewer.cloudflareApiTokenScopeHint': 'เลือก Pages Edit ตอนสร้าง API token; โดเมนแบบกำหนดเองต้องใช้ Zone Read / DNS Edit',
  'fileViewer.vercelTeamId': 'กรอกรหัสสำหรับระดับทีม ID',
  'fileViewer.vercelTeamSlug': 'นามพ่วงทีมแบบย่อ',
  'fileViewer.cloudflareAccountId': 'หมวดระดับรหัสบัญชีหลัก',
  'fileViewer.cloudflareAccountIdHint': 'ค้นหา account ID ได้ในแดชบอร์ด Cloudflare',
  'fileViewer.cloudflareAccountIdRequired': 'โปรดป้อนเก็บไว้ Cloudflare หลัก Account ID ในเครื่องก่อนเริ่ม',
  'fileViewer.cloudflareZoneLabel': 'ตัวเชื่อมแบบโดเมน',
  'fileViewer.cloudflareZonePlaceholder': 'นำเครื่องมือตั้งต่าในหน้าหลักเพื่อเปิดลิงก์ทั้งหมดมาใช้',
  'fileViewer.cloudflareZoneRequired': 'เอาตัว Cloudflare โดเมน มากรอกให้เสร็จ',
  'fileViewer.cloudflareZonesLoading': 'เครื่องมือกำลังเช็ค Cloudflare โดเมน ทั้งระบบ…',
  'fileViewer.cloudflareZonesRefresh': 'รีข้อมูลเรียกตัวโดเมน',
  'fileViewer.cloudflareZonesLoadFailed': 'การเซฟตัวของโดเมนเข้าใน Cloudflare ประสบข้อไม่พบของที่จะโหลดได้',
  'fileViewer.cloudflareZonesEmpty': 'บัญชีนี้ยังขาดการเข้าเซฟข้อมูลจากโดเมนระดับแบบสมบูรณ์มาใช้ด้วยกัน',
  'fileViewer.cloudflareDomainPrefixLabel': 'กลุ่มของคำนำหน้าใน Subdomain Prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'เดโม่ (demo)',
  'fileViewer.cloudflareDomainPrefixInvalid': 'คำโดเมนรองนี้ให้ใช้อักษรพิเศษอย่างยัติภังค์ (ขีด) กับตัวเลขและพิมพ์เล็กได้ ไม่ให้ใช้อย่างอื่นที่ผิดแปลกไปเลย',
  'fileViewer.cloudflareHostnamePreview': 'ความพร้อมตัวโฮสต์รอง: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'ไม่บังคับ: ผูกโดเมนแบบกำหนดเอง หากเว้นว่างไว้จะยังสร้างลิงก์ pages.dev',
  'fileViewer.cloudflarePagesDevLinkLabel': 'ลิ้งก์จากช่องทางฟรี pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'ตัวลิ้งก์ Custom แบบมีโดเมนเสริม',
  'fileViewer.optional': 'ตัวเลือกเสริม',
  'fileViewer.vercelPreviewOnly': 'ปัจจุบันการโชว์ Deploy มีเปิดให้แต่พรีวิวการใช้งานเท่านั้น',
  'fileViewer.cloudflarePagesPreviewHint': 'สามารถส่งข้อมูลโฮสต์ผ่านแบบ Direct Upload ตรงเข้าสู่ของ Cloudflare ไปเลย',
  'fileViewer.savingConfig': 'คอยจัดระเบียบให้…',
  'fileViewer.deployConfigSaveFailed': 'จำคำสั่งเชื่อมระบบฝั่ง Vercel เข้ามาไม่ได้',
  'fileViewer.deployFailed': 'เกิดความล้มเหลวกับการเรียกตัว Deployment ขอไปปรับเครื่องมือ Vercel ใหม่แล้วลองซ้ำนะ',
  'fileViewer.deployProviderConfigSaveFailed': 'ปรับเปลี่ยนและนำตั้งค่าเซฟไม่ได้บนฝั่งผู้บริการ {provider}',
  'fileViewer.deployProviderFailed': 'โฮสต์ไม่ติดสำหรับตัวผู้ดำเนินการ {provider} เช็คการควบคุมดูอีกรอบก่อนเถอะ',
  'fileViewer.deployResultLabel': 'ที่อยู่แบบ URL ซึ่งอัพลง',
  'fileViewer.deployLinkReady': 'ลุยได้ทันที',
  'fileViewer.deploySuccessToast': 'อัปโหลดการ Deploy สำเร็จแล้ว',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'เตรียมออกสู่หน้าผู้คนข้างนอก',
  'fileViewer.deployLinkDelayed': 'ตัวเว็บนั้นเข้าใช้งานได้แต่ความพร้อมยังถูกแช่ไว้บ้างอยู่',
  'fileViewer.deployLinkFailed': 'โดเมนส่วนตัวที่พยายามมีอยู่ดันไม่เชื่อมกัน',
  'fileViewer.deployLinkProtectedLabel': 'ใส่ตัวยืนยันและปกป้องให้กับการข้ามระบบไว้',
  'fileViewer.deployLinkProtected': 'ถึงจะเอาเว็บเข้าไปไว้ให้แล้วแต่การให้ดูตัวอย่างยังเข้ายาก ปลดรหัสความปลอดภัยเข้าออกที หรือสลับเป็นแบบ Custom',
  'fileViewer.retryLink': 'เข้ากดรีโหลดซ้ำหน่อย',
  'fileViewer.versions.entry': 'Versions',
  'fileViewer.versions.entryFull': 'Version history',
  'fileViewer.versions.title': 'Versions',
  'fileViewer.versions.countOne': '1 version',
  'fileViewer.versions.countMany': '{count} versions',
  'fileViewer.versions.current': 'Current',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Version {version}',
  'fileViewer.versions.listAria': 'File versions',
  'fileViewer.versions.loading': 'Loading versions…',
  'fileViewer.versions.empty': 'No versions yet.',
  'fileViewer.versions.loadFailed': 'Could not load version history.',
  'fileViewer.versions.previewFailed': 'Could not load this version.',
  'fileViewer.versions.noPrompt': 'No prompt recorded',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.diffTitle': 'Compare with current',
  'fileViewer.versions.restore': 'Restore',
  'fileViewer.versions.restoreConfirmTitle': 'Switch to this version?',
  'fileViewer.versions.restoreConfirmCta': 'Restore this version',
  'fileViewer.versions.restoring': 'Restoring…',
  'fileViewer.versions.restoreFailed': 'Restore failed.',
  'fileViewer.versions.restoreSuccess': 'Restored version {version}.',
  'fileViewer.versions.currentHelp': 'This is already the current version.',
  'fileViewer.versions.restoreHelp': 'Restoring writes this HTML as a new current version.',
  'fileViewer.versions.close': 'Close version history',
  'questionForm.submit': 'ส่งผ่าน',
  'questionForm.skip': 'ข้ามตัวนี้',
  'questionForm.locked': 'สำเร็จตอบไปแล้ว',
  'conv.switch': 'กดรับเข้าเลือกหน้าสนทนา',
  'conv.label': 'เรื่องของการสนทนา',
  'conv.heading': 'ข้อการพูดคุยที่เคยมี',
  'conv.new': '+ เพิ่มบทแชทใหม่',
  'conv.empty': 'ไม่มีประวัติเลยแม้แต่น้อย',
  'conv.untitled': 'ที่ค้างเก่าแบบลืมเขียนชื่อกำกับ',
  'conv.renameTooltip': 'คลิกซ้ำซ้อนสองทีถ้าคิดจะเปลี่ยนหน้า',
  'conv.delete': 'ยุติสิ่งของหัวข้อทิ้งเสีย',
  'conv.deleteConfirm': 'ต้องการลบ "{title}" ? เมื่อเอาออกจะทำให้สิ่งของของเนื้อความจบทันที',
  'agentPicker.label': 'ตัวเลือกให้เอเจนต์ทำงาน',
  'agentPicker.modeChoose': 'กรุณาตั้งสถาณะว่าจะให้ใช้การสั่งงานทางรูปแบบไหน',
  'agentPicker.localCli': 'ตั้งแบบ Local CLI ในตัวของ',
  'agentPicker.daemonOff': 'ดับเครื่องมือ Daemon ไป',
  'agentPicker.byok': 'ส่วนของ API · BYOK ตัวรองรับ',
  'agentPicker.selectAgent': 'ระบุว่า CLI code-agent ในอันไหนที่เราพบเห็นให้ใช้ไปได้บ้าง',
  'agentPicker.noAgents': 'ไม่มีในความช่วยเหลือบนส่วนเส้นทาง (PATH)',
  'agentPicker.notInstalled': 'ไม่อยู่บนระบบที่ติดตั้งไว้',
  'agentPicker.rescan': 'ขอสแกนตัวของเส้นทางในเครื่องซ้ำเพื่อตามหาเอเจนต์',
  'tool.openInTab': 'จับเรียก {name} ไว้ให้เข้าหน้าใหม่ของแท็บ',
  'tool.open': 'เข้าไป',
  'tool.todos': 'สิ่งที่วางแผนต้องทำ',
  'tool.askQuestion': 'คำถาม',
  'tool.askQuestionSubmit': 'ส่ง',
  'tool.askQuestionPending': 'รอคำตอบของคุณ',
  'tool.askQuestionAnswered': 'ตอบแล้ว',
  'tool.todosExpand': 'แสดงงาน',
  'tool.todosCollapse': 'ซ่อนงาน',
  'tool.todosDone': 'เสร็จสิ้น',
  'tool.todosDismiss': 'ปิดรายการงาน',
  'tool.write': 'ใส่เขียนลงไป',
  'tool.edit': 'จัดการปรับปรุง',
  'tool.read': 'มองเห็นภาพ',
  'tool.bash': 'สั่ง Bash ทำ',
  'tool.glob': 'หาสิ่ง Glob เอา',
  'tool.grep': 'หาการค้น Grep ลงไป',
  'tool.fetch': 'ดึงรับส่ง Fetch',
  'tool.search': 'สืบเสาะ',
  'tool.lines': '{n} เป็นจำนวนบรรัด',
  'tool.changeSingular': 'ปรับจุดหนึ่งแล้ว',
  'tool.changePlural': 'เปลี่ยนแก้ไขมาเยอะเลย',
  'tool.in': 'ผ่านทางที่อยู่ของ {path}',
  'tool.hide': 'ถูกแอบแฝง',
  'tool.output': 'ข้อสั่งสรุปหน้าจอ',
  'tool.running': 'เริ่มทำงานต่อ…',
  'tool.error': 'สะดุดขัดข้อง',
  'tool.done': 'จบบริบูรณ์',
  'assistant.role': 'หน่วยผู้ช่วยเหลือส่วนตัว',
  'assistant.workingLabel': 'ดำเนินระบบรับทำงานอยู่',
  'assistant.doneLabel': 'บรรลุสู่ระดับพร้อมแล้ว',
  'assistant.copyMarkdown': 'คัดลอก Markdown ของคำตอบ',
  'assistant.forkConversation': 'Fork จากตรงนี้',
  'assistant.forkingConversation': 'กำลัง fork…',
  'assistant.shareToOpenDesign': 'แชร์ไปยัง Gini Studio',
  'assistant.shareToOpenDesignBusy': 'กำลังแชร์…',
  'assistant.feedbackPrompt': 'ข้อเสนอแนะ',
  'assistant.feedbackPositive': 'มีประโยชน์',
  'assistant.feedbackNegative': 'ไม่มีประโยชน์',
  'assistant.feedbackReasonTitle': 'บอกเราว่าทำไม',
  'assistant.feedbackReasonPositiveMatched': 'เข้าใจคำขอของฉัน',
  'assistant.feedbackReasonPositiveVisual': 'ดูดี',
  'assistant.feedbackReasonPositiveUseful': 'โครงสร้างมีประโยชน์',
  'assistant.feedbackReasonPositiveEasy': 'แก้ไขต่อได้ง่าย',
  'assistant.feedbackReasonPositiveDesignSystem': 'ทำตามดีไซน์ซิสเต็ม',
  'assistant.feedbackReasonNegativeMissed': 'พลาดคำขอของฉัน',
  'assistant.feedbackReasonNegativeVisual': 'คุณภาพของภาพต้องปรับปรุง',
  'assistant.feedbackReasonNegativeIncomplete': 'ผลลัพธ์ไม่สมบูรณ์',
  'assistant.feedbackReasonNegativeHard': 'ใช้งานยาก',
  'assistant.feedbackReasonNegativeDesignSystem': 'ไม่ได้ทำตามดีไซน์ซิสเต็ม',
  'assistant.feedbackReasonOther': 'อื่น ๆ',
  'assistant.feedbackReasonPlaceholder': 'เพิ่มหมายเหตุสั้น ๆ...',
  'assistant.feedbackReasonSubmit': 'ส่ง',
  'assistant.emptyResponseLabel': 'ไม่มีผลลัพธ์',
  'assistant.emptyResponseMessage': 'ผู้ให้บริการสิ้นสุดคำขอโดยไม่ส่งคืนข้อความหรืออาร์ติแฟกต์ ลองใช้โมเดลหรือผู้ให้บริการอื่น ตรวจสอบโควต้า หรือลองใหม่อีกครั้ง',
  'assistant.unfinishedLabel': 'พ้นจากโหมดเพราะงานตกค้าง',
  'assistant.unfinishedSummary': 'งาน {n} ขั้นลืมอยู่ข้างหลัง',
  'assistant.unfinishedMore': 'ทิ้งเพิ่มมาอีก +{n}',
  'assistant.continueRemaining': 'สานต่อภาระหน้าที่หลงเหลือที',
  'assistant.outTokens': 'หมดการจ่ายใน {n} โทเคน',
  'assistant.producedFiles': 'ดึงงานมาจากระบบไฟล์',
  'assistant.openFile': 'เรียก',
  'assistant.downloadFile': 'สูบลงตัวเครื่อง',
  'nextStep.title': 'ขั้นตอนถัดไป',
  'nextStep.share': 'แชร์',
  'nextStep.chipJoiner': ', ',
  'nextStep.chipPolishVisual': 'ทำให้ดูพรีเมียมขึ้น',
  'nextStep.chipBrand': 'เสริมสไตล์แบรนด์',
  'nextStep.chipConcise': 'ปรับข้อความให้กระชับ',
  'nextStep.chipSecondVersion': 'สร้างแบบที่สอง',
  'assistant.thinking': 'ไตร่ตรอง…',
  'assistant.thought': 'คิดแล้ว',
  'assistant.thoughtFor': 'คิด {s} วินาที',
  'assistant.systemReminder': 'จดบอกเล่าจากสิ่งที่สำคัญในระบบ',
  'assistant.possiblePromptInjection': 'อาจมีการฉีดพรอมต์',
  'assistant.waitingFirstOutput': 'รอบอกการประมวลครั้งเปิดฉาก',
  'assistant.statusBootingAgent': 'เริ่มปลุกเอเจนต์ก่อน',
  'assistant.statusPreparing': 'กำลังเตรียม...',
  'assistant.statusStarting': 'ขึ้นเดินหน้าสู่ระบบแล้ว',
  'assistant.statusRequesting': 'ผลักภาระด้วยคำสั่งเข้ามารับใช้',
  'assistant.statusThinking': 'ครุ่นคิดคำตอบเตรียมไว้ให้ดี',
  'assistant.statusStreaming': 'ส่งถ่ายผลลัพธ์มาตลอดต่อเนื่อง',
  'assistant.slowHint': 'ใช้ขอบเขตเวลามากผิดคาด ฟอร์มตอบควรมาราว 5-10 วินาที — หยุดไว้และขอเขียนเข้าไปให้เป็นที่เข้าใจอีกทีดีไหม',
  'assistant.verbEditing': 'แก้ไขโครงใหม่',
  'assistant.verbWriting': 'นั่งเขียนเพิ่มเติม',
  'assistant.verbReading': 'รับชมพิจารณาข้อมูล',
  'assistant.verbSearching': 'ไล่สายตาหา',
  'assistant.verbRunning': 'เดินระบบคำสั่งไป',
  'assistant.verbTodos': 'สร้างกำหนดของเป้าหมายหน้า',
  'assistant.verbFetching': 'ชักนำผลผ่านตัวออนไลน์',
  'assistant.verbCalling': 'ตามสั่งเครื่องมือมาใช้',
  'qf.answered': 'ได้ส่งคำไปแล้ว',
  'qf.choose': 'จิ้มเลือกเถอะ…',
  'qf.required': 'เป็นของต้องจัดให้เสมอ',
  'qf.lockedSubmitted': 'ข้อมูลรับไปสู่มือเอเจนต์แบบไม่มีตกค้าง เพื่อต่อความรันได้จนเสร็จสิ้น',
  'qf.lockedPrev': 'หน้าจอกรอบนี้มาจากแบบข้อมูลผ่านแล้ว',
  'qf.hint': 'ระบุเลือกตามที่มองเห็นว่าชอบใจอันไหน หากไม่ได้รู้สึกว่าอยากใช้อะไรก็ข้ามไป เอเจนต์คอยวางเกณฑ์ค่าพื้นฐานไว้ด้วยตัวเขาเอง',
  'qf.submitDefault': 'เอาผลทั้งหมดนี้เข้าไป',
  'qf.submitDisabledTitle': 'นำคำลงในกล่องที่จำเป็นให้ครบกันก่อน',
  'qf.submitTitle': 'เอาผลทั้งหมดนี้เข้าไป',
  'qf.cardSelected': 'เลือกใช้งาน',
  'qf.cardRefs': 'เชื่อมโยงจากตัวของ:',
  'qf.cardSampleText': 'สุนัขจิ้งจอกสีน้ำตาลตัวรวดเร็ว · 0123',
  'questions.tabLabel': 'คำถาม',
  'questions.banner': 'ขออนุญาตถามคำถามสั้น ๆ สองสามข้อได้ไหม',
  'questions.continue': 'ดำเนินการต่อ',
  'questions.generating': 'กำลังสร้างคำถาม…',
  'questions.skipAll': 'ข้ามทั้งหมด',
  'questions.autoSkipHint': 'ดำเนินการต่อโดยอัตโนมัติเมื่อหมดเวลา',
  'sketch.toolSelect': 'จิ้มเลือกตัวสิ่งของ',
  'sketch.toolPen': 'ปากกาวาดลาย',
  'sketch.toolText': 'ข้อความอักษร',
  'sketch.toolRect': 'ทำกรอบสี่เหลี่ยม',
  'sketch.toolArrow': 'ทำลูกศรชี้',
  'sketch.toolEraser': 'ยางลบเก็บลาย',
  'sketch.color': 'หยิบสีระบาย',
  'sketch.strokeSize': 'เพิ่มระดับความหนาเส้นวาด',
  'sketch.undo': 'ดึงกลับขั้นที่เพิ่งวาดไป',
  'sketch.clear': 'ลบทำความสะอาดเต็มแผ่น',
  'sketch.close': 'ทิ้งและปิดหน้าต่าง',
  'sketch.closeConfirm': 'ต้องการละทิ้งของที่ปรับยังไม่จบในร่างภาพวาดและออกไปเลยหรือ?',
  'sketch.textPrompt': 'ใส่ข้อความของคุณลง:',
  'sketch.textModalTitle': 'เติมข้อความลงที่ตัวหนังสือ',
  'critiqueTheater.userFacingName': 'คณะกรรมการตัดสินดีไซน์',
  'critiqueTheater.roleDesigner': 'นักออกแบบ',
  'critiqueTheater.roleCritic': 'นักวิจารณ์',
  'critiqueTheater.roleBrand': 'แบรนด์',
  'critiqueTheater.roleA11y': 'การเข้าถึง',
  'critiqueTheater.roleCopy': 'คัดลอก',
  'critiqueTheater.roundLabel': 'รอบที่ {n} จาก {m}',
  'critiqueTheater.mustFix': 'ต้องแก้ไข {n} รายการ',
  'critiqueTheater.composite': 'คะแนนรวม',
  'critiqueTheater.threshold': 'เกณฑ์ขั้นต่ำ',
  'critiqueTheater.consensus': 'ฉันทามติ',
  'critiqueTheater.interrupt': 'ขัดจังหวะ',
  'critiqueTheater.interrupting': 'กำลังหยุดชั่วคราว…',
  'critiqueTheater.interrupted': 'ถูกขัดจังหวะ',
  'critiqueTheater.degradedHeading': 'คณะกรรมการออฟไลน์ในการรันนี้',
  'critiqueTheater.degradedReasonMalformed': 'ผลลัพธ์ของคณะกรรมการมีรูปแบบไม่ถูกต้อง (ตัวแยกวิเคราะห์ปฏิเสธบล็อก)',
  'critiqueTheater.degradedReasonOversize': 'ผลลัพธ์ของคณะกรรมการเกินขีดจำกัดไบต์ที่ปลอดภัย',
  'critiqueTheater.degradedReasonAdapter': 'อะแดปเตอร์ {adapter} ไม่รองรับโปรโตคอล Critique',
  'critiqueTheater.degradedReasonProtocol': 'อะแดปเตอร์ {adapter} ส่งเวอร์ชันโปรโตคอลที่ไม่รองรับ',
  'critiqueTheater.degradedReasonMissingArtifact': 'การรันเสร็จสิ้นโดยไม่มีอาร์ติแฟกต์สุดท้าย',
  'critiqueTheater.replay': 'เล่นซ้ำ',
  'critiqueTheater.replaySpeed': 'ความเร็วในการเล่นซ้ำ',
  'critiqueTheater.readOnly': 'อ่านอย่างเดียว',
  'critiqueTheater.shippedSummary': 'ส่งออกในรอบ {round} · คะแนนรวม {composite}',
  'critiqueTheater.interruptedSummary': 'ถูกขัดจังหวะในรอบ {round} · คะแนนรวมที่ดีที่สุด {composite}',
  'critiqueTheater.shippedBadge': 'ส่งมอบแล้ว',
  'critiqueTheater.belowThresholdBadge': 'ต่ำกว่าเกณฑ์',
  'critiqueTheater.timedOutBadge': 'หมดเวลา',
  'critiqueTheater.failedHeading': 'การรันล้มเหลว',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI ออกจากการทำงานด้วยรหัสที่ไม่ใช่ศูนย์ก่อนที่ panel จะทำงานเสร็จ',
  'critiqueTheater.failedReasonPerRoundTimeout': 'รอบหนึ่งใช้เวลาเกินงบประมาณเวลาที่กำหนด',
  'critiqueTheater.failedReasonTotalTimeout': 'การรันทั้งหมดใช้เวลาเกินงบประมาณเวลารวมที่กำหนด',
  'critiqueTheater.failedReasonOrchestrator': 'เกิดข้อผิดพลาดภายในของตัวจัดการการทำงาน',
  'critiqueTheater.transcriptEmpty': 'ยังไม่มี transcript ให้เล่นซ้ำ รันการวิจารณ์เพื่อบันทึกหนึ่งรายการ',
  'critiqueTheater.transcriptLoading': 'กำลังโหลดบทถอดความ…',
  'critiqueTheater.transcriptError': 'ไม่สามารถโหลด transcript ได้: {error}',
  'critiqueTheater.replaySpeedPaused': 'หยุดชั่วคราว',
  'critiqueTheater.replaySpeedInstant': 'ทันที',
  'critiqueTheater.replaySpeedLive': 'สด',
  'critiqueTheater.replaySpeedFast': 'เร็ว',
  'critiqueTheater.settingsNav': 'คณะกรรมการตัดสินดีไซน์',
  'critiqueTheater.settingsNavHint': 'การรีวิวงานออกแบบห้า panel สำหรับการรันของคุณ',
  'critiqueTheater.settingsEnabledLabel': 'แสดง Design Jury ระหว่างการรันของ Agent',
  'critiqueTheater.settingsEnabledDescription': 'เมื่อเปิดใช้งาน การรีวิวห้า panel จะปรากฏควบคู่ไปกับการสร้างของ Agent และให้คะแนนผลลัพธ์ก่อนส่งออก คุณสามารถขัดจังหวะได้ทุกเมื่อ',
  'critiqueTheater.settingsEnabledProjectHint': 'บันทึกไว้สำหรับโปรเจกต์นี้แล้ว การรันใหม่ในโปรเจกต์นี้จะถูกส่งผ่าน Design Jury ที่ฝั่งเซิร์ฟเวอร์',
  'critiqueTheater.settingsEnabledNoProjectHint': 'เปิดโปรเจกต์เพื่อบันทึกสิ่งนี้ที่ฝั่งเซิร์ฟเวอร์ จนกว่าจะถึงตอนนั้น การตั้งค่านี้จะเปลี่ยนเฉพาะค่ากำหนดในเบราว์เซอร์เท่านั้น',
  'pet.title': 'เพื่อนสัตว์เลี้ยง',
  'pet.subtitle': 'มารับน้องเอาไว้ดูแลในบนหน้าจอโปรเจกต์',
  'pet.navTitle': 'เพื่อนสัตว์เลี้ยง',
  'pet.navHint': 'ให้รับน้องเข้ามาอยู่กับตัวเอง',
  'pet.tabBuiltIn': 'มาพร้อมเปิดระบบ',
  'pet.tabBuiltInHint': 'จัดกลุ่มให้พร้อมใช้กับชุดระบบจาก Gini Studio แล้ว — เอาได้เลย',
  'pet.builtInEmpty': 'ของที่จัดกลุ่มจากข้างในมาไม่เห็นเลย ถ้าระบบออนไลน์อยู่ก็ขอตัวรีไปหามันต่อให้ที',
  'pet.tabCustom': 'สร้างของสไตล์แต่งเติมเอาเอง',
  'pet.tabCustomHint': 'มีตัวสัตว์ของเอง สร้างชื่อ กำหนดรูป เอามาวางปรับได้เสร็จสรรพ',
  'pet.tabCommunity': 'จากเพื่อนชุมชน',
  'pet.tabCommunityHint': 'เป็นพวกตัวสัตว์จากการผลิตใน Codex — ดูๆ และรับเลี้ยงต่อ หรือสั่งเจาะจงให้ทำแบบของที่ตัวเลือกเอาได้',
  'pet.tabsAria': 'ช่องทางของน้องเอาที่ไหนมาดี',
  'pet.adopt': 'เอาไปดูแลรับเลี้ยง',
  'pet.adoptedBadge': 'อยู่ในช่วงรับเลี้ยงไปแล้ว',
  'pet.adoptCallout': 'เอาไปดูแลรับเลี้ยงเถอะนะ',
  'pet.changePet': 'เปลื่ยนเพื่อนคู่หูตัวอื่นเอามาดีกว่า',
  'pet.wake': 'ลืมตื่นเถิด',
  'pet.tuck': 'กลับไปซุกรังเถอะ',
  'pet.wakeTitle': 'ไปเรียกตื่นออกมา — แสดงโชว์ให้พร้อม',
  'pet.tuckTitle': 'ม้วนกลับที่นอน — เอาออกจากการแสดงโชว์ไปก่อน',
  'pet.settingsTitle': 'เข้ามาที่แถบการตั้งปรับสัตว์เลี้ยง',
  'pet.useCustom': 'นำเพื่อนของฉันมาเป็นโชว์คู่หู',
  'pet.customTitle': 'ทำสัตว์ตัวโปรดของคุณเลย',
  'pet.customHint': 'จัดระเบียบใส่ชื่อ อีโมจิ หรือสิ่งที่มีเพื่อนำมาเป็นโชว์สัตว์แบบสมบูรณ์พร้อม',
  'pet.customGreetingPlaceholder': 'ทักทายส่งเสียงบอกสักคำสิ…',
  'pet.fieldName': 'เรียกน้องสัตว์ว่า',
  'pet.fieldGlyph': 'ใช้อีโมจินี้แหล่ะ',
  'pet.fieldGlyphHint': 'เหมาะสุดก็คือแบบอีโมจิเดี่ยวมาตัวนึง (เช่น 🐝, 🦄, 🐢)',
  'pet.fieldGreeting': 'เสียงคำทักทายที่กล่าวไว้',
  'pet.fieldAccent': 'ใช้สีโทนสดใสของเน้นตัว',
  'pet.fieldAccentCustom': 'ปรับแต่งของสีด้วยตัวเอง',
  'pet.fieldAccentDefault': 'สีเน้นเริ่มต้น',
  'pet.overlayAria': 'เป็นโชว์แผงของสัตว์',
  'pet.spriteAria': 'นี่ของ {name} — ตัวกดจับลากและแชทเข้าพูด',
  'pet.spriteTitle': 'แวะมาหวัดดีจาก {name}! จิ้มมาสนทนากัน',
  'pet.taskSummarySingle': 'งาน Agent {count} งานกำลังทำงานอยู่',
  'pet.taskSummaryMultiple': 'งาน Agent {count} งานกำลังทำงานอยู่ใน {projects} โปรเจกต์',
  'pet.taskSummaryRecentSingle': 'งาน Agent {count} งานเพิ่งเสร็จสิ้น',
  'pet.taskSummaryRecentMultiple': 'งาน Agent {count} งานเพิ่งเสร็จสิ้น',
  'pet.taskListAria': 'งาน Agent ที่กำลังทำงาน',
  'pet.taskOpenProject': 'เปิด {project}',
  'pet.taskGroup.running': 'กำลังทำงาน',
  'pet.taskGroup.queued': 'กำลังรอ',
  'pet.taskGroup.recent': 'เพิ่งเสร็จสิ้น',
  'pet.idleQuote.leonardo.text': 'การเรียนรู้ไม่เคยทำให้จิตใจเหนื่อยล้า',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'ฉันเห็นเทวดาในก้อนหินอ่อนและแกะสลักจนกระทั่งปลดปล่อยเขาให้เป็นอิสระ',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'มีสองสิ่งที่ช่วยประติมากรได้: แสงและเงา',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'เมื่อกำลังวาดภาพ คนเราไม่ได้คิด',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'ผลงานทั้งหมด ไม่ว่าจะเป็นอะไรหรือใครวาด ล้วนเป็นเพียงสิ่งไร้ค่าและเรื่องเล็กน้อยแบบเด็กๆ เว้นแต่จะถูกสร้างและวาดขึ้นจากชีวิตจริง',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'สิ่งสำคัญที่สุดคือการได้รู้สึกซาบซึ้ง ได้รัก ได้หวัง ได้สั่นไหว ได้มีชีวิต',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'เพื่อนสัตว์เลี้ยง — เรียกตื่น ม้วนไปนอน หรือเอาอันไหนสักที',
  'pet.composerMenuTitle': 'เพื่อนสัตว์เลี้ยง',
  'pet.composerMenuHint': 'ตัวเลือกพิเศษ: ลองพิมพ์ /pet เพื่อเปลี่ยนการใช้งานโหมด',
  'pet.composerOpenSettings': 'จัดการสัตว์เลี้ยง',
  'pet.welcomeTeaserTitle': 'เปิดรับเพื่อนมา',
  'pet.welcomeTeaserBody': 'ตัวกระจุ๋มกระจิ๋มอยู่ลอยไปมาบนพื้นที่ที่โชว์แวะทัก',
  'pet.welcomeTeaserCta': 'เลือกมาตัวนึงสิ',
  'pet.imageUpload': 'ส่งแถบภาพเคลื่อนไหวสไปรต์',
  'pet.imageReplace': 'โละเปลี่ยนใส่ของภาพสไปรต์ให้มาใหม่',
  'pet.imageRemove': 'หยุดกลับสู่อีโมจิตามปกติก่อน',
  'pet.imageHintIdle': 'รองรับทั้งไฟล์แบบ PNG, JPG, WebP, GIF รวมไปถึง SVG ของที่อัพเข้ามา ถ้าใช้แผ่นเคลื่อนไหวหลายช่อง ก็ต้องเซตส่วนตัวที่กรอบมาให้ด้วย',
  'pet.imageHintActive': 'รูปสัตว์โชว์การแสดงผลพร้อมใช้ ถ้าใส่เฟรมไว้ > 1 มันจะไปรันให้ดูผ่านของแผ่นแสดงตามที่ว่ามา',
  'pet.fieldFrames': 'จำนวนเฟรมที่แบ่ง',
  'pet.fieldFramesHint': 'มีแค่ 1 = ปักนิ่งเอาไว้ให้ มีของ > 1 = ลากมาเคลื่อนไปเรื่อยตามการใส่',
  'pet.fieldFps': 'วิ่งจังหวะฉับไว (fps)',
  'pet.fieldFpsHint': 'ให้กำหนดตามใจว่าหมุนมาเปลี่ยนช่องเร็วแค่ไหน',
  'pet.atlasImport': 'เอาของสไปรต์ Codex ใช้นำเข้า',
  'pet.atlasImportTitle': 'มาให้ดึงแบบสไปรต์สัตว์แบบฟัก (hatch-pet) แผนที่เข้าฉบับ 8x9 / 192x208 (แบบรับได้ของ PNG และ WebP)',
  'pet.atlasPickerTitle': 'ไปลองกดตรงแถบของโชว์ความเคลื่อนไหวมาสักชุด',
  'pet.atlasPickerHint': 'ของ Codex ที่รวมแผงสัตว์ไว้มีราว 9 แถวของการเคลือนมาด้วย ของที่พร้อมมาแล้วตามพื้นฐานมักจะทำแผ่นแบบครบเซต พอมีเวลาที่น้องขยับตามทิศทางเมาส์หรือเอามาพักเฉยๆ ก็พร้อมที่จะใช้ตลอด สามารถแช่ภาพหรือเอาตามการเล่นก็ตั้งตามใจในนั้นได้',
  'pet.atlasCancel': 'ทิ้งและปล่อยตัวเลือกนี้ไปเถิด',
  'pet.atlasAdopt': 'ล็อคแช่ตามแถวที่เลือกมา',
  'pet.atlasAdoptFull': 'ลากเข้าเอาในของแผนเต็มแบบจัดฉากเอง (เน้นทำทิศทางขยับเป็นหลายท่วงท่า)',
  'pet.atlasAdoptFullTitle': 'ครอบคลุมมาเก็บทั้งแถวให้โชว์ทุกอย่างเวลามีทิศทาง หรือโดนเมาส์รบกวน',
  'pet.atlasAdoptRowTitle': 'ตัดมาแบ่งใช้เน้นส่วนเด่นๆ ให้ทำวิ่งซ้ำๆ ของเฉพาะเจาะจงกันเลย',
  'pet.atlasActiveHint': 'อยู่ในของที่ตัวแอนิเมชันเปิดตามฉบับเต็มใช้งานตลอด — น้องพร้อมแล้วที่มีจะเปลี่ยนการแสดงอารมณ์ไป (ทั้งขยับไปมา ลาก หรืออยู่หยุดพักนิ่ง)',
  'pet.atlasRow.idle': 'ยืนนิ่งรับสถานะ',
  'pet.atlasRow.running-right': 'พุ่งตัวทางด้านขวา',
  'pet.atlasRow.running-left': 'พุ่งตัวไปในทิศทางซ้าย',
  'pet.atlasRow.waving': 'ทักทายโบกสะบัด',
  'pet.atlasRow.jumping': 'กระโดดลอยตัว',
  'pet.atlasRow.failed': 'รับทราบถึงข้อขัดข้องล้มเหลว',
  'pet.atlasRow.waiting': 'ทอดทิ้งไว้รอบางสิ่ง',
  'pet.atlasRow.running': 'พุ่งทะยานวิ่ง',
  'pet.atlasRow.review': 'ทำการไล่ทบทวนตรวจดูผลลัพธ์กัน',
  'pet.hatchTitle': 'เสกหาตัวน้องสัตว์ AI ด้วยตัวเองจากฟักไข่ใหม่เลย',
  'pet.hatchHint': 'เอาของเครื่องมือที่ฝังใช้จากข้างใน (hatch-pet skill) กดรับนำมาปั้นผลสไปรต์หน้าของ Codex ในหน้าจอและนำเข้ามายังตระกูลที่นี่ซะ',
  'pet.hatchConcept': 'ของไอเดียสัตว์ตัวหลัก (เสริมใส่หรือไม่ใส่ก็ว่าตามต้องการ)',
  'pet.hatchConceptPlaceholder': 'อาทิ หมาปั๊กแบบภาพ 8-บิท สวมชุดหมวกนิตติ้งมา',
  'pet.hatchCopy': 'จิ้มเพื่อก็อปปี้สคริปต์นี้ออกไว้ได้',
  'pet.hatchCopied': 'จัดการคัดลอกมาอยู่บนคลิปบอร์ดเสร็จแล้ว!',
  'pet.hatchFoot': 'หลังจากเครื่องมือเซฟสัตว์เลี้ยงไว้ ให้กลับมาที่นี่เพื่อทำการเลือก "นำเข้าภาพ Codex sprite" และระบุเลย',
  'pet.slashPopoverAria': 'แถบเข้าชุดเครื่องมือ Slash พิเศษ',
  'pet.slashPopoverTitle': 'สั่งทำงานตามคำพูดตรง',
  'pet.slashPopoverHint': 'ไล่ชี้จากทิศทาง ↑↓ นำเอา enter เข้าจับสั่ง · esc ไม่เอาหน้าต่างแล้วออกไป',
  'pet.slashPet': 'โหมดตั้งกลับแบบ เปิดเอา/ปิดรับ พร้อมการเข้าจัดระบบตัวของสัตว์เลยทันใจ',
  'pet.slashPetWake': 'เรียกตัวที่เตรียมลอยมาโชว์รับในจอ',
  'pet.slashPetTuck': 'เอากลับพับโชว์เข้าที่ไปตอนนี้นี่แหล่ะ',
  'pet.slashHatch': 'ก่อแบบเสกตัวของจากแบบฉบับ Codex ทำเข้าจากตรงระบบความสามารถ hatch-pet เสียด้วย',
  'pet.slashHatchArg': '<รายละเอียดการออกแบบคอนเซปต์>',
  'pet.slashSearch': 'รับให้สั่งดึงของคำสั่งที่ใช้เพื่อตรวจเว็บแบบ OD วิ่งค้นหากันได้',
  'pet.slashSearchArg': '<รายละเอียดการนำทางสืบค้น>',
  'pet.codexTitle': 'แบบสดๆ ฟักจากข้างในเลย',
  'pet.codexSubtitle': 'สิ่งที่เป็นพวกนี้คือตัวน้องๆ ที่ได้จากทักษะ hatch-pet โดยกดปุ๊บก็ไปพร้อมกับการให้ตัวเข้ามาทันที',
  'pet.codexSubtitleWithDir': 'ในเวลาที่เข้าดึงสแกนตามตัวจากระบบไดเรกทอรี {dir} ที่จะได้ให้ตัวเลือกการเข้าจัดการของ hatch-pet',
  'pet.codexEmpty': 'ไร้แววเลยตอนนี้ ไม่พบแบบของอะไรใหม่เลยที่ฟักออกมาได้ ไปตามปุ่มการใช้พิมพ์แบบ /hatch ดูเอาไว้สร้างขึ้นนะ',
  'pet.codexLoading': 'อยู่ระหว่างพิจารณาจับแบบการฟักสัตว์มาให้เห็นกัน…',
  'pet.codexRefresh': 'ดึงโหลดเข้ามาอีก',
  'pet.codexAdopt': 'กดยอมรับดูแลไปเลย',
  'pet.codexAdopting': 'สู่โหมดกำลังเข้าเอาตัวดูแลไปแล้วนะ…',
  'pet.communitySync': 'มาจับซิงค์หาเหล่าแบบจากส่วนชุมชนลงเครื่องมาสิ',
  'pet.communitySyncing': 'จัดการไล่จับข้อมูลดาวน์โหลดมาให้คอยอยู่…',
  'pet.communitySyncTitle': 'จับข้อมูลเพื่อซิงค์รุ่นเข้าแบบ Codex Pet Share ทั้งของแบบ j20 นำดึงสู่ในของ ~/.codex/pets/ ให้',
  'pet.communitySyncDone': 'ดำเนินการซิงค์ลุล่วงด้วยไปได้ {wrote} ของรุ่นสัตว์ใหม่ ({total} ค่ามีทั้งหมดในผลนะ)',
  'pet.communitySyncFailed': 'ซิงค์เข้าล้มซะแล้ว มีเออเร่อแบบนี้ขึ้นเลย: {error}',
  'pet.codexBundled': 'รวมมามัดชุดใหญ่',
  'pet.codexBundledTitle': 'เตรียมมาให้กับ Gini Studio แล้ว — ไม่ต้องดาวน์โหลดใหม่',
  'settings.notifications': 'การรับส่งข้อมูลการแจ้งเตือน',
  'settings.notificationsHint': 'มีระบบใช้บอกทั้งส่งเตือนเดสก์ท็อป และเปิดเสียงที่รันรับใช้เข้าแบบทำงานลุล่วง',
  'settings.notifyCompletionSound': 'ส่งเสียงแสดงให้รับรู้',
  'settings.notifyCompletionSoundHint': 'ทำงานดังขึ้นเมื่อถึงจังหวะผลลุล่วง เป็นค่าตั้งที่ปิดก่อนด้วยค่าระดับพื้นฐานเอาไว้เลย',
  'settings.notifySuccessSound': 'โทนเสียงแจ้งงานผ่านตลอดรอดตาย',
  'settings.notifyFailureSound': 'โทนเสียงแบบเกิดล้มเหลว',
  'settings.notifyDesktop': 'ป้ายกล่องเตือนหน้าจอเดสก์ท็อป',
  'settings.notifyDesktopHint': 'ส่งไปเตือนให้เวลาหน้าจอหรือตัวหน้าต่างโดนไปไม่ได้ตั้งโฟกัสมองดูเอาไว้',
  'settings.notifyDesktopBlocked': 'ยังติดปิดกั้นแบบของในเบราว์เซอร์ไปแล้ว ให้เปิดไปตั้งค่าความอนุญาตรับในส่วนที่ทำในแผงจัดการตัวเว็บให้หน่อย',
  'settings.notifyDesktopUnsupported': 'หมดโอกาสรองรับกันไปในการทำแบบแผงการแจ้งนี้บนอุปกรณ์ที่เป็นอยู่นี่ซะ',
  'settings.notifyTest': 'กดลองฟังตัวเทสดู',
  'settings.notifyTestSent': 'ถูกลากผ่านส่งคำโชว์ข้อตัวทดสอบนี้ไป ถ้าระดับป้ายตัวเตือนไม่มีขึ้นเลย ควรตามเข้าไปจัดใหม่ดูในการของแจ้งทั้งระบบบนและเบราว์เซอร์ล่ะกัน',
  'settings.notifyTestFailed': 'เรียกการส่งเตือนเกิดความล้มเหลว ลองตรวจระดับตัวเซตติ้งในส่วนระบบของเตือนแบบระบบเบราว์เซอร์หน่อยแล้วกัน',
  'settings.notifySoundDing': 'ดังติ๊งสิ',
  'settings.notifySoundChime': 'ลั่นเหมือนดังกระดิ่ง',
  'settings.notifySoundTwoToneUp': 'โทนดังปรับขึ้นไป 2 จังหวะ',
  'settings.notifySoundPluck': 'เสียงดั่งโดนสายกระตุกไปมา',
  'settings.notifySoundBuzz': 'เป็นจังหวะกระตุ้นอารมณ์สั่นเลย',
  'settings.notifySoundTwoToneDown': 'โทนดังลดถอย 2 จังหวะ',
  'settings.notifySoundThud': 'เสียงหนักเน้นโครมให้ระวัง',
  'settings.skills': 'ทักษะ',
  'settings.skillsHint': 'ทักษะเชิงฟังก์ชันที่ Agent สามารถเรียกใช้ระหว่างทำงานได้',
  'settings.skillsNew': 'Skill ใหม่',
  'settings.skillsEmpty': 'เลือก skill ทางด้านซ้าย หรือสร้างใหม่',
  'settings.skillsEdit': 'แก้ไข',
  'settings.skillsDelete': 'ลบ',
  'settings.skillsDeleteConfirm': 'ยืนยันการลบ',
  'settings.skillsName': 'ชื่อ',
  'settings.skillsTriggers': 'ทริกเกอร์ (คั่นด้วยจุลภาคหรือขึ้นบรรทัดใหม่)',
  'settings.skillsDescription': 'คำอธิบาย',
  'settings.skillsBody': 'เนื้อหา SKILL.md',
  'settings.skillsCreate': 'สร้าง',
  'settings.skillsSave': 'บันทึก',
  'settings.skillsSaving': 'กำลังบันทึก…',
  'settings.skillsFiles': 'ไฟล์',
  'settings.skillsNoFiles': 'ไม่มีไฟล์ในโฟลเดอร์ทักษะนี้',
  'settings.skillsNameRequired': 'ต้องระบุชื่อทักษะ',
  'settings.skillsBodyRequired': 'ต้องระบุเนื้อหาทักษะ',
  'settings.designSystems': 'ระบบดีไซน์',
  'settings.designSystemsHint': 'จัดการว่า design system ใดบ้างที่จะปรากฏในแกลเลอรีหน้าแรก',
  'settings.designSystemsInstalled': 'ติดตั้งแล้ว',
  'settings.designSystemsAdd': 'เพิ่มระบบออกแบบ',
  'settings.designSystemsHiddenCount': 'ซ่อน {count} รายการจากแกลเลอรีหน้าแรก',
  'settings.designSystemsShowAll': 'แสดงทั้งหมด',
  'settings.designSystemsShowHidden': 'แสดงรายการที่ซ่อน',
  'settings.designSystemsSource': 'แหล่งที่มา',
  'settings.designSystemsSourceLocal': 'ในเครื่อง',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'การอ้างอิงรีจิสทรี shadcn',
  'settings.designSystemsImportShadcn': 'นำเข้าจาก shadcn',
  'settings.designSystemsStructure': 'โครงสร้าง',
  'settings.designSystemsModeHybrid': 'ไฮบริด',
  'settings.designSystemsModeNormalized': 'ปรับมาตรฐาน',
  'settings.designSystemsModeVerbatim': 'คงเดิม',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'สี',
  'settings.designSystemsCraftAccessibility': 'การเข้าถึง',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'พาธโปรเจกต์',
  'settings.designSystemsImportGithub': 'นำเข้าจาก GitHub',
  'settings.designSystemsImportProject': 'นำเข้าจากโปรเจกต์',
  'settings.designSystemsImportedStatus': 'นำเข้า {title} แล้ว',
  'settings.designSystemsViewImported': 'ดูระบบออกแบบที่นำเข้า',
  'settings.designSystemsCategory': 'หมวดหมู่',
  'settings.designSystemsAllCategories': 'ทุกหมวดหมู่',
  'settings.designSystemsShowInHomeGallery': 'แสดงในแกลเลอรีหน้าแรก',
  'settings.projectLocations': 'ตำแหน่งโปรเจกต์',
  'settings.projectLocationsHint': 'รากที่เก็บเวิร์กสเปซ',
  'settings.projectLocationsDescription': 'เพิ่มฐานงานที่สามารถเก็บโฟลเดอร์โปรเจกต์ Gini Studio ได้หลายรายการ โปรเจกต์ใหม่จะถูกบันทึกเป็นหนึ่งโฟลเดอร์ภายในฐานที่เลือก',
  'settings.projectLocationsSaveError': 'ไม่สามารถบันทึกตำแหน่งโปรเจกต์ได้ ตรวจสอบว่าแต่ละพาธเป็นโฟลเดอร์ที่เข้าถึงได้',
  'settings.projectLocationsSaved': 'บันทึกตำแหน่งโปรเจกต์แล้ว',
  'settings.projectLocationsScanError': 'ไม่สามารถสแกนตำแหน่งโปรเจกต์ได้',
  'settings.projectLocationsScanComplete': 'สแกนเสร็จแล้ว: นำเข้า {imported} รายการ, ลงทะเบียนไว้แล้ว {existing} รายการ',
  'settings.projectLocationsNoFolderSelected': 'ไม่ได้เลือกโฟลเดอร์',
  'settings.projectLocationsDuplicate': 'เพิ่มฐานงานนี้ไว้แล้ว',
  'settings.projectLocationsWorkBaseMeta': 'ฐานงาน · โปรเจกต์จะถูกสร้างเป็นโฟลเดอร์ย่อยที่นี่',
  'settings.projectLocationsAddFolder': 'เพิ่มโฟลเดอร์…',
  'settings.projectLocationsDefaultBadge': 'ตำแหน่งเริ่มต้น',
  'settings.projectLocationsMakeDefault': 'ตั้งเป็นค่าเริ่มต้น',
  'settings.projectLocationsDefaultSaved': 'อัปเดตตำแหน่งโปรเจกต์เริ่มต้นแล้ว',
  'settings.librarySkills': 'พวก Skills',
  'settings.libraryDesignSystems': 'ตัวของระบบแบบ Design Systems',
  'settings.librarySearch': 'ต้องการหาสิ่งใด…',
  'settings.libraryAll': 'ทุกชิ้นส่วนเอามา',
  'settings.libraryPreview': 'ชมภาพเตรียม',
  'settings.libraryPreviewClose': 'นำเก็บซ่อน',
  'settings.libraryLoading': 'ในระบบเรียกมารอ…',
  'settings.libraryNoResults': 'ตัวหานี้มีอันที่ไม่มีตรงใดๆ กับที่ค้นเข้ามาเลยล่ะ',
  'settings.libraryEnabled': 'เปิดเข้าตัวโหมด',
  'settings.libraryDisabled': 'งับการแสดงอยู่',
  'settings.connectorsNavHint': 'แหล่งของระบบที่ไว้เข้าถึงจากที่ตั้งในของตัวพ่วงแผงอื่น',
  'settings.connectorsHint': 'ให้คอยเข้ามาปรับเซตและมองเข้าจัดการส่วนตัวบริการระบบที่เชื่อมผูกมากับดีไวซ์ในอันนี้ด้วย',
  'settings.connectorsComposioApiKey': 'ใส่ส่วนตัวของคีย์แบบ Composio API',
  'settings.connectorsSavedTitle': 'ดึงสู่ความพร้อมเก็บในที่ Local Daemon เลย',
  'settings.connectorsSavedWithTail': 'พร้อมใช้แล้ว · ••••{tail}',
  'settings.connectorsSaved': 'บันทึกพร้อม',
  'settings.connectorsGetApiKey': 'หาเส้นทางคีย์เข้า API Key',
  'settings.connectorsReplaceKeyPlaceholder': 'หามาใส่ของตัวคีย์ที่ตั้งในของแทนส่วนเก็บไปก่อนแล้วได้ตรงนี้',
  'settings.connectorsApiKeyPlaceholder': 'อัดเข้ากับตัว Composio API key ในนี่แหล่ะ',
  'settings.connectorsClear': 'ให้เอาออกโล่งเลย',
  'settings.connectorsClearConfirmTitle': 'สั่งแบบกำจัดพร้อมเอาคีย์เก่าบน Composio API ที่ตั้งไว้นี้หรือไม่',
  'settings.connectorsClearConfirmBody': 'ของชุดนี้ส่งออกคีย์ไปหมายความตัวของแอปใดใดทางตัวเชื่อมทุกชนิดที่จะติดผูกมาตรง Composio ทิ้งให้หมดทุกแบบ ซึ่งพวกรวมแบบอย่างการมีบัญชีของระบบ อนุญาตตั้งตามทาง OAuth รวมเลยกับของความเข้ามือเอาทิ้งตามออกหมดเรียบเลย',
  'settings.connectorsClearConfirmContinue': 'ขอเดินข้ามเอาต่อ',
  'settings.connectorsClearFinalTitle': 'เรื่องนี้จะไปรบกวนให้ทุกตัวแอปพลิเคชั่นหลุดออก',
  'settings.connectorsClearFinalBody': 'คุณจะไม่สามารถทำอะไรกลับมาได้ จนกว่าจะใส่และเชื่อมเครื่องมือต่างๆ ใหม่',
  'settings.connectorsClearFinalConfirm': 'ลบคีย์และเลิกแอป',
  'settings.connectorsClearArming': 'สักแป๊บดึงเวลาตั้งเตรียมรับ…',
  'settings.connectorsClearCancel': 'กดแบบยกเลิกไป',
  'settings.connectorsSaveKey': 'อัดลงบันทึกชุดคีย์เลย',
  'settings.connectorsSaveKeyTitle': 'ดึงโอนความของคีย์ที่ได้รับกลับมาให้ที่ส่วนระบบเครื่องส่วน Local Daemon ต่อเลย',
  'settings.connectorsKeySaving': 'เก็บรักษาที่ส่วนข้อมูล…',
  'settings.connectorsKeySaved': 'บันทึกแล้ว ✓',
  'settings.connectorsKeyError': 'ไม่สามารถบันทึกได้ ลองตรวจสอบตัว Daemon ให้ดี',
  'settings.connectorsHelpSaved': 'รหัสเก็บอยู่ในเครื่องเรียบร้อย นำรหัสใหม่ใส่ได้ตลอด หรือเอาออกด้วยปุ่มล้างข้อมูล',
  'settings.connectorsHelpUnsaved': 'ผลต่างของการแก้ที่คงไม่ทันบันทึก — กดที่คำบันทึกคีย์มาทำให้เป็นบันทึกเข้าเอาในของระบบไว้เพื่อให้เปิดตรงข้อมูลหน้าได้ดูความพร้อมในแถบเครื่องมือ',
  'settings.connectorsHelpEmpty': 'ต้องเอาคีย์ลงก่อนจึงใช้เป็นตัวระบบเพิ่ม ข้อมูลอยู่ที่แอป และเครื่องของคุณเท่านั้น',
  'settings.connectorsLoadingSavedKey': 'ตรวจสอบตามส่วนที่จะเจอความตั้งการในส่วนการใช้บันทึกคีย์ตรงที่มาของ Local Daemon…',
  'settings.autosaveSaving': 'บันทึก…',
  'settings.autosaveSaved': 'บันทึกของข้อมูลสำเร็จ',
  'settings.autosaveError': 'เซฟข้อมูลไม่ได้ คาดว่า Daemon ขาดสัญญาณ',
  'settings.libraryToggleLabel': 'สลับโหมด',
  'settings.memory': 'หน่วยความจำ',
  'settings.memoryHint': 'ข้อเท็จจริงและบริบทที่บันทึกไว้สำหรับการแชทในอนาคต',
  'assetLibrary.title': 'Asset Library',
  'assetLibrary.subtitle': 'Cross-project reusable images, docs, and design assets',
  'assetLibrary.navHint': 'Reusable assets across projects',
  'assetLibrary.searchPlaceholder': 'Search assets...',
  'assetLibrary.filterKind': 'Filter by kind',
  'assetLibrary.kindAll': 'All kinds',
  'assetLibrary.empty': 'No assets yet. Add one below to reuse it across projects.',
  'assetLibrary.count': '{count} assets',
  'assetLibrary.upload': 'Add to library',
  'assetLibrary.namePlaceholder': 'Asset name (e.g. brand-logo.png)',
  'assetLibrary.bodyPlaceholder': 'Paste text content or SVG/HTML source...',
  'assetLibrary.createRequired': 'Name and content are required.',
  'assetLibrary.createFailed': 'Could not add the asset.',
  'assetLibrary.created': 'Asset added to the library.',
  'assetLibrary.duplicateReused': 'Identical content already indexed - reused existing asset.',
  'assetLibrary.deleteFailed': 'Could not delete the asset.',
  'assetLibrary.deleted': 'Asset removed from the library.',
  'assetLibrary.noProject': 'Open a project to insert an asset.',
  'assetLibrary.insertFailed': 'Could not insert the asset into the project.',
  'assetLibrary.inserted': 'Inserted as {path}',
  'assetLibrary.useInProject': 'Use in project',
  'assetLibrary.loadFailed': 'Could not load the asset library.',
  'assetLibrary.previewViaApi': 'Preview is available via the safe /api/library/:id/preview path.',
  'assetLibrary.pickerTitle': 'Insert from Asset Library',
  'assetLibrary.clipperTitle': 'Browser Clipper',
  'assetLibrary.clipperHint': 'Load the MV3 extension from clipper/ (chrome://extensions → Load unpacked). Pairing is optional — zero-config ingest works on loopback.',
  'assetLibrary.clipperPair': 'Generate pairing code',
  'assetLibrary.clipperCode': 'Pairing code: {code}',
  'assetLibrary.clipperPaired': 'Extension paired ({count})',
  'assetLibrary.clipperUnpaired': 'No extension paired yet',
  'assetLibrary.clipperPairFailed': 'Could not start pairing.',
  'assetLibrary.editAsPage': 'Edit as page',
  'assetLibrary.editAsPageFailed': 'Could not open this capture as a page.',
  'assetLibrary.editAsPageOk': 'Opened project {projectId}',
  'settings.customInstructionsTitle': 'กฎทั่วโลก',
  'settings.customInstructionsHint': 'คำสั่งตายตัวที่ Gini Studio ควรปฏิบัติตามในทุกการสนทนา บันทึกข้อเท็จจริง การตั้งค่า และบริบทของโปรเจกต์ไว้เป็นความทรงจำ',
  'settings.customInstructionsPlaceholder': 'เช่น "ใช้ TypeScript เสมอ เลือกใช้ functional component กระชับคำตอบให้สั้น"',
  'settings.memoryDescription': 'ควบคุมว่าจะนำข้อเท็จจริง การตั้งค่า และบริบทของโปรเจกต์ที่บันทึกไว้มาใช้ซ้ำในการสนทนาครั้งต่อไปหรือไม่',
  'settings.memoryEnabled': 'เปิดใช้งาน',
  'settings.memoryDisabled': 'ปิดใช้งาน',
  'settings.memoryEnableLabel': 'เปิดใช้การแทรกความทรงจำ',
  'settings.memoryDisabledBanner': 'ความทรงจำกำลังปิดอยู่ ข้อเท็จจริงที่มีอยู่ยังถูกเก็บไว้ในดิสก์ แต่จะไม่ถูกนำมารวมในการสนทนาใหม่ และการสนทนารอบใหม่จะไม่ดึงข้อมูลใหม่ออกมา',
  'settings.memoryNew': 'ความทรงจำใหม่',
  'settings.memoryEdit': 'แก้ไข',
  'settings.memoryDelete': 'ลบ',
  'settings.memoryPreview': 'ดูตัวอย่าง',
  'settings.memoryEmpty': 'ยังไม่มีความทรงจำ',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'ฉันชอบโหมดมืด',
  'settings.memoryName': 'เช่น การตั้งค่า UI',
  'settings.memoryDesc': 'หนึ่งประโยค — ความทรงจำนี้เกี่ยวกับอะไร?',
  'settings.memoryBody': '- กฎข้อแรก\n- กฎข้อสอง\n\nเหตุผล: เหตุผลเพิ่มเติม (ไม่บังคับ)\nเมื่อใดจึงนำมาใช้: ขอบเขตเพิ่มเติม (ไม่บังคับ)',
  'settings.memoryBodyHint': 'ใส่กฎเป็นรายการก่อน จากนั้นจึงเพิ่มบรรทัด เหตุผล และ เมื่อใดจึงนำมาใช้ (ไม่บังคับ) รองรับ Markdown หรือคลิกตัวอย่างเริ่มต้นด้านบนเพื่อโหลดตัวอย่างที่ใช้งานได้',
  'settings.memoryStartersLabel': 'ต้องการจุดเริ่มต้นใช่ไหม? คลิกเพื่อกรอกแบบฟอร์ม:',
  'settings.memoryStarterUserName': 'บทบาทของฉัน',
  'settings.memoryStarterUserDesc': 'ฉันเป็นวิศวกร frontend ที่ทำงานกับเครื่องมือออกแบบ SaaS',
  'settings.memoryStarterUserBody': '- บทบาท: วิศวกร frontend อาวุโส\n- สแตก: React, TypeScript, Vite\n- โดเมน: เครื่องมือดีไซน์ / การทำงานร่วมกัน\n- เขตเวลา: GMT+8 (Asia/Shanghai)\n\nเมื่อใดที่จะใช้: แชทใดก็ได้ — ยกตัวอย่างโดยอิงกับเว็บ frontend',
  'settings.memoryStarterFeedbackName': 'การตั้งค่า UI',
  'settings.memoryStarterFeedbackDesc': 'โหมดมืด ตัวอักษรเนื้อหาขนาดใหญ่ ความหนาแน่นของข้อมูลต่ำ',
  'settings.memoryStarterFeedbackBody': '- ธีม: เข้มเป็นค่าเริ่มต้น\n- ข้อความเนื้อหา: ≥ 18px\n- ความหนาแน่นของข้อมูล: เน้นพื้นที่ว่าง มีรายการต่อหน้าจอน้อยลง\n\nเหตุผล: ลดอาการล้าของดวงตาระหว่างการใช้งานนาน ๆ\nเมื่อใดที่จะใช้: ทุกครั้งที่คุณสร้าง UI หน้าเว็บ หรือสไลด์',
  'settings.memoryStarterProjectName': 'โปรเจกต์ปัจจุบัน',
  'settings.memoryStarterProjectDesc': 'Gini Studio v0.5 — โปรแกรมแก้ไขดีไซน์ที่ขับเคลื่อนด้วยแชท',
  'settings.memoryStarterProjectBody': '- เป้าหมาย: ส่งมอบเอดิเตอร์แบบขับเคลื่อนด้วยแชตในไตรมาสนี้\n- ลำดับความสำคัญ: การเรนเดอร์แบบสตรีม, มัลติโมดัลในเครื่อง, ทำงานออฟไลน์เป็นหลัก\n- Stack: Next.js 16, Express daemon, SQLite\n\nเมื่อใดจึงนำมาใช้: ในการสนทนาใดก็ตามที่เกี่ยวกับโปรเจกต์นี้',
  'settings.memorySaveHint': 'ไม่ได้บันทึกอัตโนมัติ — คลิก สร้าง / บันทึก เพื่อปรับใช้',
  'settings.memoryIndexSaveHint': 'การแก้ไขดัชนีไม่ได้บันทึกอัตโนมัติ — คลิก บันทึกดัชนี เพื่อปรับใช้',
  'settings.memoryIndexUnsaved': 'การเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
  'settings.memoryFlashCreated': '✓ สร้างความทรงจำแล้ว',
  'settings.memoryFlashSaved': '✓ บันทึกความทรงจำแล้ว',
  'settings.memoryFlashDeleted': '✓ ลบความทรงจำแล้ว',
  'settings.memoryFlashIndexSaved': '✓ บันทึกดัชนีแล้ว',
  'settings.memoryFlashPathCopied': '✓ คัดลอกเส้นทางแล้ว',
  'settings.memoryNameLabel': 'ชื่อเรื่อง',
  'settings.memoryTypeLabel': 'ประเภท',
  'settings.memoryDescLabel': 'คำอธิบาย',
  'settings.memoryBodyLabel': 'เนื้อหา',
  'settings.memoryTypeUser': 'ผู้ใช้',
  'settings.memoryTypeFeedback': 'ข้อเสนอแนะ',
  'settings.memoryTypeProject': 'โปรเจกต์',
  'settings.memoryTypeReference': 'การอ้างอิง',
  'settings.memoryIndex': 'MEMORY.md (ดัชนี)',
  'settings.memoryIndexSave': 'บันทึกดัชนี',
  'settings.memoryIndexReset': 'รีเซ็ต',
  'settings.memoryToastChanged': 'อัปเดตความทรงจำแล้ว',
  'settings.memoryToastClickHint': 'ดู',
  'settings.memoryAll': 'ทั้งหมด',
  'settings.memoryExtractions': 'ประวัติการดึงข้อมูล',
  'settings.memoryExtractionsHint': 'Regex ทำงานก่อน LLM ทำงานเบื้องหลัง',
  'settings.memoryExtractionsEmpty': 'ยังไม่มีการดึงข้อมูล การสนทนารอบถัดไปจะเติมข้อมูลลงในรายการนี้',
  'settings.memoryExtractionsRefresh': 'รีเฟรช',
  'settings.memoryExtractionsRefreshing': 'กำลังรีเฟรช…',
  'settings.memoryExtractionPhaseRunning': 'กำลังทำงาน…',
  'settings.memoryExtractionPhaseSuccess': 'สำเร็จ',
  'settings.memoryExtractionPhaseSkipped': 'ข้ามแล้ว',
  'settings.memoryExtractionPhaseFailed': 'ล้มเหลว',
  'settings.memoryExtractionSkipNoProvider': 'ยังไม่ได้ตั้งค่า API key สำหรับการดึงความทรงจำด้วย LLM',
  'settings.memoryExtractionSkipDisabled': 'ความทรงจำถูกปิดใช้งาน',
  'settings.memoryExtractionSkipEmpty': 'ข้อความผู้ใช้ว่างเปล่า — ไม่มีอะไรให้ดึงข้อมูล',
  'settings.memoryExtractionSkipNoMatch': 'ไม่มีรูปแบบ regex ที่ตรงกับการสนทนารอบนี้',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'การตั้งค่าสื่อ',
  'settings.memoryExtractionProviderOverride': 'การตั้งค่าความทรงจำ',
  'settings.memoryExtractionProposed': 'ที่เสนอ',
  'settings.memoryExtractionWritten': 'เขียนแล้ว',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'ลบ',
  'settings.memoryExtractionsClear': 'ล้าง',
  'settings.memoryExtractionsClearTitle': 'ล้างประวัติการดึงข้อมูลทั้งหมด',
  'settings.memoryExtractionsClearConfirm': 'ล้างประวัติการดึงข้อมูลทั้งหมดหรือไม่? การกระทำนี้ไม่สามารถย้อนกลับได้',
  'settings.memoryNoProviderBannerTitle': 'การดึงความทรงจำด้วย LLM ไม่ได้ทำงานอยู่',
  'settings.memoryNoProviderBannerBody': 'ไม่พบ API key สำหรับตัวดึงความทรงจำ เพิ่ม OpenAI key ภายใต้ Media providers หรือตั้งค่า ANTHROPIC_API_KEY / OPENAI_API_KEY ในสภาพแวดล้อม เพื่อเปิดใช้การดึงข้อมูลที่ขับเคลื่อนด้วย LLM การดึงข้อมูลแบบฮิวริสติกด้วย regex ยังคงทำงานอยู่',
  'settings.libraryInstall': 'ติดตั้ง',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'พาธในเครื่อง',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'ติดตั้ง',
  'settings.libraryUninstall': 'ถอนการติดตั้ง',
  'settings.libraryBuiltIn': 'มีในตัว',
  'settings.libraryInstalled': 'ติดตั้งแล้ว',
  'settings.orbit.eyebrow': 'ระบบออโตเมชัน',
  'settings.orbit.title': 'วงโคจร (Orbit)',
  'settings.orbit.navHint': 'รวบรวมเหตุการณ์ในรอบวัน',
  'settings.orbit.lede': 'เก็บสรุปของแอปทั้งหมดมาบันทึกและโชว์ได้เลย',
  'settings.orbit.statusOnTitle': 'งานตารางประจำวันเดินเครื่องแล้ว',
  'settings.orbit.statusOffTitle': 'งานตารางประจำวันถูกปิด',
  'settings.orbit.statusActive': 'กำลังใช้',
  'settings.orbit.statusOff': 'ปิด',
  'settings.orbit.runTitle': 'กดใช้งาน และไปหน้าสรุปได้เลย',
  'settings.orbit.running': 'กำลังดึงสรุป…',
  'settings.orbit.runOpen': 'สั่งทำงานทันที',
  'settings.orbit.dailySummaryTitle': 'รายวันสรุปยอด',
  'settings.orbit.dailySummarySub': 'ใช้เวลาเพียง 1 หนในวัน ที่ทำหน้าที่',
  'settings.orbit.on': 'เปิด',
  'settings.orbit.off': 'ปิด',
  'settings.orbit.runTimeTitle': 'จองเวลาสรุปยอด',
  'settings.orbit.runTimeSub': '08:00 ใช้ตามเกณฑ์ปกติ หรือนำมาบันทึกเป็นค่าหลักสำหรับของในเครื่อง',
  'settings.orbit.runTimeAria': 'ตัวสรุปกิจกรรมใน Orbit ประจำวัน',
  'settings.orbit.nextRun': 'สรุปผลครั้งใหม่',
  'settings.orbit.nextRunScheduledAfterSave': 'รอเปิดตามตาราง (หลังการบันทึก)',
  'settings.orbit.schedule': 'นัดเวลา',
  'settings.orbit.pausedManualOnly': 'หยุดพักอยู่ (รันจากการกดเท่านั้น)',
  'settings.orbit.templateTitle': 'รูปแบบข้อความอธิบาย',
  'settings.orbit.templateMissing': 'เทมเพลต {id} ไม่ได้ติดตั้งไว้',
  'settings.orbit.templateMissingOption': '{id} (ยังหายไป)',
  'settings.orbit.templateMissingInstall': 'ใช้งานสกิลของ Orbit เพื่อกำหนดรูปแบบสรุปยอดข้อความได้ดั่งใจ',
  'settings.orbit.templateMissingPickAnother': 'เปลี่ยนการใช้ตัวแทนใหม่ตรงรายการ',
  'settings.orbit.templateResetTitle': 'รีเซ็ตสู่ {id}',
  'settings.orbit.templateReset': 'รีเซ็ต',
  'settings.orbit.templateHelp': 'ใช้คำสั่งตรงเข้าหาเพื่อความตรงไปตรงมา — เทมเพลตตัวนี้พร้อมเข้าสร้างผลในทุกตัววงโคจรให้ดี',
  'settings.orbit.templateAria': 'คำสั่งควบคุม Orbit',
  'settings.orbit.templatesLoading': 'กำลังโหลดรายการ…',
  'settings.orbit.templatesOptgroup': 'แบบฟอร์มการวิเคราะห์',
  'settings.orbit.lastRun': 'ครั้งท้ายสุด',
  'settings.orbit.triggerManual': 'จัดการสั่งรันเอง',
  'settings.orbit.triggerScheduled': 'จองไว้แล้ว',
  'settings.orbit.meterAria': 'ทั้งหมด {checked}, เข้าที่สำเร็จ {succeeded}, ยกเลิก {skipped}, ล้ม {failed}',
  'settings.orbit.countChecked': 'ที่รับงานไป',
  'settings.orbit.countSucceeded': 'เสร็จตามเป้า',
  'settings.orbit.countSkipped': 'โดนข้ามไป',
  'settings.orbit.countFailed': 'ไม่ลุล่วง',
  'settings.orbit.runError': 'หาที่รวมงานไม่ได้ โปรดเตรียมทั้งการเชื่อมต่อ และเครื่องมือ',
  'settings.orbit.gateAriaLabel': 'ระบบเรียกความพร้อม',
  'settings.orbit.gateEyebrow': 'ใช้ตัวเสริม',
  'settings.orbit.gateTitle': 'ต่อข้อมูลแอปทั้งหมดเพื่อใช้ Orbit',
  'settings.orbit.gateBody': 'Orbit ไว้ให้เป็นพื้นที่สำหรับดูทุกงาน ลองเปิดต่อเชื่อมอย่างน้อย 1 ก่อนเพื่อให้มันโชว์สถิติของทุกสิ่ง',
  'settings.orbit.gateBodyNoKey': 'Orbit ต้องการต่อเข้าส่วน Composio โปรดดึง API ลงเข้าหาก่อนจึงสามารถเข้าเครื่องได้',
  'settings.orbit.gateAction': 'ตั้งค่าแอปใหม่',
  'settings.orbit.gateActionNoKey': 'ติดตั้ง Composio',
  'settings.orbit.gateLoading': 'กำลังตรวจสิ่งที่คุณตั้งไว้…',
  'settings.orbit.controlsLockedBadge': 'มีล็อกเอาไว้',
  'settings.orbit.controlsLockedHint': 'ต้องการตัวแอปเพิ่มเพื่อใช้งานให้ครบกับกำหนดแบบฟอร์มได้',
  'settings.orbit.artifactKickerLive': 'ตัวจำลอง Live artifact',
  'settings.orbit.artifactKickerLegacy': 'เนื้อหาสรุปล่าสุด',
  'settings.orbit.artifactTitle': 'ความเคลื่อนไหวล่าสุดผ่าน Orbit',
  'settings.orbit.artifactMetaLive': 'เป็นแบบระบบอัปเดตเอง จากแอปพลิเคชั่นที่เชื่อมอยู่',
  'settings.orbit.artifactMetaLegacy': 'ข้อมูลยังไม่มีการเข้าทำตัว Live artifact — หากอยากให้ระบบขึ้น กรุณากด Orbit ทำงานไป',
  'settings.orbit.copyMarkdownTitle': 'จำลองสำเนาสถิติ',
  'settings.orbit.copied': 'เตรียมพร้อมจำลอง',
  'settings.orbit.copy': 'ก็อปปี้',
  'settings.orbit.openArtifact': 'เรียกไฟล์ระบบโชว์ความเคลื่อนไหว',
  'settings.orbit.sourceMarkdown': 'Markdown ของหน้าความเคลื่อนไหว',
  'notify.successTitle': 'งานลุล่วงแล้ว',
  'notify.failureTitle': 'ข้อมูลการงานล้มเหลว',
  'notify.successBody': 'แชทตอบบทสนทนาเรียบร้อย',
  'notify.failureBody': 'หน้าที่ทำผิดพลาด',
  'updater.available': 'มีอัปเดตใหม่',
  'updater.availableBody': 'Gini Studio {version} พร้อมใช้งานแล้ว จะดาวน์โหลดก่อนเปิดตัวติดตั้ง',
  'updater.checking': 'กำลังตรวจสอบอัปเดต',
  'updater.download': 'ดาวน์โหลดอัปเดต',
  'updater.downloading': 'กำลังดาวน์โหลดอัปเดต',
  'updater.downloadingPercent': 'กำลังดาวน์โหลดอัปเดต {percent}%',
  'updater.done': 'เสร็จสิ้น',
  'updater.failed': 'อัปเดตไม่สำเร็จ',
  'updater.installerOpenBody': 'ตัวติดตั้งเปิดอยู่ Gini Studio กำลังออกเพื่อให้คุณอัปเดตให้เสร็จ',
  'updater.installerOpened': 'เปิดตัวติดตั้งแล้ว',
  'updater.later': 'ภายหลัง',
  'updater.openFailedFallback': 'ไม่สามารถเปิดตัวติดตั้งได้',
  'updater.openInstaller': 'ติดตั้งอัปเดต',
  'updater.opening': 'กำลังเปิดตัวติดตั้ง...',
  'updater.quitButton': 'ออกจาก Gini Studio',
  'updater.quitFailedBody': 'ตัวติดตั้งเปิดอยู่ แต่ไม่สามารถออกจาก Gini Studio ได้ โปรดออกจาก Gini Studio ก่อนแทนที่แอป',
  'updater.quitFailedTitle': 'ออกไม่ได้',
  'updater.quitting': 'กำลังออก...',
  'updater.ready': 'อัปเดตพร้อมแล้ว',
  'updater.readyGeneric': 'เวอร์ชันใหม่พร้อมแล้ว Gini Studio จะปิดและเปิดตัวติดตั้ง',
  'updater.readyVersion': 'Gini Studio {version} พร้อมแล้ว Gini Studio จะปิดและเปิดตัวติดตั้ง',
  'updater.upToDate': 'คุณใช้เวอร์ชันล่าสุดอยู่แล้ว',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'โมเดลหน่วยความจำ',
  'settings.memoryModelInlineSameAsChat': 'เหมือนกับแชท',
  'settings.memoryModelInlineSameAsChatWithModel': 'เหมือนกับแชท ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'เหมือนกับแชท ({provider})',
  'settings.memoryModelInlineHintCli': 'ไม่บังคับ ใช้ Local CLI ที่เลือกไว้เมื่อรองรับ เลือกโมเดลเฉพาะเมื่อต้องการแทนที่ค่าเริ่มต้นเท่านั้น',
  'settings.memoryModelInlineHintCliConstrained': 'ไม่บังคับ ใช้ Local CLI ที่เลือกไว้เมื่อรองรับ {provider} เป็นเพียงตระกูลผู้ให้บริการสำรองเท่านั้น',
  'settings.memoryModelInlineHintByok': 'ไม่บังคับ ใช้ API key ของแชทคุณซ้ำ — เลือกโมเดลที่ถูกกว่าเพื่อประหยัดค่าใช้จ่าย',
  'settings.memoryModelInlineHintByokNeutral': 'หน่วยความจำใช้โมเดลแยกจากแชท ค่าเริ่มต้นคือโมเดลแชทของคุณ',
  'settings.memoryModelInlineFlashSaved': 'บันทึกแล้ว',
  'settings.memoryModelInlineFlashCleared': 'ล้างแล้ว',
  'diagnostics.exportTitle': 'ส่งออกข้อมูลวินิจฉัย',
  'diagnostics.exportButton': 'ส่งออกข้อมูลวินิจฉัย',
  'diagnostics.exportHint': 'รวบรวมบันทึกแอปล่าสุดและข้อมูลเครื่องไว้ในไฟล์ zip ที่คุณสามารถแชร์กับทีมได้',
  'diagnostics.exporting': 'กำลังส่งออก…',
  'diagnostics.exportSuccess': 'บันทึกข้อมูลวินิจฉัยไปยัง {path} แล้ว',
  'diagnostics.exportFailed': 'ไม่สามารถส่งออกข้อมูลวินิจฉัยได้: {message}',
  'automations.eyebrow': 'เซสชัน Agent ตามกำหนดเวลา',
  'automations.title': 'ระบบอัตโนมัติ',
  'automations.lede': 'วางแผนการสนทนาที่เกิดขึ้นซ้ำสำหรับงานโปรเจกต์ สรุป Orbit และอาร์ติแฟกต์แบบสด',
  'automations.summaryAria': 'สรุประบบอัตโนมัติ',
  'automations.metricActive': 'ใช้งานอยู่',
  'automations.metricPaused': 'หยุดชั่วคราว',
  'automations.metricTemplates': 'เทมเพลต',
  'automations.newAutomation': 'ระบบอัตโนมัติใหม่',
  'automations.yourAutomations': 'ระบบอัตโนมัติของคุณ',
  'automations.loading': 'กำลังโหลด',
  'automations.emptyTitle': 'ยังไม่มีระบบอัตโนมัติ',
  'automations.emptyBody': 'สร้างจากเทมเพลตหรือเริ่มจากกำหนดการเปล่า',
  'automations.targetNewEachRun': 'โปรเจกต์ใหม่ทุกครั้งที่รัน',
  'automations.lastRun': 'รันล่าสุด {time}',
  'automations.openResult': 'เปิดผลลัพธ์',
  'automations.run': 'รัน',
  'automations.runNowTitle': 'รันทันทีและเปิดการสนทนา',
  'automations.history': 'ประวัติ',
  'automations.hideHistory': 'ซ่อนประวัติ',
  'automations.edit': 'แก้ไข',
  'automations.pause': 'หยุดชั่วคราว',
  'automations.resume': 'ดำเนินการต่อ',
  'automations.deleteAria': 'ลบระบบอัตโนมัติ',
  'automations.deleteTitle': 'ลบระบบอัตโนมัตินี้',
  'automations.deleteConfirm': 'ลบระบบอัตโนมัตินี้หรือไม่? การรันที่ผ่านมาและโปรเจกต์ของมันจะยังคงอยู่',
  'automations.proposalsTitle': 'ข้อเสนอการพัฒนา',
  'automations.proposalsSub': 'ตรวจสอบผลลัพธ์ของระบบอัตโนมัติก่อนที่จะเปลี่ยนแปลงหน่วยความจำ ทักษะ หรือ design systems',
  'automations.proposalsPending': 'รอดำเนินการ {n} รายการ',
  'automations.apply': 'นำไปใช้',
  'automations.reject': 'ปฏิเสธ',
  'automations.proposalsDismissReason': 'ปิดใน Automations',
  'automations.templatesTitle': 'เทมเพลต',
  'automations.templatesSub': 'Orbit และอาร์ติแฟกต์แบบสดเป็นเทมเพลตภายในโฟลว์ระบบอัตโนมัติเดียวกัน',
  'automations.templatesCount': '{filtered} จาก {total}',
  'automations.templateFiltersAria': 'ตัวกรองเทมเพลต',
  'automations.templatesEmptyTitle': 'ยังไม่มีเทมเพลตในหมวดหมู่นี้',
  'automations.templatesEmptyBody': 'ลองตัวกรองอื่น หรือเริ่มจากระบบอัตโนมัติเปล่า',
  'automations.useTemplate': 'ใช้เทมเพลต',
  'automations.runHistoryLoading': 'กำลังโหลดประวัติการรัน...',
  'automations.runHistoryEmpty': 'ยังไม่มีการรัน',
  'automations.runHistoryTitle': 'ประวัติการรัน',
  'automations.runHistoryLatest': 'ล่าสุด 10 รายการ',
  'automations.crystallize': 'ตกผลึก',
  'automations.crystallizing': 'กำลังตกผลึก',
  'automations.crystallizeTitle': 'ร่างข้อเสนอทักษะและหน่วยความจำจากการรันนี้',
  'automations.openConversation': 'เปิดการสนทนา',
  'automations.runHistoryAria': 'ประวัติการรันระบบอัตโนมัติ',
  'automations.proposalsAria': 'ข้อเสนอการพัฒนาระบบอัตโนมัติ',
  'automations.templatesAria': 'เทมเพลตระบบอัตโนมัติ',
  'automations.runInProgress': 'กำลังดำเนินการ',
  'automations.scheduleStatusPaused': 'หยุดชั่วคราว',
  'automations.nextRunManualOnly': 'รันด้วยตนเองเท่านั้น',
  'automations.nextRunScheduled': 'ตามกำหนดการ',
  'automations.nextRunAt': 'ครั้งถัดไป {time}',
  'automations.statusSucceeded': 'สำเร็จ',
  'automations.statusFailed': 'ล้มเหลว',
  'automations.statusRunning': 'กำลังรัน',
  'automations.statusQueued': 'อยู่ในคิว',
  'automations.statusCanceled': 'ยกเลิกแล้ว',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'อาร์ติแฟกต์แบบสด',
  'automations.kindAutomation': 'ระบบอัตโนมัติ',
  'automations.proposalTargetMemory': 'หน่วยความจำ',
  'automations.proposalTargetDesignSystem': 'ระบบดีไซน์',
  'automations.proposalTargetSkill': 'ทักษะ',
  'automations.proposalTargetTemplate': 'เทมเพลตระบบอัตโนมัติ',
  'automations.proposalActionCreate': 'สร้าง',
  'automations.proposalActionUpdate': 'อัปเดต',
  'automations.proposalActionMerge': 'ผสาน',
  'automations.proposalActionMove': 'ย้าย',
  'automations.proposalActionDelete': 'ลบ',
  'automations.proposalActionPromote': 'เลื่อนระดับ',
  'automations.filterAll': 'ทั้งหมด',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'อาร์ติแฟกต์แบบสด',
  'automations.filterMemory': 'หน่วยความจำ',
  'automations.filterDesignSystems': 'ระบบดีไซน์',
  'automations.filterSkills': 'ทักษะ',
  'automations.filterConnectors': 'ตัวเชื่อมต่อ',
  'automations.filterCompression': 'การบีบอัด',
  'automations.filterRelease': 'การปล่อยเวอร์ชัน',
  'automations.filterQuality': 'คุณภาพ',
  'automations.tpl.memoryRefresh.title': 'รีเฟรชหน่วยความจำโปรเจกต์จากงานล่าสุด',
  'automations.tpl.memoryRefresh.desc': 'เปลี่ยนการตัดสินใจ ความชอบ และฟีดแบ็กที่เกิดขึ้นซ้ำให้เป็นการอัปเดตหน่วยความจำที่นำกลับมาใช้ใหม่ได้',
  'automations.tpl.designSystemRefresh.title': 'อัปเดต design systems จากอาร์ติแฟกต์ที่ส่งมอบแล้ว',
  'automations.tpl.designSystemRefresh.desc': 'ค้นหา token คอมโพเนนต์ และกฎที่นำกลับมาใช้ใหม่ได้จากงานออกแบบล่าสุด',
  'automations.tpl.liveArtifactRegistry.title': 'ตรวจสอบอาร์ติแฟกต์แบบสดและรีเฟรชเวอร์ชันที่ล้าสมัย',
  'automations.tpl.liveArtifactRegistry.desc': 'ทำให้แดชบอร์ด รายงาน และตัวอย่างที่คงอยู่ตลอดเป็นปัจจุบันแทนการสร้างซ้ำ',
  'automations.tpl.orbitDashboard.title': 'สร้างแดชบอร์ดกิจกรรมตัวเชื่อมต่อ',
  'automations.tpl.orbitDashboard.desc': 'รวบรวมตัวเชื่อมต่อที่เลือกไว้เป็นแดชบอร์ดแบบสดสไตล์ Orbit',
  'automations.tpl.releaseNotes.title': 'ร่างบันทึกการปล่อยเวอร์ชันจากงานออกแบบที่ส่งมอบแล้ว',
  'automations.tpl.releaseNotes.desc': 'เชื่อมโยง PR ที่ผสานแล้ว อาร์ติแฟกต์ และการเปลี่ยนแปลงที่เกี่ยวกับผลิตภัณฑ์เข้าเป็นบันทึกการปล่อยเวอร์ชัน',
  'automations.tpl.qualityRegressionWatch.title': 'เฝ้าระวังการถดถอยของการออกแบบและการพัฒนา',
  'automations.tpl.qualityRegressionWatch.desc': 'เปรียบเทียบการเปลี่ยนแปลงล่าสุดกับเกณฑ์มาตรฐาน เทรซ และข้อมูลอ้างอิงที่ยอมรับแล้ว',
  'automations.tpl.orbitDaily.title': 'สรุปตัวเชื่อมต่อรายวัน',
  'automations.tpl.orbitDaily.desc': 'รีเฟรชสรุปกิจกรรมตัวเชื่อมต่อตามกำหนดเวลา',
  'automations.tpl.liveStatusBoard.title': 'ทำให้อาร์ติแฟกต์สถานะแบบสดเป็นปัจจุบันอยู่เสมอ',
  'automations.tpl.liveStatusBoard.desc': 'อัปเดตอาร์ติแฟกต์ที่คงอยู่เพียงชิ้นเดียวแทนการสร้างรายงานใหม่ทุกครั้งที่รัน',
  'dsManager.areaAria': 'พื้นที่ design systems',
  'dsManager.tabDesignSystem': 'ระบบดีไซน์',
  'dsManager.tabTemplate': 'เทมเพลต',
  'dsManager.sourceAria': 'แหล่งที่มาของ design system',
  'dsManager.templateSourceAria': 'แหล่งที่มาของเทมเพลต',
  'dsManager.yourSystems': 'ระบบของคุณ',
  'dsManager.officialPresets': 'พรีเซ็ตอย่างเป็นทางการ',
  'dsManager.enterprise': 'องค์กร',
  'dsManager.yourTemplates': 'เทมเพลตของคุณ',
  'dsManager.yourSystemsAria': 'design systems ของคุณ',
  'dsManager.eyebrowDesignSystems': 'ระบบดีไซน์',
  'dsManager.yourSystemsHeading': 'ระบบของคุณ',
  'dsManager.filterAria': 'กรอง design systems',
  'dsManager.filterAll': 'ทั้งหมด',
  'dsManager.filterPublished': 'เผยแพร่แล้ว',
  'dsManager.filterDraft': 'ฉบับร่าง',
  'dsManager.createTitle': 'สร้าง design system ใหม่',
  'dsManager.createBody': 'สอน Gini Studio ให้รู้จักแบรนด์ ผลิตภัณฑ์ โค้ด แอสเซ็ต และข้อมูลอ้างอิงการออกแบบของคุณ',
  'dsManager.createAction': 'สร้าง',
  'dsManager.emptyMine': 'ยังไม่มี design systems สร้างจากบริบทผลิตภัณฑ์จริง ตรวจสอบฉบับร่าง แล้วเผยแพร่เพื่อใช้กับโปรเจกต์ในอนาคต',
  'dsManager.badgeDefault': 'ค่าเริ่มต้น',
  'dsManager.rowMetaUpdated': 'คุณ · อัปเดต {date}',
  'dsManager.edit': 'แก้ไข',
  'dsManager.makeDefault': 'ตั้งเป็นค่าเริ่มต้น',
  'dsManager.statusPublished': 'เผยแพร่แล้ว',
  'dsManager.statusDraft': 'ฉบับร่าง',
  'dsManager.openSystemAria': 'เปิด {title}',
  'dsManager.deleteSystemAria': 'ลบ {title}',
  'dsManager.presetsAria': 'พรีเซ็ต design system อย่างเป็นทางการ',
  'dsManager.eyebrowLibrary': 'ไลบรารี',
  'dsManager.eyebrowTemplates': 'เทมเพลต',
  'dsManager.yourTemplatesAria': 'เทมเพลตของคุณ',
  'dsManager.emptyTemplates': 'ยังไม่มีเทมเพลต สร้างจากโปรเจกต์ที่สร้างขึ้นใดก็ได้ผ่าน Share เมื่อเปิดใช้งานการเผยแพร่เทมเพลตแล้ว',
  'dsManager.templateDescFallback': 'สร้างจากโปรเจกต์',
  'dsManager.comingSoonBadge': 'เร็วๆ นี้',
  'dsManager.enterpriseDsTitle': 'Design systems สำหรับองค์กร',
  'dsManager.enterpriseDsBody': 'design systems ที่แชร์ในทีมและไลบรารีแบรนด์ที่มีการกำกับดูแลกำลังจะมาเร็วๆ นี้',
  'dsManager.enterpriseTplTitle': 'เทมเพลตสำหรับองค์กร',
  'dsManager.enterpriseTplBody': 'เทมเพลตที่ทีมอนุมัติและการเผยแพร่ทั่วทั้งองค์กรกำลังจะมาเร็วๆ นี้',
  'settings.instructionsTitle': 'คำสั่ง / กฎ',
  'settings.instructionsSubtitle': 'พฤติกรรมตายตัวที่ผู้ช่วยควรปฏิบัติตาม',
  'settings.instructionsNavSub': 'พฤติกรรมตายตัวของผู้ช่วย',
  'settings.customInstructionsDesc': 'คำสั่งตายตัวที่ Gini Studio ปฏิบัติตามในทุกการแชต สิ่งเหล่านี้ไม่ใช่หน่วยความจำที่บันทึกไว้ ใช้ Memory สำหรับข้อเท็จจริง ความชอบ และบริบทของโปรเจกต์',
  'mcpClient.forwardedToLabel': 'ส่งต่อไปยัง:',
  'mcpClient.notForwardedToLabel': 'ไม่ได้ส่งต่อไปยัง:',
  'mcpClient.forwardedAcpNote': 'ACP adapter ที่ทำเครื่องหมาย stdio จะรับเฉพาะเซิร์ฟเวอร์ MCP แบบ stdio จากรายการนี้เท่านั้น รายการ HTTP และ SSE จะถูกตัดทิ้งในเวลาที่ spawn',
  'mcpClient.notForwardedNote': 'สำหรับ Agent เหล่านั้น ให้กำหนดค่าเซิร์ฟเวอร์ MCP ในไฟล์ config ของ Agent เอง (เช่น ~/.codex/config.toml, ~/.gemini/settings.json) เซิร์ฟเวอร์ด้านล่างจะไม่ถูกใช้งานที่นั่นโดยไม่มีการแจ้งเตือน',

  'welcome.title': 'เข้าสู่ระบบ Gini Studio',
  'welcome.subtitle': 'Use your GINI Studio account to continue.',
  'welcome.registerInviteHint': 'Create an account with an invited email address. Ask an admin for an invite if you do not have one yet.',
  'welcome.emailLabel': 'อีเมล',
  'welcome.passwordLabel': 'รหัสผ่าน',
  'welcome.nameLabel': 'ชื่อ (ไม่บังคับ)',
  'welcome.loginButton': 'เข้าสู่ระบบ',
  'welcome.loginPending': 'กำลังเข้าสู่ระบบ…',
  'welcome.registerButton': 'Create account',
  'welcome.registerPending': 'Creating account...',
  'welcome.toggleToRegister': 'Don\'t have an account? Create one',
  'welcome.toggleToLogin': 'มีบัญชีอยู่แล้ว? เข้าสู่ระบบ',
  'welcome.loadingSession': 'กำลังตรวจสอบเซสชันของคุณ…',
  'authCallback.connecting': 'กำลังเชื่อมต่อบัญชี Gini ของคุณ…',
  'authCallback.failed': 'ไม่สามารถเข้าสู่ระบบให้เสร็จสมบูรณ์ได้',
  'authCallback.retryHint': 'ลองเปิด Gini Studio จาก Gini Code อีกครั้ง หรือเข้าสู่ระบบด้านล่าง',
  'giniCodeBridge.title': 'GINI Code',
  'giniCodeBridge.sendTo': 'Send to GINI Code',
  'giniCodeBridge.copyFor': 'Copy for GINI Code',
  'giniCodeBridge.importResult': 'Import GINI Code Result',
  'giniCodeBridge.cancel': 'ยกเลิก',
  'giniCodeBridge.approveImport': 'Approve import',
  'giniCodeBridge.sendHint': 'Prepare a structured task for GINI Code. Copy it, paste into GINI Code, then import the result back here. Nothing is applied until you approve.',
  'giniCodeBridge.requestLabel': 'Implementation request',
  'giniCodeBridge.requestPlaceholder': 'Describe what GINI Code should implement...',
  'giniCodeBridge.prepareTask': 'Prepare task',
  'giniCodeBridge.copied': 'Copied for GINI Code.',
  'giniCodeBridge.copyFailed': 'Could not copy to clipboard.',
  'giniCodeBridge.importHint': 'Paste the GINI Code result. Studio validates and previews first - files are not changed until you approve.',
  'giniCodeBridge.pasteLabel': 'GINI Code result',
  'giniCodeBridge.pastePlaceholder': 'Paste the gini-code-result/v1 JSON here...',
  'giniCodeBridge.preview': 'Validate & preview',
  'giniCodeBridge.diffsSummary': 'Operations: {creates} create, {updates} update, {deletes} delete',
  'giniCodeBridge.verification': 'Verification: {status}',
  'giniCodeBridge.passed': 'passed',
  'giniCodeBridge.failed': 'failed',
  'giniCodeBridge.applied': 'Imported {count} file operation(s).',
  'giniCodeBridge.unexpectedMutation': 'Preview claimed a mutation; refusing to continue.',
  'giniCodeBridge.defaultRequest': 'Implement the requested changes for {project}.',
  'giniCodeBridge.working': 'Working...',
  'giniCodeBridge.taskReady': 'Task ready to copy',
  'giniCodeBridge.pasteRequired': 'Paste a result before importing',
  'giniCodeBridge.previewReady': 'Preview ready - approve to apply',
  'giniCodeBridge.previewHeading': 'Validation preview',
  'giniCodeBridge.warnings': 'Warnings',
  'giniCodeBridge.applySuccess': 'Applied {count} file operation(s)',
  'giniHandoff.opening': 'กำลังเปิดการส่งต่อ…',
  'giniHandoff.unavailableTitle': 'ลิงก์ส่งต่อนี้ใช้ไม่ได้อีกแล้ว',
  'giniHandoff.errorTitle': 'เกิดข้อผิดพลาด',
  'giniHandoff.expiredBody': 'ลิงก์ส่งต่อนี้หมดอายุแล้ว เริ่มการส่งต่อใหม่จาก Gini Code',
  'giniHandoff.consumedBody': 'ลิงก์ส่งต่อนี้ถูกใช้ไปแล้ว เริ่มการส่งต่อใหม่จาก Gini Code',
  'giniHandoff.unknownBody': 'เราไม่รู้จักลิงก์ส่งต่อนี้',
  'giniHandoff.openStudio': 'เปิด Gini Studio',
  'giniHandoff.projectCreated': 'สร้างโปรเจกต์จากบรีฟ Gini Code ของคุณแล้ว',
  'giniHandoff.projectOpened': 'เปิดโปรเจกต์ Gini Studio ที่มีอยู่ของคุณแล้ว',
  'giniHandoff.briefHeading': 'บรีฟที่นำเข้า',
  'giniHandoff.sourceConversation': 'บทสนทนาต้นทาง',
  'giniHandoff.sourceWorkspace': 'พื้นที่ทำงานต้นทาง',
  'giniHandoff.projectHeading': 'โปรเจกต์ Studio',
  'giniHandoff.openProject': 'เปิดใน Studio',
  'giniHandoff.generationHeading': 'การสร้าง',
  'giniHandoff.startHostedGeneration': 'เริ่มการสร้างแบบโฮสต์',
  'giniHandoff.artifactsHeading': 'อาร์ทิแฟกต์',
  'giniHandoff.artifactsEmpty': 'ยังไม่มีเวอร์ชันอาร์ทิแฟกต์',
  'giniHandoff.refresh': 'รีเฟรช',
  'giniHandoff.checking': 'กำลังตรวจหาเวอร์ชันใหม่…',
  'giniHandoff.lastChecked': 'ตรวจล่าสุด',
  'giniHandoff.pollingStopped': 'หยุดตรวจแล้ว ใช้รีเฟรชเพื่อลองใหม่',
  'giniHandoff.preview': 'ดูตัวอย่าง',
  'giniHandoff.referenceExpired': 'การอ้างอิงตัวอย่างนี้หมดอายุแล้ว ขอใหม่อีกครั้ง',
  'giniHandoff.returnHeading': 'กลับไปที่ Gini Code',
  'giniHandoff.returnReady': 'อาร์ทิแฟกต์พร้อมสำหรับ Gini Code',
  'giniHandoff.returnAction': 'เตรียมการอ้างอิงสำหรับส่งกลับ',
  'giniHandoff.copyReference': 'คัดลอกการอ้างอิง',
  'giniHandoff.copied': 'คัดลอกแล้ว',
  'giniHandoff.accountHeading': 'บัญชี Gini',
  'giniHandoff.accountEmail': 'บัญชี',
  'giniHandoff.accountTenant': 'เทแนนต์',
  'giniHandoff.accountPlan': 'แพ็กเกจ',
  'giniHandoff.platformManaged': 'การสร้างจัดการโดยแพลตฟอร์ม Gini การเลือกโมเดลและผู้ให้บริการเป็นของเซิร์ฟเวอร์',
};
